/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  CancelToken
} from 'axios'

export interface ICloudNuggetClient {
  /**
   * Get the basic Cloud-Nugget profile
   * @return Success
   */
  ping(): Promise<CloudNuggetProfile>
  /**
   * Get the docs
   * @return Success
   */
  getReadme(): Promise<string>
  /**
   * Get the changes
   * @return Success
   */
  getChangelog(): Promise<string>
  /**
   * Get the API routes
   * @param version Version number of the API version
   * @return Success
   */
  getOpenApi(version: string): Promise<any>
}

export class CloudNuggetClient implements ICloudNuggetClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * Get the basic Cloud-Nugget profile
   * @return Success
   */
  ping(cancelToken?: CancelToken | undefined): Promise<CloudNuggetProfile> {
    let url_ = this.baseUrl + '/s1/cloud-nugget/ping'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPing(_response)
      })
  }

  protected processPing(response: AxiosResponse): Promise<CloudNuggetProfile> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = CloudNuggetProfile.fromJS(resultData200)
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<CloudNuggetProfile>(<any>null)
  }

  /**
   * Get the docs
   * @return Success
   */
  getReadme(cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/s1/cloud-nugget/readme'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/markdown'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetReadme(_response)
      })
  }

  protected processGetReadme(response: AxiosResponse): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * Get the changes
   * @return Success
   */
  getChangelog(cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/s1/cloud-nugget/changelog'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/markdown'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetChangelog(_response)
      })
  }

  protected processGetChangelog(response: AxiosResponse): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * Get the API routes
   * @param version Version number of the API version
   * @return Success
   */
  getOpenApi(
    version: string,
    cancelToken?: CancelToken | undefined
  ): Promise<any> {
    let url_ = this.baseUrl + '/s1/cloud-nugget/openapi/{version}'
    if (version === undefined || version === null)
      throw new Error("The parameter 'version' must be defined.")
    url_ = url_.replace('{version}', encodeURIComponent('' + version))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetOpenApi(_response)
      })
  }

  protected processGetOpenApi(response: AxiosResponse): Promise<any> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<any>(<any>null)
  }
}

export interface IAccountClient {
  /**
   * @return Success
   */
  login(body: Login): Promise<void>
  /**
   * @return Success
   */
  login2FA(body: Login2FA): Promise<void>
  /**
   * @return Success
   */
  logout(): Promise<void>
  /**
   * @param username (optional)
   * @param password (optional)
   * @return Success
   */
  get2FAByLoginInfo(
    username: string | null | undefined,
    password: string | null | undefined
  ): Promise<AuthenticatorConnectInfo>
  /**
   * @return Success
   */
  enable2FAByLoginInfo(body: Enable2FA): Promise<Enable2FAResponse>
  /**
   * @return Success
   */
  disableCurrent2FA(): Promise<void>
  /**
   * @return Success
   */
  changeCurrentPassword(body: ChangeCurrentPassword): Promise<void>
  /**
   * @return Success
   */
  getCurrentUser(): Promise<UserInfo>
}

export class AccountClient implements IAccountClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  login(body: Login, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/account/login'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processLogin(_response)
      })
  }

  protected processLogin(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  login2FA(
    body: Login2FA,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/account/login2fa'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processLogin2FA(_response)
      })
  }

  protected processLogin2FA(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  logout(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/account/logout'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processLogout(_response)
      })
  }

  protected processLogout(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @param username (optional)
   * @param password (optional)
   * @return Success
   */
  get2FAByLoginInfo(
    username: string | null | undefined,
    password: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AuthenticatorConnectInfo> {
    let url_ = this.baseUrl + '/account/get2fa?'
    if (username !== undefined && username !== null)
      url_ += 'username=' + encodeURIComponent('' + username) + '&'
    if (password !== undefined && password !== null)
      url_ += 'password=' + encodeURIComponent('' + password) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet2FAByLoginInfo(_response)
      })
  }

  protected processGet2FAByLoginInfo(
    response: AxiosResponse
  ): Promise<AuthenticatorConnectInfo> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = AuthenticatorConnectInfo.fromJS(resultData200)
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<AuthenticatorConnectInfo>(<any>null)
  }

  /**
   * @return Success
   */
  enable2FAByLoginInfo(
    body: Enable2FA,
    cancelToken?: CancelToken | undefined
  ): Promise<Enable2FAResponse> {
    let url_ = this.baseUrl + '/account/enable2fa'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processEnable2FAByLoginInfo(_response)
      })
  }

  protected processEnable2FAByLoginInfo(
    response: AxiosResponse
  ): Promise<Enable2FAResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = Enable2FAResponse.fromJS(resultData200)
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<Enable2FAResponse>(<any>null)
  }

  /**
   * @return Success
   */
  disableCurrent2FA(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/account/disable2fa'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDisableCurrent2FA(_response)
      })
  }

  protected processDisableCurrent2FA(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  changeCurrentPassword(
    body: ChangeCurrentPassword,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/account/change-password'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeCurrentPassword(_response)
      })
  }

  protected processChangeCurrentPassword(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  getCurrentUser(cancelToken?: CancelToken | undefined): Promise<UserInfo> {
    let url_ = this.baseUrl + '/account/userinfo'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCurrentUser(_response)
      })
  }

  protected processGetCurrentUser(response: AxiosResponse): Promise<UserInfo> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = UserInfo.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<UserInfo>(<any>null)
  }
}

export interface IAuthTestClient {
  /**
   * @return Success
   */
  anonymous(): Promise<string>
  /**
   * @return Success
   */
  isAuthenticated(): Promise<string>
  /**
   * @return Success
   */
  authorizedWithPermission(): Promise<string>
}

export class AuthTestClient implements IAuthTestClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  anonymous(cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/auth-test/Anonymous'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAnonymous(_response)
      })
  }

  protected processAnonymous(response: AxiosResponse): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * @return Success
   */
  isAuthenticated(cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/auth-test/IsAuthenticated'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processIsAuthenticated(_response)
      })
  }

  protected processIsAuthenticated(response: AxiosResponse): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * @return Success
   */
  authorizedWithPermission(
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/auth-test/AuthorizedWithPermission'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAuthorizedWithPermission(_response)
      })
  }

  protected processAuthorizedWithPermission(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }
}

export interface IAvailableTypesClient {
  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getAvailableTypes(
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfAvailableTypeDto>
}

export class AvailableTypesClient implements IAvailableTypesClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getAvailableTypes(
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfAvailableTypeDto> {
    let url_ = this.baseUrl + '/available-types?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAvailableTypes(_response)
      })
  }

  protected processGetAvailableTypes(
    response: AxiosResponse
  ): Promise<PagedOfAvailableTypeDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfAvailableTypeDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfAvailableTypeDto>(<any>null)
  }
}

export interface ICaseDocumentLogsClient {
  /**
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getLogEntries(
    caseId: string,
    page: number | undefined,
    pagesize: number | undefined
  ): Promise<PagedOfDocumentLogEntryDto>
}

export class CaseDocumentLogsClient implements ICaseDocumentLogsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getLogEntries(
    caseId: string,
    page: number | undefined,
    pagesize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfDocumentLogEntryDto> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/logs?'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pagesize === null)
      throw new Error("The parameter 'pagesize' cannot be null.")
    else if (pagesize !== undefined)
      url_ += 'pagesize=' + encodeURIComponent('' + pagesize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLogEntries(_response)
      })
  }

  protected processGetLogEntries(
    response: AxiosResponse
  ): Promise<PagedOfDocumentLogEntryDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfDocumentLogEntryDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfDocumentLogEntryDto>(<any>null)
  }
}

export interface ICaseDocumentMailsClient {
  /**
   * @return Success
   */
  sendDocumentsMail(caseId: string, body: SendDocumentsMail): Promise<void>
  /**
   * @return Success
   */
  sendPersonalizedDocumentsMail(
    caseId: string,
    body: DocumentMailing
  ): Promise<void>
}

export class CaseDocumentMailsClient implements ICaseDocumentMailsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  sendDocumentsMail(
    caseId: string,
    body: SendDocumentsMail,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/cases/{caseId}/document-mails'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSendDocumentsMail(_response)
      })
  }

  protected processSendDocumentsMail(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  sendPersonalizedDocumentsMail(
    caseId: string,
    body: DocumentMailing,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/cases/{caseId}/document-mails/personalized'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSendPersonalizedDocumentsMail(_response)
      })
  }

  protected processSendPersonalizedDocumentsMail(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }
}

export interface ICaseDocumentsClient {
  /**
   * @return Success
   */
  getDocuments(caseId: string): Promise<DocumentDto[]>
  /**
   * @return Success
   */
  getBasicDocuments(caseId: string): Promise<BasicDocumentDto[]>
  /**
   * @return Success
   */
  initializeDocument(
    caseId: string,
    body: DocumentSpecification
  ): Promise<DocumentDto>
  /**
   * @param documentId (optional)
   * @param file (optional)
   * @return Success
   */
  uploadDocument(
    caseId: string,
    documentId: string | undefined,
    file: FileParameter | null | undefined
  ): Promise<void>
  /**
   * @param files (optional)
   * @return Success
   */
  checkinDocuments(
    caseId: string,
    files: FileParameter[] | null | undefined
  ): Promise<void>
  /**
   * @return Success
   */
  checkoutDocument(caseId: string, documentId: string): Promise<FileResponse>
  /**
   * @return Success
   */
  checkoutDocuments(
    caseId: string,
    body: DocumentsRequestDto
  ): Promise<FileResponse>
  /**
   * @return Success
   */
  releaseCheckoutLock(caseId: string, documentId: string): Promise<void>
  /**
   * @return Success
   */
  getDocumentDetails(
    caseId: string,
    documentId: string
  ): Promise<DocumentDetailDto>
  /**
   * @return Success
   */
  setFolderAssociation(
    caseId: string,
    documentId: string,
    body: string[] | null
  ): Promise<void>
  /**
   * @param documentId (optional)
   * @return Success
   */
  copyLookupDocument(
    caseId: string,
    documentId: string | undefined
  ): Promise<DocumentDto>
  /**
   * @return Success
   */
  updateDocument(
    caseId: string,
    documentId: string,
    body: DocumentSpecification
  ): Promise<DocumentDto>
  /**
   * @return Success
   */
  deleteDocument(caseId: string, documentId: string): Promise<DocumentDto>
  /**
   * @return Success
   */
  downloadDocument(caseId: string, documentId: string): Promise<FileResponse>
  /**
   * @return Success
   */
  finalizeDocument(caseId: string, documentId: string): Promise<DocumentDto>
  /**
   * @return Success
   */
  downloadPreview(caseId: string, documentId: string): Promise<FileResponse>
  /**
   * @return Success
   */
  downloadVersion(
    caseId: string,
    documentId: string,
    versionNr: number
  ): Promise<FileResponse>
  /**
   * @return Success
   */
  downloadMultipleDocuments(
    caseId: string,
    body: string[] | null
  ): Promise<FileResponse>
  /**
   * @return Success
   */
  downloadDocumentsZip(
    caseId: string,
    body: DocumentsRequestDto
  ): Promise<FileResponse>
  /**
   * @param templateId (optional)
   * @return Success
   */
  createDocumentFromTemplate(
    caseId: string,
    templateId: string | undefined,
    body: DocumentSpecification
  ): Promise<TemplateMergeResponse>
  /**
   * @param templateId (optional)
   * @param layoutId (optional)
   * @return Success
   */
  createDocumentFromTemplateWithLayout(
    caseId: string,
    templateId: string | undefined,
    layoutId: string | undefined,
    body: DocumentSpecification
  ): Promise<TemplateMergeResponse>
  /**
   * @param marker (optional)
   * @return Success
   */
  markDocuments(
    caseId: string,
    marker: string | null | undefined,
    body: string[] | null
  ): Promise<void>
}

export class CaseDocumentsClient implements ICaseDocumentsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  getDocuments(
    caseId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto[]> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDocuments(_response)
      })
  }

  protected processGetDocuments(
    response: AxiosResponse
  ): Promise<DocumentDto[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(DocumentDto.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto[]>(<any>null)
  }

  /**
   * @return Success
   */
  getBasicDocuments(
    caseId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<BasicDocumentDto[]> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/basic'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBasicDocuments(_response)
      })
  }

  protected processGetBasicDocuments(
    response: AxiosResponse
  ): Promise<BasicDocumentDto[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(BasicDocumentDto.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<BasicDocumentDto[]>(<any>null)
  }

  /**
   * @return Success
   */
  initializeDocument(
    caseId: string,
    body: DocumentSpecification,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/upload/init'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processInitializeDocument(_response)
      })
  }

  protected processInitializeDocument(
    response: AxiosResponse
  ): Promise<DocumentDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = DocumentDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto>(<any>null)
  }

  /**
   * @param documentId (optional)
   * @param file (optional)
   * @return Success
   */
  uploadDocument(
    caseId: string,
    documentId: string | undefined,
    file: FileParameter | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/upload?'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (documentId === null)
      throw new Error("The parameter 'documentId' cannot be null.")
    else if (documentId !== undefined)
      url_ += 'documentId=' + encodeURIComponent('' + documentId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = new FormData()
    if (file !== null && file !== undefined)
      content_.append('file', file.data, file.fileName ? file.fileName : 'file')

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUploadDocument(_response)
      })
  }

  protected processUploadDocument(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @param files (optional)
   * @return Success
   */
  checkinDocuments(
    caseId: string,
    files: FileParameter[] | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/checkin'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = new FormData()
    if (files !== null && files !== undefined)
      files.forEach(item_ =>
        content_.append(
          'files',
          item_.data,
          item_.fileName ? item_.fileName : 'files'
        )
      )

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCheckinDocuments(_response)
      })
  }

  protected processCheckinDocuments(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  checkoutDocument(
    caseId: string,
    documentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/{documentId}/checkout'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      responseType: 'blob',
      method: 'PUT',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCheckoutDocument(_response)
      })
  }

  protected processCheckoutDocument(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined
      const fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      })
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FileResponse>(<any>null)
  }

  /**
   * @return Success
   */
  checkoutDocuments(
    caseId: string,
    body: DocumentsRequestDto,
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/checkout/multiple'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      responseType: 'blob',
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCheckoutDocuments(_response)
      })
  }

  protected processCheckoutDocuments(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined
      const fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      })
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FileResponse>(<any>null)
  }

  /**
   * @return Success
   */
  releaseCheckoutLock(
    caseId: string,
    documentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      '/cases/{caseId}/documents/{documentId}/release-checkout-lock'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'PUT',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processReleaseCheckoutLock(_response)
      })
  }

  protected processReleaseCheckoutLock(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  getDocumentDetails(
    caseId: string,
    documentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDetailDto> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/{documentId}/details'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDocumentDetails(_response)
      })
  }

  protected processGetDocumentDetails(
    response: AxiosResponse
  ): Promise<DocumentDetailDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = DocumentDetailDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDetailDto>(<any>null)
  }

  /**
   * @return Success
   */
  setFolderAssociation(
    caseId: string,
    documentId: string,
    body: string[] | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/{documentId}/folders'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSetFolderAssociation(_response)
      })
  }

  protected processSetFolderAssociation(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @param documentId (optional)
   * @return Success
   */
  copyLookupDocument(
    caseId: string,
    documentId: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/copy?'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (documentId === null)
      throw new Error("The parameter 'documentId' cannot be null.")
    else if (documentId !== undefined)
      url_ += 'documentId=' + encodeURIComponent('' + documentId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCopyLookupDocument(_response)
      })
  }

  protected processCopyLookupDocument(
    response: AxiosResponse
  ): Promise<DocumentDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = DocumentDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto>(<any>null)
  }

  /**
   * @return Success
   */
  updateDocument(
    caseId: string,
    documentId: string,
    body: DocumentSpecification,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/{documentId}'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateDocument(_response)
      })
  }

  protected processUpdateDocument(
    response: AxiosResponse
  ): Promise<DocumentDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = DocumentDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto>(<any>null)
  }

  /**
   * @return Success
   */
  deleteDocument(
    caseId: string,
    documentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/{documentId}'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteDocument(_response)
      })
  }

  protected processDeleteDocument(
    response: AxiosResponse
  ): Promise<DocumentDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = DocumentDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto>(<any>null)
  }

  /**
   * @return Success
   */
  downloadDocument(
    caseId: string,
    documentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/{documentId}'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      responseType: 'blob',
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadDocument(_response)
      })
  }

  protected processDownloadDocument(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined
      const fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      })
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FileResponse>(<any>null)
  }

  /**
   * @return Success
   */
  finalizeDocument(
    caseId: string,
    documentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/{documentId}/finalize'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'PUT',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processFinalizeDocument(_response)
      })
  }

  protected processFinalizeDocument(
    response: AxiosResponse
  ): Promise<DocumentDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = DocumentDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto>(<any>null)
  }

  /**
   * @return Success
   */
  downloadPreview(
    caseId: string,
    documentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/{documentId}/preview'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      responseType: 'blob',
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadPreview(_response)
      })
  }

  protected processDownloadPreview(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined
      const fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      })
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FileResponse>(<any>null)
  }

  /**
   * @return Success
   */
  downloadVersion(
    caseId: string,
    documentId: string,
    versionNr: number,
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ =
      this.baseUrl + '/cases/{caseId}/documents/{documentId}/{versionNr}'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    if (versionNr === undefined || versionNr === null)
      throw new Error("The parameter 'versionNr' must be defined.")
    url_ = url_.replace('{versionNr}', encodeURIComponent('' + versionNr))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      responseType: 'blob',
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadVersion(_response)
      })
  }

  protected processDownloadVersion(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined
      const fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      })
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FileResponse>(<any>null)
  }

  /**
   * @return Success
   */
  downloadMultipleDocuments(
    caseId: string,
    body: string[] | null,
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/multiple'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      responseType: 'blob',
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadMultipleDocuments(_response)
      })
  }

  protected processDownloadMultipleDocuments(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined
      const fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      })
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FileResponse>(<any>null)
  }

  /**
   * @return Success
   */
  downloadDocumentsZip(
    caseId: string,
    body: DocumentsRequestDto,
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/download'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      responseType: 'blob',
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadDocumentsZip(_response)
      })
  }

  protected processDownloadDocumentsZip(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined
      const fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      })
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FileResponse>(<any>null)
  }

  /**
   * @param templateId (optional)
   * @return Success
   */
  createDocumentFromTemplate(
    caseId: string,
    templateId: string | undefined,
    body: DocumentSpecification,
    cancelToken?: CancelToken | undefined
  ): Promise<TemplateMergeResponse> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/create-from-template?'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (templateId === null)
      throw new Error("The parameter 'templateId' cannot be null.")
    else if (templateId !== undefined)
      url_ += 'templateId=' + encodeURIComponent('' + templateId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateDocumentFromTemplate(_response)
      })
  }

  protected processCreateDocumentFromTemplate(
    response: AxiosResponse
  ): Promise<TemplateMergeResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = TemplateMergeResponse.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<TemplateMergeResponse>(<any>null)
  }

  /**
   * @param templateId (optional)
   * @param layoutId (optional)
   * @return Success
   */
  createDocumentFromTemplateWithLayout(
    caseId: string,
    templateId: string | undefined,
    layoutId: string | undefined,
    body: DocumentSpecification,
    cancelToken?: CancelToken | undefined
  ): Promise<TemplateMergeResponse> {
    let url_ =
      this.baseUrl +
      '/cases/{caseId}/documents/create-from-template-with-layout?'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (templateId === null)
      throw new Error("The parameter 'templateId' cannot be null.")
    else if (templateId !== undefined)
      url_ += 'templateId=' + encodeURIComponent('' + templateId) + '&'
    if (layoutId === null)
      throw new Error("The parameter 'layoutId' cannot be null.")
    else if (layoutId !== undefined)
      url_ += 'layoutId=' + encodeURIComponent('' + layoutId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateDocumentFromTemplateWithLayout(_response)
      })
  }

  protected processCreateDocumentFromTemplateWithLayout(
    response: AxiosResponse
  ): Promise<TemplateMergeResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = TemplateMergeResponse.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<TemplateMergeResponse>(<any>null)
  }

  /**
   * @param marker (optional)
   * @return Success
   */
  markDocuments(
    caseId: string,
    marker: string | null | undefined,
    body: string[] | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/cases/{caseId}/documents/mark?'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (marker !== undefined && marker !== null)
      url_ += 'marker=' + encodeURIComponent('' + marker) + '&'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMarkDocuments(_response)
      })
  }

  protected processMarkDocuments(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }
}

export interface ICaseFoldersClient {
  /**
   * @return Success
   */
  allFoldersForCase(caseId: string): Promise<CaseFolderDto[]>
  /**
   * @return Success
   */
  allDocumentsForFolder(
    caseId: string,
    folderId: string
  ): Promise<DocumentDto[]>
  /**
   * @return Success
   */
  allDocumentsForFolders(
    caseId: string,
    body: string[] | null
  ): Promise<DocumentDto[]>
  /**
   * @return Success
   */
  getDocumentOrdering(
    caseId: string,
    folderId: string
  ): Promise<DocumentOrdering[]>
  /**
   * @return Success
   */
  changeDocumentOrdering(
    caseId: string,
    folderId: string,
    body: DocumentOrderingChange[] | null
  ): Promise<DocumentOrdering[]>
}

export class CaseFoldersClient implements ICaseFoldersClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  allFoldersForCase(
    caseId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<CaseFolderDto[]> {
    let url_ = this.baseUrl + '/cases/{caseId}/folders'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAllFoldersForCase(_response)
      })
  }

  protected processAllFoldersForCase(
    response: AxiosResponse
  ): Promise<CaseFolderDto[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(CaseFolderDto.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<CaseFolderDto[]>(<any>null)
  }

  /**
   * @return Success
   */
  allDocumentsForFolder(
    caseId: string,
    folderId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto[]> {
    let url_ = this.baseUrl + '/cases/{caseId}/folders/{folderId}/documents'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (folderId === undefined || folderId === null)
      throw new Error("The parameter 'folderId' must be defined.")
    url_ = url_.replace('{folderId}', encodeURIComponent('' + folderId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAllDocumentsForFolder(_response)
      })
  }

  protected processAllDocumentsForFolder(
    response: AxiosResponse
  ): Promise<DocumentDto[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(DocumentDto.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto[]>(<any>null)
  }

  /**
   * @return Success
   */
  allDocumentsForFolders(
    caseId: string,
    body: string[] | null,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto[]> {
    let url_ = this.baseUrl + '/cases/{caseId}/folders/documents'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAllDocumentsForFolders(_response)
      })
  }

  protected processAllDocumentsForFolders(
    response: AxiosResponse
  ): Promise<DocumentDto[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(DocumentDto.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto[]>(<any>null)
  }

  /**
   * @return Success
   */
  getDocumentOrdering(
    caseId: string,
    folderId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentOrdering[]> {
    let url_ =
      this.baseUrl + '/cases/{caseId}/folders/{folderId}/document-ordering'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (folderId === undefined || folderId === null)
      throw new Error("The parameter 'folderId' must be defined.")
    url_ = url_.replace('{folderId}', encodeURIComponent('' + folderId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDocumentOrdering(_response)
      })
  }

  protected processGetDocumentOrdering(
    response: AxiosResponse
  ): Promise<DocumentOrdering[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(DocumentOrdering.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentOrdering[]>(<any>null)
  }

  /**
   * @return Success
   */
  changeDocumentOrdering(
    caseId: string,
    folderId: string,
    body: DocumentOrderingChange[] | null,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentOrdering[]> {
    let url_ =
      this.baseUrl + '/cases/{caseId}/folders/{folderId}/document-ordering'
    if (caseId === undefined || caseId === null)
      throw new Error("The parameter 'caseId' must be defined.")
    url_ = url_.replace('{caseId}', encodeURIComponent('' + caseId))
    if (folderId === undefined || folderId === null)
      throw new Error("The parameter 'folderId' must be defined.")
    url_ = url_.replace('{folderId}', encodeURIComponent('' + folderId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeDocumentOrdering(_response)
      })
  }

  protected processChangeDocumentOrdering(
    response: AxiosResponse
  ): Promise<DocumentOrdering[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(DocumentOrdering.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentOrdering[]>(<any>null)
  }
}

export interface ICaseInterviewSharesClient {
  /**
   * @return Success
   */
  createShare(body: CaseInterviewShareDto): Promise<CaseInterviewShareDto>
  /**
   * @return Success
   */
  getSharedInterviewData(shareId: string): Promise<string>
  /**
   * @return Success
   */
  completeSharedInterview(shareId: string, body: string | null): Promise<void>
  /**
   * @return Success
   */
  getShare(shareId: string): Promise<CaseInterviewShareDto>
}

export class CaseInterviewSharesClient implements ICaseInterviewSharesClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  createShare(
    body: CaseInterviewShareDto,
    cancelToken?: CancelToken | undefined
  ): Promise<CaseInterviewShareDto> {
    let url_ = this.baseUrl + '/CaseInterviewShares'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateShare(_response)
      })
  }

  protected processCreateShare(
    response: AxiosResponse
  ): Promise<CaseInterviewShareDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = CaseInterviewShareDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<CaseInterviewShareDto>(<any>null)
  }

  /**
   * @return Success
   */
  getSharedInterviewData(
    shareId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/CaseInterviewShares/{shareId}/data'
    if (shareId === undefined || shareId === null)
      throw new Error("The parameter 'shareId' must be defined.")
    url_ = url_.replace('{shareId}', encodeURIComponent('' + shareId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSharedInterviewData(_response)
      })
  }

  protected processGetSharedInterviewData(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * @return Success
   */
  completeSharedInterview(
    shareId: string,
    body: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/CaseInterviewShares/{shareId}/complete'
    if (shareId === undefined || shareId === null)
      throw new Error("The parameter 'shareId' must be defined.")
    url_ = url_.replace('{shareId}', encodeURIComponent('' + shareId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCompleteSharedInterview(_response)
      })
  }

  protected processCompleteSharedInterview(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  getShare(
    shareId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<CaseInterviewShareDto> {
    let url_ = this.baseUrl + '/CaseInterviewShares/{shareId}'
    if (shareId === undefined || shareId === null)
      throw new Error("The parameter 'shareId' must be defined.")
    url_ = url_.replace('{shareId}', encodeURIComponent('' + shareId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetShare(_response)
      })
  }

  protected processGetShare(
    response: AxiosResponse
  ): Promise<CaseInterviewShareDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = CaseInterviewShareDto.fromJS(resultData200)
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<CaseInterviewShareDto>(<any>null)
  }
}

export interface ICasesClient {
  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getCases(
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfCaseDto>
  /**
   * @return Success
   */
  createCase(body: CaseDto): Promise<CaseDto>
  /**
   * @param lookupEntryId (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getCasesWithExistingLookupEntry(
    lookupEntryId: string | undefined,
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfCaseDto>
  /**
   * @return Success
   */
  getFilteredAndSortedCases(
    body: FilteredAndSortedDataRequest
  ): Promise<PagedOfFilteredAndSortedCase>
  /**
   * @return Success
   */
  searchCases(body: SimpleSearchCondition): Promise<string[]>
  /**
   * @return Success
   */
  getCase(id: string): Promise<CaseDto>
  /**
   * @return Success
   */
  updateCase(id: string, body: CaseDto): Promise<CaseDto>
  /**
   * @return Success
   */
  deleteCase(id: string): Promise<void>
  /**
   * @return Success
   */
  updateCaseMeta(id: string, body: CaseDto): Promise<void>
  /**
   * @return Success
   */
  updateCaseSchema(id: string, body: CaseDto): Promise<CaseDto>
  /**
   * @return Success
   */
  updateCasesFromLookupEntry(body: UpdateCasesFromLookupEntry): Promise<void>
  /**
   * @return Success
   */
  fillCasePropertiesFromLookupEntry(
    id: string,
    body: FillCasePropertiesFromLookupEntry
  ): Promise<string>
}

export class CasesClient implements ICasesClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getCases(
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfCaseDto> {
    let url_ = this.baseUrl + '/Cases?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCases(_response)
      })
  }

  protected processGetCases(response: AxiosResponse): Promise<PagedOfCaseDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfCaseDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfCaseDto>(<any>null)
  }

  /**
   * @return Success
   */
  createCase(
    body: CaseDto,
    cancelToken?: CancelToken | undefined
  ): Promise<CaseDto> {
    let url_ = this.baseUrl + '/Cases'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateCase(_response)
      })
  }

  protected processCreateCase(response: AxiosResponse): Promise<CaseDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = CaseDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<CaseDto>(<any>null)
  }

  /**
   * @param lookupEntryId (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getCasesWithExistingLookupEntry(
    lookupEntryId: string | undefined,
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfCaseDto> {
    let url_ = this.baseUrl + '/Cases/with-lookup-entry?'
    if (lookupEntryId === null)
      throw new Error("The parameter 'lookupEntryId' cannot be null.")
    else if (lookupEntryId !== undefined)
      url_ += 'lookupEntryId=' + encodeURIComponent('' + lookupEntryId) + '&'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCasesWithExistingLookupEntry(_response)
      })
  }

  protected processGetCasesWithExistingLookupEntry(
    response: AxiosResponse
  ): Promise<PagedOfCaseDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfCaseDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfCaseDto>(<any>null)
  }

  /**
   * @return Success
   */
  getFilteredAndSortedCases(
    body: FilteredAndSortedDataRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfFilteredAndSortedCase> {
    let url_ = this.baseUrl + '/Cases/filtered'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetFilteredAndSortedCases(_response)
      })
  }

  protected processGetFilteredAndSortedCases(
    response: AxiosResponse
  ): Promise<PagedOfFilteredAndSortedCase> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfFilteredAndSortedCase.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfFilteredAndSortedCase>(<any>null)
  }

  /**
   * @return Success
   */
  searchCases(
    body: SimpleSearchCondition,
    cancelToken?: CancelToken | undefined
  ): Promise<string[]> {
    let url_ = this.baseUrl + '/Cases/search'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearchCases(_response)
      })
  }

  protected processSearchCases(response: AxiosResponse): Promise<string[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200) result200!.push(item)
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string[]>(<any>null)
  }

  /**
   * @return Success
   */
  getCase(id: string, cancelToken?: CancelToken | undefined): Promise<CaseDto> {
    let url_ = this.baseUrl + '/Cases/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCase(_response)
      })
  }

  protected processGetCase(response: AxiosResponse): Promise<CaseDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = CaseDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<CaseDto>(<any>null)
  }

  /**
   * @return Success
   */
  updateCase(
    id: string,
    body: CaseDto,
    cancelToken?: CancelToken | undefined
  ): Promise<CaseDto> {
    let url_ = this.baseUrl + '/Cases/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateCase(_response)
      })
  }

  protected processUpdateCase(response: AxiosResponse): Promise<CaseDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = CaseDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<CaseDto>(<any>null)
  }

  /**
   * @return Success
   */
  deleteCase(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/Cases/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteCase(_response)
      })
  }

  protected processDeleteCase(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  updateCaseMeta(
    id: string,
    body: CaseDto,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/Cases/{id}/meta'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateCaseMeta(_response)
      })
  }

  protected processUpdateCaseMeta(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  updateCaseSchema(
    id: string,
    body: CaseDto,
    cancelToken?: CancelToken | undefined
  ): Promise<CaseDto> {
    let url_ = this.baseUrl + '/Cases/{id}/schema'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateCaseSchema(_response)
      })
  }

  protected processUpdateCaseSchema(response: AxiosResponse): Promise<CaseDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = CaseDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<CaseDto>(<any>null)
  }

  /**
   * @return Success
   */
  updateCasesFromLookupEntry(
    body: UpdateCasesFromLookupEntry,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/Cases/from-lookup-entry'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateCasesFromLookupEntry(_response)
      })
  }

  protected processUpdateCasesFromLookupEntry(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  fillCasePropertiesFromLookupEntry(
    id: string,
    body: FillCasePropertiesFromLookupEntry,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/Cases/{id}/from-lookup-entry'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processFillCasePropertiesFromLookupEntry(_response)
      })
  }

  protected processFillCasePropertiesFromLookupEntry(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }
}

export interface ICaseTypeFoldersClient {
  /**
   * @return Folder created successfully
   */
  createFolder(typeId: string | null, body: FolderDto): Promise<FolderDto>
  /**
   * @return Success
   */
  getFolders(typeId: string | null): Promise<FolderDto[]>
  /**
   * @return Success
   */
  updateFolder(typeId: string | null, body: FolderDto): Promise<FolderDto>
  /**
   * @return Folder deleted successfully
   */
  deleteFolder(typeId: string | null, folderId: string | null): Promise<void>
  /**
   * @return Success
   */
  setDefault(typeId: string | null, folderId: string | null): Promise<void>
}

export class CaseTypeFoldersClient implements ICaseTypeFoldersClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Folder created successfully
   */
  createFolder(
    typeId: string | null,
    body: FolderDto,
    cancelToken?: CancelToken | undefined
  ): Promise<FolderDto> {
    let url_ = this.baseUrl + '/casetypes/{typeId}/folders'
    if (typeId === undefined || typeId === null)
      throw new Error("The parameter 'typeId' must be defined.")
    url_ = url_.replace('{typeId}', encodeURIComponent('' + typeId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateFolder(_response)
      })
  }

  protected processCreateFolder(response: AxiosResponse): Promise<FolderDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data
      let result201: any = null
      let resultData201 = _responseText
      result201 = FolderDto.fromJS(resultData201)
      return result201
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FolderDto>(<any>null)
  }

  /**
   * @return Success
   */
  getFolders(
    typeId: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<FolderDto[]> {
    let url_ = this.baseUrl + '/casetypes/{typeId}/folders'
    if (typeId === undefined || typeId === null)
      throw new Error("The parameter 'typeId' must be defined.")
    url_ = url_.replace('{typeId}', encodeURIComponent('' + typeId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetFolders(_response)
      })
  }

  protected processGetFolders(response: AxiosResponse): Promise<FolderDto[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200) result200!.push(FolderDto.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FolderDto[]>(<any>null)
  }

  /**
   * @return Success
   */
  updateFolder(
    typeId: string | null,
    body: FolderDto,
    cancelToken?: CancelToken | undefined
  ): Promise<FolderDto> {
    let url_ = this.baseUrl + '/casetypes/{typeId}/folders'
    if (typeId === undefined || typeId === null)
      throw new Error("The parameter 'typeId' must be defined.")
    url_ = url_.replace('{typeId}', encodeURIComponent('' + typeId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateFolder(_response)
      })
  }

  protected processUpdateFolder(response: AxiosResponse): Promise<FolderDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = FolderDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FolderDto>(<any>null)
  }

  /**
   * @return Folder deleted successfully
   */
  deleteFolder(
    typeId: string | null,
    folderId: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/casetypes/{typeId}/folders/{folderId}'
    if (typeId === undefined || typeId === null)
      throw new Error("The parameter 'typeId' must be defined.")
    url_ = url_.replace('{typeId}', encodeURIComponent('' + typeId))
    if (folderId === undefined || folderId === null)
      throw new Error("The parameter 'folderId' must be defined.")
    url_ = url_.replace('{folderId}', encodeURIComponent('' + folderId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteFolder(_response)
      })
  }

  protected processDeleteFolder(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  setDefault(
    typeId: string | null,
    folderId: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/casetypes/{typeId}/folders/{folderId}/default'
    if (typeId === undefined || typeId === null)
      throw new Error("The parameter 'typeId' must be defined.")
    url_ = url_.replace('{typeId}', encodeURIComponent('' + typeId))
    if (folderId === undefined || folderId === null)
      throw new Error("The parameter 'folderId' must be defined.")
    url_ = url_.replace('{folderId}', encodeURIComponent('' + folderId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSetDefault(_response)
      })
  }

  protected processSetDefault(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }
}

export interface ICaseTypesClient {
  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getCaseTypes(
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfCaseTypeDto>
  /**
   * @return Success
   */
  createCaseType(body: CaseTypeDto): Promise<string>
  /**
   * @return Success
   */
  updateCaseType(body: CaseTypeDto): Promise<void>
  /**
   * @return Success
   */
  getCaseType(id: string): Promise<CaseTypeDto>
  /**
   * @return Success
   */
  deleteCaseType(id: string): Promise<void>
  /**
   * @param newName (optional)
   * @return Success
   */
  copyCaseType(id: string, newName: string | null | undefined): Promise<string>
  /**
   * @return Success
   */
  getFullyQualifiedCompoundTypes(
    id: string
  ): Promise<FullyQualifiedCompoundTypeDto[]>
}

export class CaseTypesClient implements ICaseTypesClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getCaseTypes(
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfCaseTypeDto> {
    let url_ = this.baseUrl + '/casetypes?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCaseTypes(_response)
      })
  }

  protected processGetCaseTypes(
    response: AxiosResponse
  ): Promise<PagedOfCaseTypeDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfCaseTypeDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfCaseTypeDto>(<any>null)
  }

  /**
   * @return Success
   */
  createCaseType(
    body: CaseTypeDto,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/casetypes'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateCaseType(_response)
      })
  }

  protected processCreateCaseType(response: AxiosResponse): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * @return Success
   */
  updateCaseType(
    body: CaseTypeDto,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/casetypes'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateCaseType(_response)
      })
  }

  protected processUpdateCaseType(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  getCaseType(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<CaseTypeDto> {
    let url_ = this.baseUrl + '/casetypes/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCaseType(_response)
      })
  }

  protected processGetCaseType(response: AxiosResponse): Promise<CaseTypeDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = CaseTypeDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<CaseTypeDto>(<any>null)
  }

  /**
   * @return Success
   */
  deleteCaseType(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/casetypes/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteCaseType(_response)
      })
  }

  protected processDeleteCaseType(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @param newName (optional)
   * @return Success
   */
  copyCaseType(
    id: string,
    newName: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/casetypes/{id}/copy?'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (newName !== undefined && newName !== null)
      url_ += 'newName=' + encodeURIComponent('' + newName) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCopyCaseType(_response)
      })
  }

  protected processCopyCaseType(response: AxiosResponse): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * @return Success
   */
  getFullyQualifiedCompoundTypes(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<FullyQualifiedCompoundTypeDto[]> {
    let url_ = this.baseUrl + '/casetypes/{id}/fq-compound-types'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetFullyQualifiedCompoundTypes(_response)
      })
  }

  protected processGetFullyQualifiedCompoundTypes(
    response: AxiosResponse
  ): Promise<FullyQualifiedCompoundTypeDto[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(FullyQualifiedCompoundTypeDto.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FullyQualifiedCompoundTypeDto[]>(<any>null)
  }
}

export interface ICaseWorkflowsClient {
  /**
   * @param caseId (optional)
   * @return Success
   */
  getCaseWorkflow(caseId: string | undefined): Promise<CaseWorkflowDto>
  /**
   * @return Success
   */
  activateWorkflow(id: string): Promise<void>
  /**
   * @return Success
   */
  cancelWorkflow(id: string): Promise<void>
}

export class CaseWorkflowsClient implements ICaseWorkflowsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param caseId (optional)
   * @return Success
   */
  getCaseWorkflow(
    caseId: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CaseWorkflowDto> {
    let url_ = this.baseUrl + '/CaseWorkflows?'
    if (caseId === null)
      throw new Error("The parameter 'caseId' cannot be null.")
    else if (caseId !== undefined)
      url_ += 'caseId=' + encodeURIComponent('' + caseId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCaseWorkflow(_response)
      })
  }

  protected processGetCaseWorkflow(
    response: AxiosResponse
  ): Promise<CaseWorkflowDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = CaseWorkflowDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<CaseWorkflowDto>(<any>null)
  }

  /**
   * @return Success
   */
  activateWorkflow(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/CaseWorkflows/{id}/activate'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processActivateWorkflow(_response)
      })
  }

  protected processActivateWorkflow(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  cancelWorkflow(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/CaseWorkflows/{id}/cancel'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCancelWorkflow(_response)
      })
  }

  protected processCancelWorkflow(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }
}

export interface ICaseWorkflowStepsClient {
  /**
   * @return Success
   */
  updateCaseWorkflowStep(body: CaseWorkflowStepDto): Promise<void>
}

export class CaseWorkflowStepsClient implements ICaseWorkflowStepsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  updateCaseWorkflowStep(
    body: CaseWorkflowStepDto,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/CaseWorkflowSteps'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateCaseWorkflowStep(_response)
      })
  }

  protected processUpdateCaseWorkflowStep(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }
}

export interface ICaseWorkflowTransitionsClient {
  /**
   * @param caseId (optional)
   * @return Success
   */
  getLogs(caseId: string | undefined): Promise<CaseWorkflowLogDto[]>
}

export class CaseWorkflowTransitionsClient
  implements ICaseWorkflowTransitionsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param caseId (optional)
   * @return Success
   */
  getLogs(
    caseId: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CaseWorkflowLogDto[]> {
    let url_ = this.baseUrl + '/CaseWorkflowTransitions?'
    if (caseId === null)
      throw new Error("The parameter 'caseId' cannot be null.")
    else if (caseId !== undefined)
      url_ += 'caseId=' + encodeURIComponent('' + caseId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLogs(_response)
      })
  }

  protected processGetLogs(
    response: AxiosResponse
  ): Promise<CaseWorkflowLogDto[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(CaseWorkflowLogDto.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<CaseWorkflowLogDto[]>(<any>null)
  }
}

export interface ICompoundTypesClient {
  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getCompoundTypes(
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfCompoundTypeDto>
  /**
   * @return Success
   */
  createCompoundType(body: CreateCompoundType): Promise<string>
  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getSharedCompoundTypes(
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfCompoundTypeDto>
  /**
   * @param caseTypeId (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getCaseTypeCompoundTypes(
    caseTypeId: string | undefined,
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfCompoundTypeDto>
  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getBasicDataCompoundTypes(
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfCompoundTypeDto>
  /**
   * @return Success
   */
  getCompoundType(id: string | null): Promise<CompoundTypeDto>
  /**
   * @return Success
   */
  updateCompoundType(id: string | null, body: UpdateCompoundType): Promise<void>
  /**
   * @return Success
   */
  deleteCompoundType(id: string | null): Promise<void>
  /**
   * @return Success
   */
  updateCompoundTypesOrder(body: CompoundTypeDto[] | null): Promise<void>
}

export class CompoundTypesClient implements ICompoundTypesClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getCompoundTypes(
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfCompoundTypeDto> {
    let url_ = this.baseUrl + '/compound-types?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCompoundTypes(_response)
      })
  }

  protected processGetCompoundTypes(
    response: AxiosResponse
  ): Promise<PagedOfCompoundTypeDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfCompoundTypeDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfCompoundTypeDto>(<any>null)
  }

  /**
   * @return Success
   */
  createCompoundType(
    body: CreateCompoundType,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/compound-types'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateCompoundType(_response)
      })
  }

  protected processCreateCompoundType(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getSharedCompoundTypes(
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfCompoundTypeDto> {
    let url_ = this.baseUrl + '/compound-types/shared?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSharedCompoundTypes(_response)
      })
  }

  protected processGetSharedCompoundTypes(
    response: AxiosResponse
  ): Promise<PagedOfCompoundTypeDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfCompoundTypeDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfCompoundTypeDto>(<any>null)
  }

  /**
   * @param caseTypeId (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getCaseTypeCompoundTypes(
    caseTypeId: string | undefined,
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfCompoundTypeDto> {
    let url_ = this.baseUrl + '/compound-types/casetype?'
    if (caseTypeId === null)
      throw new Error("The parameter 'caseTypeId' cannot be null.")
    else if (caseTypeId !== undefined)
      url_ += 'caseTypeId=' + encodeURIComponent('' + caseTypeId) + '&'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCaseTypeCompoundTypes(_response)
      })
  }

  protected processGetCaseTypeCompoundTypes(
    response: AxiosResponse
  ): Promise<PagedOfCompoundTypeDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfCompoundTypeDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfCompoundTypeDto>(<any>null)
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getBasicDataCompoundTypes(
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfCompoundTypeDto> {
    let url_ = this.baseUrl + '/compound-types/basic?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBasicDataCompoundTypes(_response)
      })
  }

  protected processGetBasicDataCompoundTypes(
    response: AxiosResponse
  ): Promise<PagedOfCompoundTypeDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfCompoundTypeDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfCompoundTypeDto>(<any>null)
  }

  /**
   * @return Success
   */
  getCompoundType(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<CompoundTypeDto> {
    let url_ = this.baseUrl + '/compound-types/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCompoundType(_response)
      })
  }

  protected processGetCompoundType(
    response: AxiosResponse
  ): Promise<CompoundTypeDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = CompoundTypeDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<CompoundTypeDto>(<any>null)
  }

  /**
   * @return Success
   */
  updateCompoundType(
    id: string | null,
    body: UpdateCompoundType,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/compound-types/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateCompoundType(_response)
      })
  }

  protected processUpdateCompoundType(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  deleteCompoundType(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/compound-types/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteCompoundType(_response)
      })
  }

  protected processDeleteCompoundType(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  updateCompoundTypesOrder(
    body: CompoundTypeDto[] | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/compound-types/order'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PATCH',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateCompoundTypesOrder(_response)
      })
  }

  protected processUpdateCompoundTypesOrder(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }
}

export interface IDocumentsClient {
  /**
   * @return Success
   */
  getDocumentNamingScheme(): Promise<DocumentNameSchemePartDto[]>
  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getLockedDocuments(
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfLockedCaseDocumentDto>
}

export class DocumentsClient implements IDocumentsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  getDocumentNamingScheme(
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentNameSchemePartDto[]> {
    let url_ = this.baseUrl + '/documents/naming-scheme'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDocumentNamingScheme(_response)
      })
  }

  protected processGetDocumentNamingScheme(
    response: AxiosResponse
  ): Promise<DocumentNameSchemePartDto[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(DocumentNameSchemePartDto.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentNameSchemePartDto[]>(<any>null)
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getLockedDocuments(
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfLockedCaseDocumentDto> {
    let url_ = this.baseUrl + '/documents/locked?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLockedDocuments(_response)
      })
  }

  protected processGetLockedDocuments(
    response: AxiosResponse
  ): Promise<PagedOfLockedCaseDocumentDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfLockedCaseDocumentDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfLockedCaseDocumentDto>(<any>null)
  }
}

export interface IEchoClient {
  /**
   * @return Success
   */
  getEcho(): Promise<string>
}

export class EchoClient implements IEchoClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  getEcho(cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/echo'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetEcho(_response)
      })
  }

  protected processGetEcho(response: AxiosResponse): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }
}

export interface IFileTemplatesClient {
  /**
   * @return Success
   */
  createBasicDataFileTemplate(
    body: FileTemplateSpecification
  ): Promise<FileTemplateDto>
  /**
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getBasicDataFileTemplates(
    page: number | undefined,
    pagesize: number | undefined
  ): Promise<PagedOfFileTemplateDto>
  /**
   * @return Success
   */
  createCaseTypeFileTemplate(
    caseTypeId: string,
    body: FileTemplateSpecification
  ): Promise<FileTemplateDto>
  /**
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getCaseTypeFileTemplates(
    caseTypeId: string,
    page: number | undefined,
    pagesize: number | undefined
  ): Promise<PagedOfFileTemplateDto>
  /**
   * @param caseTypeId (optional)
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getFileTemplatesForCase(
    caseTypeId: string | undefined,
    page: number | undefined,
    pagesize: number | undefined
  ): Promise<PagedOfFileTemplateDto>
  /**
   * @param file (optional)
   * @return Success
   */
  uploadFileTemplate(
    templateId: string,
    file: FileParameter | null | undefined
  ): Promise<void>
  /**
   * @return Success
   */
  downloadFileTemplate(templateId: string): Promise<FileResponse>
  /**
   * @return Success
   */
  updateFileTemplate(
    templateId: string,
    body: FileTemplateSpecification
  ): Promise<void>
  /**
   * @return Success
   */
  deleteFileTemplate(templateId: string): Promise<void>
}

export class FileTemplatesClient implements IFileTemplatesClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  createBasicDataFileTemplate(
    body: FileTemplateSpecification,
    cancelToken?: CancelToken | undefined
  ): Promise<FileTemplateDto> {
    let url_ = this.baseUrl + '/file-templates/basic-data'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateBasicDataFileTemplate(_response)
      })
  }

  protected processCreateBasicDataFileTemplate(
    response: AxiosResponse
  ): Promise<FileTemplateDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = FileTemplateDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FileTemplateDto>(<any>null)
  }

  /**
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getBasicDataFileTemplates(
    page: number | undefined,
    pagesize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfFileTemplateDto> {
    let url_ = this.baseUrl + '/file-templates/basic-data?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pagesize === null)
      throw new Error("The parameter 'pagesize' cannot be null.")
    else if (pagesize !== undefined)
      url_ += 'pagesize=' + encodeURIComponent('' + pagesize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBasicDataFileTemplates(_response)
      })
  }

  protected processGetBasicDataFileTemplates(
    response: AxiosResponse
  ): Promise<PagedOfFileTemplateDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfFileTemplateDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfFileTemplateDto>(<any>null)
  }

  /**
   * @return Success
   */
  createCaseTypeFileTemplate(
    caseTypeId: string,
    body: FileTemplateSpecification,
    cancelToken?: CancelToken | undefined
  ): Promise<FileTemplateDto> {
    let url_ = this.baseUrl + '/file-templates/case-type/{caseTypeId}'
    if (caseTypeId === undefined || caseTypeId === null)
      throw new Error("The parameter 'caseTypeId' must be defined.")
    url_ = url_.replace('{caseTypeId}', encodeURIComponent('' + caseTypeId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateCaseTypeFileTemplate(_response)
      })
  }

  protected processCreateCaseTypeFileTemplate(
    response: AxiosResponse
  ): Promise<FileTemplateDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = FileTemplateDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FileTemplateDto>(<any>null)
  }

  /**
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getCaseTypeFileTemplates(
    caseTypeId: string,
    page: number | undefined,
    pagesize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfFileTemplateDto> {
    let url_ = this.baseUrl + '/file-templates/case-type/{caseTypeId}?'
    if (caseTypeId === undefined || caseTypeId === null)
      throw new Error("The parameter 'caseTypeId' must be defined.")
    url_ = url_.replace('{caseTypeId}', encodeURIComponent('' + caseTypeId))
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pagesize === null)
      throw new Error("The parameter 'pagesize' cannot be null.")
    else if (pagesize !== undefined)
      url_ += 'pagesize=' + encodeURIComponent('' + pagesize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCaseTypeFileTemplates(_response)
      })
  }

  protected processGetCaseTypeFileTemplates(
    response: AxiosResponse
  ): Promise<PagedOfFileTemplateDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfFileTemplateDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfFileTemplateDto>(<any>null)
  }

  /**
   * @param caseTypeId (optional)
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getFileTemplatesForCase(
    caseTypeId: string | undefined,
    page: number | undefined,
    pagesize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfFileTemplateDto> {
    let url_ = this.baseUrl + '/file-templates/case?'
    if (caseTypeId === null)
      throw new Error("The parameter 'caseTypeId' cannot be null.")
    else if (caseTypeId !== undefined)
      url_ += 'caseTypeId=' + encodeURIComponent('' + caseTypeId) + '&'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pagesize === null)
      throw new Error("The parameter 'pagesize' cannot be null.")
    else if (pagesize !== undefined)
      url_ += 'pagesize=' + encodeURIComponent('' + pagesize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetFileTemplatesForCase(_response)
      })
  }

  protected processGetFileTemplatesForCase(
    response: AxiosResponse
  ): Promise<PagedOfFileTemplateDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfFileTemplateDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfFileTemplateDto>(<any>null)
  }

  /**
   * @param file (optional)
   * @return Success
   */
  uploadFileTemplate(
    templateId: string,
    file: FileParameter | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/file-templates/{templateId}/upload'
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.")
    url_ = url_.replace('{templateId}', encodeURIComponent('' + templateId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = new FormData()
    if (file !== null && file !== undefined)
      content_.append('file', file.data, file.fileName ? file.fileName : 'file')

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUploadFileTemplate(_response)
      })
  }

  protected processUploadFileTemplate(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  downloadFileTemplate(
    templateId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/file-templates/{templateId}/download'
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.")
    url_ = url_.replace('{templateId}', encodeURIComponent('' + templateId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      responseType: 'blob',
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadFileTemplate(_response)
      })
  }

  protected processDownloadFileTemplate(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined
      const fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      })
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FileResponse>(<any>null)
  }

  /**
   * @return Success
   */
  updateFileTemplate(
    templateId: string,
    body: FileTemplateSpecification,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/file-templates/{templateId}'
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.")
    url_ = url_.replace('{templateId}', encodeURIComponent('' + templateId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateFileTemplate(_response)
      })
  }

  protected processUpdateFileTemplate(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  deleteFileTemplate(
    templateId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/file-templates/{templateId}'
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.")
    url_ = url_.replace('{templateId}', encodeURIComponent('' + templateId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteFileTemplate(_response)
      })
  }

  protected processDeleteFileTemplate(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }
}

export interface IIndependentDocumentsClient {
  /**
   * @param file (optional)
   * @return Success
   */
  createIndependentDocument(
    file: FileParameter | null | undefined
  ): Promise<DocumentDto>
  /**
   * @param file (optional)
   * @return Success
   */
  updateIndependentDocument(
    documentId: string,
    file: FileParameter | null | undefined
  ): Promise<DocumentDto>
  /**
   * @return Success
   */
  getIndependentDocument(documentId: string): Promise<DocumentDto>
  /**
   * @return Success
   */
  deleteIndependentDocument(documentId: string): Promise<DocumentDto>
  /**
   * @return Success
   */
  getIndependentDocuments(body: string[] | null): Promise<DocumentDto[]>
  /**
   * @return Success
   */
  downloadIndependentDocument(documentId: string): Promise<FileResponse>
}

export class IndependentDocumentsClient implements IIndependentDocumentsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param file (optional)
   * @return Success
   */
  createIndependentDocument(
    file: FileParameter | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto> {
    let url_ = this.baseUrl + '/documents/independent'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = new FormData()
    if (file !== null && file !== undefined)
      content_.append('file', file.data, file.fileName ? file.fileName : 'file')

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateIndependentDocument(_response)
      })
  }

  protected processCreateIndependentDocument(
    response: AxiosResponse
  ): Promise<DocumentDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = DocumentDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto>(<any>null)
  }

  /**
   * @param file (optional)
   * @return Success
   */
  updateIndependentDocument(
    documentId: string,
    file: FileParameter | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto> {
    let url_ = this.baseUrl + '/documents/independent/{documentId}'
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = new FormData()
    if (file !== null && file !== undefined)
      content_.append('file', file.data, file.fileName ? file.fileName : 'file')

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateIndependentDocument(_response)
      })
  }

  protected processUpdateIndependentDocument(
    response: AxiosResponse
  ): Promise<DocumentDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = DocumentDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto>(<any>null)
  }

  /**
   * @return Success
   */
  getIndependentDocument(
    documentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto> {
    let url_ = this.baseUrl + '/documents/independent/{documentId}'
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetIndependentDocument(_response)
      })
  }

  protected processGetIndependentDocument(
    response: AxiosResponse
  ): Promise<DocumentDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = DocumentDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto>(<any>null)
  }

  /**
   * @return Success
   */
  deleteIndependentDocument(
    documentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto> {
    let url_ = this.baseUrl + '/documents/independent/{documentId}'
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteIndependentDocument(_response)
      })
  }

  protected processDeleteIndependentDocument(
    response: AxiosResponse
  ): Promise<DocumentDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = DocumentDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto>(<any>null)
  }

  /**
   * @return Success
   */
  getIndependentDocuments(
    body: string[] | null,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto[]> {
    let url_ = this.baseUrl + '/documents/independent/bulk'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetIndependentDocuments(_response)
      })
  }

  protected processGetIndependentDocuments(
    response: AxiosResponse
  ): Promise<DocumentDto[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(DocumentDto.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto[]>(<any>null)
  }

  /**
   * @return Success
   */
  downloadIndependentDocument(
    documentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/documents/independent/{documentId}/download'
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      responseType: 'blob',
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadIndependentDocument(_response)
      })
  }

  protected processDownloadIndependentDocument(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined
      const fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      })
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FileResponse>(<any>null)
  }
}

export interface IInterviewsClient {
  /**
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getOnboardingInterviews(
    page: number | undefined,
    pagesize: number | undefined
  ): Promise<PagedOfInterviewDto>
  /**
   * @return Success
   */
  getInterviewDetail(interviewId: string): Promise<InterviewDetailDto>
  /**
   * @return Success
   */
  updateInteview(interviewId: string, body: InterviewDto): Promise<InterviewDto>
  /**
   * @return Success
   */
  deleteInterview(interviewId: string): Promise<InterviewDto>
  /**
   * @return Success
   */
  createInterview(body: InterviewDto): Promise<InterviewDetailDto>
  /**
   * @return Success
   */
  updateInterviewData(interviewId: string, body: string | null): Promise<void>
  /**
   * @return Success
   */
  publishInterview(interviewId: string): Promise<void>
  /**
   * @return Success
   */
  getOnboardingInterviewData(slugName: string | null): Promise<string>
  /**
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getAbstractInterviews(
    page: number | undefined,
    pagesize: number | undefined
  ): Promise<PagedOfMinimalInterviewDto>
  /**
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getAbstractInterviewsByUsage(
    usage: InterviewUsage,
    page: number | undefined,
    pagesize: number | undefined
  ): Promise<PagedOfMinimalInterviewDto>
  /**
   * @param jsonValues (optional)
   * @return Success
   */
  onboard(jsonValues: string | null | undefined): Promise<void>
}

export class InterviewsClient implements IInterviewsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getOnboardingInterviews(
    page: number | undefined,
    pagesize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfInterviewDto> {
    let url_ = this.baseUrl + '/onboarding?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pagesize === null)
      throw new Error("The parameter 'pagesize' cannot be null.")
    else if (pagesize !== undefined)
      url_ += 'pagesize=' + encodeURIComponent('' + pagesize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetOnboardingInterviews(_response)
      })
  }

  protected processGetOnboardingInterviews(
    response: AxiosResponse
  ): Promise<PagedOfInterviewDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfInterviewDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfInterviewDto>(<any>null)
  }

  /**
   * @return Success
   */
  getInterviewDetail(
    interviewId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<InterviewDetailDto> {
    let url_ = this.baseUrl + '/interviews/{interviewId}'
    if (interviewId === undefined || interviewId === null)
      throw new Error("The parameter 'interviewId' must be defined.")
    url_ = url_.replace('{interviewId}', encodeURIComponent('' + interviewId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetInterviewDetail(_response)
      })
  }

  protected processGetInterviewDetail(
    response: AxiosResponse
  ): Promise<InterviewDetailDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = InterviewDetailDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<InterviewDetailDto>(<any>null)
  }

  /**
   * @return Success
   */
  updateInteview(
    interviewId: string,
    body: InterviewDto,
    cancelToken?: CancelToken | undefined
  ): Promise<InterviewDto> {
    let url_ = this.baseUrl + '/interviews/{interviewId}'
    if (interviewId === undefined || interviewId === null)
      throw new Error("The parameter 'interviewId' must be defined.")
    url_ = url_.replace('{interviewId}', encodeURIComponent('' + interviewId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateInteview(_response)
      })
  }

  protected processUpdateInteview(
    response: AxiosResponse
  ): Promise<InterviewDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = InterviewDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<InterviewDto>(<any>null)
  }

  /**
   * @return Success
   */
  deleteInterview(
    interviewId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<InterviewDto> {
    let url_ = this.baseUrl + '/interviews/{interviewId}'
    if (interviewId === undefined || interviewId === null)
      throw new Error("The parameter 'interviewId' must be defined.")
    url_ = url_.replace('{interviewId}', encodeURIComponent('' + interviewId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteInterview(_response)
      })
  }

  protected processDeleteInterview(
    response: AxiosResponse
  ): Promise<InterviewDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = InterviewDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<InterviewDto>(<any>null)
  }

  /**
   * @return Success
   */
  createInterview(
    body: InterviewDto,
    cancelToken?: CancelToken | undefined
  ): Promise<InterviewDetailDto> {
    let url_ = this.baseUrl + '/interviews'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateInterview(_response)
      })
  }

  protected processCreateInterview(
    response: AxiosResponse
  ): Promise<InterviewDetailDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = InterviewDetailDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<InterviewDetailDto>(<any>null)
  }

  /**
   * @return Success
   */
  updateInterviewData(
    interviewId: string,
    body: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/interviews/{interviewId}/data'
    if (interviewId === undefined || interviewId === null)
      throw new Error("The parameter 'interviewId' must be defined.")
    url_ = url_.replace('{interviewId}', encodeURIComponent('' + interviewId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateInterviewData(_response)
      })
  }

  protected processUpdateInterviewData(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  publishInterview(
    interviewId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/interviews/{interviewId}/publish'
    if (interviewId === undefined || interviewId === null)
      throw new Error("The parameter 'interviewId' must be defined.")
    url_ = url_.replace('{interviewId}', encodeURIComponent('' + interviewId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'PUT',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPublishInterview(_response)
      })
  }

  protected processPublishInterview(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  getOnboardingInterviewData(
    slugName: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/interviews/onboarding/{slugName}'
    if (slugName === undefined || slugName === null)
      throw new Error("The parameter 'slugName' must be defined.")
    url_ = url_.replace('{slugName}', encodeURIComponent('' + slugName))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetOnboardingInterviewData(_response)
      })
  }

  protected processGetOnboardingInterviewData(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getAbstractInterviews(
    page: number | undefined,
    pagesize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfMinimalInterviewDto> {
    let url_ = this.baseUrl + '/interviews/abstract?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pagesize === null)
      throw new Error("The parameter 'pagesize' cannot be null.")
    else if (pagesize !== undefined)
      url_ += 'pagesize=' + encodeURIComponent('' + pagesize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAbstractInterviews(_response)
      })
  }

  protected processGetAbstractInterviews(
    response: AxiosResponse
  ): Promise<PagedOfMinimalInterviewDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfMinimalInterviewDto.fromJS(resultData200)
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfMinimalInterviewDto>(<any>null)
  }

  /**
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getAbstractInterviewsByUsage(
    usage: InterviewUsage,
    page: number | undefined,
    pagesize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfMinimalInterviewDto> {
    let url_ = this.baseUrl + '/interviews/abstract/{usage}?'
    if (usage === undefined || usage === null)
      throw new Error("The parameter 'usage' must be defined.")
    url_ = url_.replace('{usage}', encodeURIComponent('' + usage))
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pagesize === null)
      throw new Error("The parameter 'pagesize' cannot be null.")
    else if (pagesize !== undefined)
      url_ += 'pagesize=' + encodeURIComponent('' + pagesize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAbstractInterviewsByUsage(_response)
      })
  }

  protected processGetAbstractInterviewsByUsage(
    response: AxiosResponse
  ): Promise<PagedOfMinimalInterviewDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfMinimalInterviewDto.fromJS(resultData200)
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfMinimalInterviewDto>(<any>null)
  }

  /**
   * @param jsonValues (optional)
   * @return Success
   */
  onboard(
    jsonValues: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/interviews/onboard?'
    if (jsonValues !== undefined && jsonValues !== null)
      url_ += 'jsonValues=' + encodeURIComponent('' + jsonValues) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processOnboard(_response)
      })
  }

  protected processOnboard(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }
}

export interface ILoginLogsClient {
  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getLoginLogEntries(
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfLoginLogEntryDto>
}

export class LoginLogsClient implements ILoginLogsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getLoginLogEntries(
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfLoginLogEntryDto> {
    let url_ = this.baseUrl + '/login-logs?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLoginLogEntries(_response)
      })
  }

  protected processGetLoginLogEntries(
    response: AxiosResponse
  ): Promise<PagedOfLoginLogEntryDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfLoginLogEntryDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfLoginLogEntryDto>(<any>null)
  }
}

export interface ILookupEntriesClient {
  /**
   * @param lookupId (optional)
   * @return Success
   */
  hasLookupEntries(lookupId: string | null | undefined): Promise<boolean>
  /**
   * @param lookupId (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getLookupEntries(
    lookupId: string | null | undefined,
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfLookupEntryDto>
  /**
   * @return Success
   */
  createLookupEntry(body: LookupEntryDto): Promise<string>
  /**
   * @return Success
   */
  getFilteredAndSortedLookupEntries(
    body: FilteredAndSortedLookupEntryRequest
  ): Promise<PagedOfFilteredAndSortedLookupEntry>
  /**
   * @return Success
   */
  getLookupEntry(id: string): Promise<LookupEntryDto>
  /**
   * @return Success
   */
  updateLookupEntry(id: string, body: LookupEntryDto): Promise<void>
  /**
   * @return Success
   */
  deleteLookupEntry(id: string): Promise<void>
}

export class LookupEntriesClient implements ILookupEntriesClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param lookupId (optional)
   * @return Success
   */
  hasLookupEntries(
    lookupId: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<boolean> {
    let url_ = this.baseUrl + '/exists?'
    if (lookupId !== undefined && lookupId !== null)
      url_ += 'lookupId=' + encodeURIComponent('' + lookupId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processHasLookupEntries(_response)
      })
  }

  protected processHasLookupEntries(response: AxiosResponse): Promise<boolean> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<boolean>(<any>null)
  }

  /**
   * @param lookupId (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getLookupEntries(
    lookupId: string | null | undefined,
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfLookupEntryDto> {
    let url_ = this.baseUrl + '/lookup-entries?'
    if (lookupId !== undefined && lookupId !== null)
      url_ += 'lookupId=' + encodeURIComponent('' + lookupId) + '&'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLookupEntries(_response)
      })
  }

  protected processGetLookupEntries(
    response: AxiosResponse
  ): Promise<PagedOfLookupEntryDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfLookupEntryDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfLookupEntryDto>(<any>null)
  }

  /**
   * @return Success
   */
  createLookupEntry(
    body: LookupEntryDto,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/lookup-entries'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateLookupEntry(_response)
      })
  }

  protected processCreateLookupEntry(response: AxiosResponse): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * @return Success
   */
  getFilteredAndSortedLookupEntries(
    body: FilteredAndSortedLookupEntryRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfFilteredAndSortedLookupEntry> {
    let url_ = this.baseUrl + '/lookup-entries/filtered'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetFilteredAndSortedLookupEntries(_response)
      })
  }

  protected processGetFilteredAndSortedLookupEntries(
    response: AxiosResponse
  ): Promise<PagedOfFilteredAndSortedLookupEntry> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfFilteredAndSortedLookupEntry.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfFilteredAndSortedLookupEntry>(<any>null)
  }

  /**
   * @return Success
   */
  getLookupEntry(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<LookupEntryDto> {
    let url_ = this.baseUrl + '/lookup-entries/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLookupEntry(_response)
      })
  }

  protected processGetLookupEntry(
    response: AxiosResponse
  ): Promise<LookupEntryDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = LookupEntryDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<LookupEntryDto>(<any>null)
  }

  /**
   * @return Success
   */
  updateLookupEntry(
    id: string,
    body: LookupEntryDto,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/lookup-entries/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateLookupEntry(_response)
      })
  }

  protected processUpdateLookupEntry(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  deleteLookupEntry(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/lookup-entries/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteLookupEntry(_response)
      })
  }

  protected processDeleteLookupEntry(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }
}

export interface ILookupEntryDocumentsClient {
  /**
   * @param file (optional)
   * @return Success
   */
  createDocument(
    entryId: string,
    file: FileParameter | null | undefined
  ): Promise<DocumentDto>
  /**
   * @return Success
   */
  getDocumentDetails2(entryId: string, documentId: string): Promise<DocumentDto>
  /**
   * @return Success
   */
  downloadDocument2(entryId: string, documentId: string): Promise<FileResponse>
  /**
   * @param file (optional)
   * @return Success
   */
  updateDocument2(
    entryId: string,
    documentId: string,
    file: FileParameter | null | undefined
  ): Promise<DocumentDto>
  /**
   * @return Success
   */
  deleteDocument2(entryId: string, documentId: string): Promise<void>
  /**
   * @param caseId (optional)
   * @param documentId (optional)
   * @return Success
   */
  copyCaseDocument(
    caseId: string | undefined,
    documentId: string | undefined,
    entryId: string
  ): Promise<DocumentDto>
}

export class LookupEntryDocumentsClient implements ILookupEntryDocumentsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param file (optional)
   * @return Success
   */
  createDocument(
    entryId: string,
    file: FileParameter | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto> {
    let url_ = this.baseUrl + '/lookup-entries/{entryId}/documents'
    if (entryId === undefined || entryId === null)
      throw new Error("The parameter 'entryId' must be defined.")
    url_ = url_.replace('{entryId}', encodeURIComponent('' + entryId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = new FormData()
    if (file !== null && file !== undefined)
      content_.append('file', file.data, file.fileName ? file.fileName : 'file')

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateDocument(_response)
      })
  }

  protected processCreateDocument(
    response: AxiosResponse
  ): Promise<DocumentDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = DocumentDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto>(<any>null)
  }

  /**
   * @return Success
   */
  getDocumentDetails2(
    entryId: string,
    documentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto> {
    let url_ =
      this.baseUrl + '/lookup-entries/{entryId}/documents/{documentId}/details'
    if (entryId === undefined || entryId === null)
      throw new Error("The parameter 'entryId' must be defined.")
    url_ = url_.replace('{entryId}', encodeURIComponent('' + entryId))
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDocumentDetails2(_response)
      })
  }

  protected processGetDocumentDetails2(
    response: AxiosResponse
  ): Promise<DocumentDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = DocumentDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto>(<any>null)
  }

  /**
   * @return Success
   */
  downloadDocument2(
    entryId: string,
    documentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/lookup-entries/{entryId}/documents/{documentId}'
    if (entryId === undefined || entryId === null)
      throw new Error("The parameter 'entryId' must be defined.")
    url_ = url_.replace('{entryId}', encodeURIComponent('' + entryId))
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      responseType: 'blob',
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadDocument2(_response)
      })
  }

  protected processDownloadDocument2(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined
      const fileName =
        fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      })
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<FileResponse>(<any>null)
  }

  /**
   * @param file (optional)
   * @return Success
   */
  updateDocument2(
    entryId: string,
    documentId: string,
    file: FileParameter | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto> {
    let url_ = this.baseUrl + '/lookup-entries/{entryId}/documents/{documentId}'
    if (entryId === undefined || entryId === null)
      throw new Error("The parameter 'entryId' must be defined.")
    url_ = url_.replace('{entryId}', encodeURIComponent('' + entryId))
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = new FormData()
    if (file !== null && file !== undefined)
      content_.append('file', file.data, file.fileName ? file.fileName : 'file')

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateDocument2(_response)
      })
  }

  protected processUpdateDocument2(
    response: AxiosResponse
  ): Promise<DocumentDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = DocumentDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto>(<any>null)
  }

  /**
   * @return Success
   */
  deleteDocument2(
    entryId: string,
    documentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/lookup-entries/{entryId}/documents/{documentId}'
    if (entryId === undefined || entryId === null)
      throw new Error("The parameter 'entryId' must be defined.")
    url_ = url_.replace('{entryId}', encodeURIComponent('' + entryId))
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.")
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteDocument2(_response)
      })
  }

  protected processDeleteDocument2(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @param caseId (optional)
   * @param documentId (optional)
   * @return Success
   */
  copyCaseDocument(
    caseId: string | undefined,
    documentId: string | undefined,
    entryId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentDto> {
    let url_ = this.baseUrl + '/lookup-entries/{entryId}/documents/copy?'
    if (entryId === undefined || entryId === null)
      throw new Error("The parameter 'entryId' must be defined.")
    url_ = url_.replace('{entryId}', encodeURIComponent('' + entryId))
    if (caseId === null)
      throw new Error("The parameter 'caseId' cannot be null.")
    else if (caseId !== undefined)
      url_ += 'caseId=' + encodeURIComponent('' + caseId) + '&'
    if (documentId === null)
      throw new Error("The parameter 'documentId' cannot be null.")
    else if (documentId !== undefined)
      url_ += 'documentId=' + encodeURIComponent('' + documentId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCopyCaseDocument(_response)
      })
  }

  protected processCopyCaseDocument(
    response: AxiosResponse
  ): Promise<DocumentDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = DocumentDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<DocumentDto>(<any>null)
  }
}

export interface ILookupsClient {
  /**
   * @param overview (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getLookups(
    overview: boolean | undefined,
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfLookupDto>
  /**
   * @return Success
   */
  createLookup(body: LookupDto): Promise<string>
  /**
   * @return Success
   */
  getLookup(id: string): Promise<LookupDto>
  /**
   * @return Success
   */
  deleteLookupEntry2(id: string): Promise<void>
  /**
   * @return Success
   */
  getLookupDomainInfos(): Promise<LookupDomainInfoDto[]>
  /**
   * @return Success
   */
  getLookupByLookupDomain(lookupDomain: string | null): Promise<LookupDto>
  /**
   * @return Success
   */
  updateLookupSchema(id: string): Promise<void>
}

export class LookupsClient implements ILookupsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param overview (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getLookups(
    overview: boolean | undefined,
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfLookupDto> {
    let url_ = this.baseUrl + '/lookups?'
    if (overview === null)
      throw new Error("The parameter 'overview' cannot be null.")
    else if (overview !== undefined)
      url_ += 'overview=' + encodeURIComponent('' + overview) + '&'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLookups(_response)
      })
  }

  protected processGetLookups(
    response: AxiosResponse
  ): Promise<PagedOfLookupDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfLookupDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfLookupDto>(<any>null)
  }

  /**
   * @return Success
   */
  createLookup(
    body: LookupDto,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/lookups'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateLookup(_response)
      })
  }

  protected processCreateLookup(response: AxiosResponse): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * @return Success
   */
  getLookup(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<LookupDto> {
    let url_ = this.baseUrl + '/lookups/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLookup(_response)
      })
  }

  protected processGetLookup(response: AxiosResponse): Promise<LookupDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = LookupDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<LookupDto>(<any>null)
  }

  /**
   * @return Success
   */
  deleteLookupEntry2(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/lookups/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteLookupEntry2(_response)
      })
  }

  protected processDeleteLookupEntry2(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  getLookupDomainInfos(
    cancelToken?: CancelToken | undefined
  ): Promise<LookupDomainInfoDto[]> {
    let url_ = this.baseUrl + '/lookups/domains'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLookupDomainInfos(_response)
      })
  }

  protected processGetLookupDomainInfos(
    response: AxiosResponse
  ): Promise<LookupDomainInfoDto[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(LookupDomainInfoDto.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<LookupDomainInfoDto[]>(<any>null)
  }

  /**
   * @return Success
   */
  getLookupByLookupDomain(
    lookupDomain: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<LookupDto> {
    let url_ = this.baseUrl + '/lookups/domains/{lookupDomain}'
    if (lookupDomain === undefined || lookupDomain === null)
      throw new Error("The parameter 'lookupDomain' must be defined.")
    url_ = url_.replace('{lookupDomain}', encodeURIComponent('' + lookupDomain))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLookupByLookupDomain(_response)
      })
  }

  protected processGetLookupByLookupDomain(
    response: AxiosResponse
  ): Promise<LookupDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = LookupDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<LookupDto>(<any>null)
  }

  /**
   * @return Success
   */
  updateLookupSchema(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/lookups/{id}/UpdateLookupSchema'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'PUT',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateLookupSchema(_response)
      })
  }

  protected processUpdateLookupSchema(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }
}

export interface IPanicClient {
  /**
   * @return Success
   */
  enablePanic(): Promise<void>
}

export class PanicClient implements IPanicClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  enablePanic(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/panic/enable-panic'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processEnablePanic(_response)
      })
  }

  protected processEnablePanic(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }
}

export interface IPermissionsClient {
  /**
   * @return Success
   */
  getAll(): Promise<PermissionDto[]>
}

export class PermissionsClient implements IPermissionsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  getAll(cancelToken?: CancelToken | undefined): Promise<PermissionDto[]> {
    let url_ = this.baseUrl + '/permissions'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAll(_response)
      })
  }

  protected processGetAll(response: AxiosResponse): Promise<PermissionDto[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(PermissionDto.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PermissionDto[]>(<any>null)
  }
}

export interface IRolesClient {
  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getRoles(
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfRoleDto>
  /**
   * @return Success
   */
  createRole(body: CreateOrUpdateRole): Promise<string>
  /**
   * @return Success
   */
  getRole(id: string): Promise<RoleDto>
  /**
   * @return Success
   */
  updateRole(id: string, body: CreateOrUpdateRole): Promise<void>
  /**
   * @return Success
   */
  deleteRole(id: string): Promise<void>
}

export class RolesClient implements IRolesClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getRoles(
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfRoleDto> {
    let url_ = this.baseUrl + '/roles?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRoles(_response)
      })
  }

  protected processGetRoles(response: AxiosResponse): Promise<PagedOfRoleDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfRoleDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfRoleDto>(<any>null)
  }

  /**
   * @return Success
   */
  createRole(
    body: CreateOrUpdateRole,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/roles'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateRole(_response)
      })
  }

  protected processCreateRole(response: AxiosResponse): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * @return Success
   */
  getRole(id: string, cancelToken?: CancelToken | undefined): Promise<RoleDto> {
    let url_ = this.baseUrl + '/roles/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRole(_response)
      })
  }

  protected processGetRole(response: AxiosResponse): Promise<RoleDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = RoleDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<RoleDto>(<any>null)
  }

  /**
   * @return Success
   */
  updateRole(
    id: string,
    body: CreateOrUpdateRole,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/roles/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateRole(_response)
      })
  }

  protected processUpdateRole(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  deleteRole(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/roles/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteRole(_response)
      })
  }

  protected processDeleteRole(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }
}

export interface ISimpleTypesClient {
  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getSimpleTypes(
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfSimpleTypeDto>
  /**
   * @return Success
   */
  createSimpleType(body: CreateSimpleType): Promise<string>
  /**
   * @return Success
   */
  getSimpleType(id: string | null): Promise<SimpleTypeDto>
  /**
   * @return Success
   */
  updateSimpleType(id: string | null, body: UpdateSimpleType): Promise<void>
  /**
   * @return Success
   */
  deleteSimpleType(id: string | null): Promise<void>
  /**
   * @return Success
   */
  testScript(body: TestScriptCommand): Promise<string>
}

export class SimpleTypesClient implements ISimpleTypesClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getSimpleTypes(
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfSimpleTypeDto> {
    let url_ = this.baseUrl + '/simple-types?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSimpleTypes(_response)
      })
  }

  protected processGetSimpleTypes(
    response: AxiosResponse
  ): Promise<PagedOfSimpleTypeDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfSimpleTypeDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfSimpleTypeDto>(<any>null)
  }

  /**
   * @return Success
   */
  createSimpleType(
    body: CreateSimpleType,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/simple-types'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateSimpleType(_response)
      })
  }

  protected processCreateSimpleType(response: AxiosResponse): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * @return Success
   */
  getSimpleType(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<SimpleTypeDto> {
    let url_ = this.baseUrl + '/simple-types/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSimpleType(_response)
      })
  }

  protected processGetSimpleType(
    response: AxiosResponse
  ): Promise<SimpleTypeDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = SimpleTypeDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<SimpleTypeDto>(<any>null)
  }

  /**
   * @return Success
   */
  updateSimpleType(
    id: string | null,
    body: UpdateSimpleType,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/simple-types/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateSimpleType(_response)
      })
  }

  protected processUpdateSimpleType(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  deleteSimpleType(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/simple-types/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteSimpleType(_response)
      })
  }

  protected processDeleteSimpleType(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  testScript(
    body: TestScriptCommand,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/simple-types/test-script'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processTestScript(_response)
      })
  }

  protected processTestScript(response: AxiosResponse): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }
}

export interface ITenantsClient {
  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getTenants(
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfTenantDto>
  /**
   * @return Success
   */
  getTenant(id: string): Promise<TenantDto>
  /**
   * @return Success
   */
  getCurrentTenant(): Promise<TenantDto>
  /**
   * @return Success
   */
  getTenantSignature(): Promise<string>
}

export class TenantsClient implements ITenantsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getTenants(
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfTenantDto> {
    let url_ = this.baseUrl + '/tenants?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTenants(_response)
      })
  }

  protected processGetTenants(
    response: AxiosResponse
  ): Promise<PagedOfTenantDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfTenantDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfTenantDto>(<any>null)
  }

  /**
   * @return Success
   */
  getTenant(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<TenantDto> {
    let url_ = this.baseUrl + '/tenants/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTenant(_response)
      })
  }

  protected processGetTenant(response: AxiosResponse): Promise<TenantDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = TenantDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<TenantDto>(<any>null)
  }

  /**
   * @return Success
   */
  getCurrentTenant(cancelToken?: CancelToken | undefined): Promise<TenantDto> {
    let url_ = this.baseUrl + '/tenants/current'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCurrentTenant(_response)
      })
  }

  protected processGetCurrentTenant(
    response: AxiosResponse
  ): Promise<TenantDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = TenantDto.fromJS(resultData200)
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<TenantDto>(<any>null)
  }

  /**
   * @return Success
   */
  getTenantSignature(cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/tenants/mail-signature'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTenantSignature(_response)
      })
  }

  protected processGetTenantSignature(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }
}

export interface IUsersClient {
  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getUsers(
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfUserDto>
  /**
   * @return Success
   */
  createUser(body: CreateUser): Promise<string>
  /**
   * @return Success
   */
  getBasicUsers(): Promise<BasicUserDto[]>
  /**
   * @return Success
   */
  getUser(id: string): Promise<UserDto>
  /**
   * @return Success
   */
  updateUser(id: string, body: UpdateUser): Promise<void>
  /**
   * @return Success
   */
  deleteUser(id: string): Promise<void>
  /**
   * @return Success
   */
  getUserSettings(id: string): Promise<string>
  /**
   * @param settings (optional)
   * @return Success
   */
  updateUserSettings(
    id: string,
    settings: string | null | undefined
  ): Promise<void>
  /**
   * @return Success
   */
  assignRoleToUser(id: string, body: AssignRoleToUser): Promise<void>
  /**
   * @return Success
   */
  changePassword(id: string, body: ChangePassword): Promise<void>
  /**
   * @return Success
   */
  current(): Promise<UserDto>
  /**
   * @return Success
   */
  updateCurrentUser(body: UserDto): Promise<void>
  /**
   * @param area (optional)
   * @param extId (optional)
   * @return Success
   */
  getCurrentUserConfig(
    area: string | null | undefined,
    extId: string | undefined
  ): Promise<string>
  /**
   * @param area (optional)
   * @param extId (optional)
   * @param config (optional)
   * @return Success
   */
  setCurrentUserConfig(
    area: string | null | undefined,
    extId: string | undefined,
    config: string | null | undefined
  ): Promise<void>
  /**
   * @param picture (optional)
   * @return Success
   */
  setCurrentProfilePicture(
    picture: FileParameter | null | undefined
  ): Promise<void>
  /**
   * @return Success
   */
  deleteCurrentProfilePicture(): Promise<void>
}

export class UsersClient implements IUsersClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getUsers(
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfUserDto> {
    let url_ = this.baseUrl + '/users?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUsers(_response)
      })
  }

  protected processGetUsers(response: AxiosResponse): Promise<PagedOfUserDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfUserDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfUserDto>(<any>null)
  }

  /**
   * @return Success
   */
  createUser(
    body: CreateUser,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/users'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateUser(_response)
      })
  }

  protected processCreateUser(response: AxiosResponse): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * @return Success
   */
  getBasicUsers(
    cancelToken?: CancelToken | undefined
  ): Promise<BasicUserDto[]> {
    let url_ = this.baseUrl + '/users/basic'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBasicUsers(_response)
      })
  }

  protected processGetBasicUsers(
    response: AxiosResponse
  ): Promise<BasicUserDto[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(BasicUserDto.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<BasicUserDto[]>(<any>null)
  }

  /**
   * @return Success
   */
  getUser(id: string, cancelToken?: CancelToken | undefined): Promise<UserDto> {
    let url_ = this.baseUrl + '/users/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUser(_response)
      })
  }

  protected processGetUser(response: AxiosResponse): Promise<UserDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = UserDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<UserDto>(<any>null)
  }

  /**
   * @return Success
   */
  updateUser(
    id: string,
    body: UpdateUser,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/users/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PATCH',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateUser(_response)
      })
  }

  protected processUpdateUser(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  deleteUser(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/users/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteUser(_response)
      })
  }

  protected processDeleteUser(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  getUserSettings(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/users/{id}/settings'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUserSettings(_response)
      })
  }

  protected processGetUserSettings(response: AxiosResponse): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * @param settings (optional)
   * @return Success
   */
  updateUserSettings(
    id: string,
    settings: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/users/{id}/settings?'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (settings !== undefined && settings !== null)
      url_ += 'settings=' + encodeURIComponent('' + settings) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'PUT',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateUserSettings(_response)
      })
  }

  protected processUpdateUserSettings(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  assignRoleToUser(
    id: string,
    body: AssignRoleToUser,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/users/{id}/assign-role'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PATCH',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAssignRoleToUser(_response)
      })
  }

  protected processAssignRoleToUser(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  changePassword(
    id: string,
    body: ChangePassword,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/users/{id}/change-password'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PATCH',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangePassword(_response)
      })
  }

  protected processChangePassword(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  current(cancelToken?: CancelToken | undefined): Promise<UserDto> {
    let url_ = this.baseUrl + '/users/current'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCurrent(_response)
      })
  }

  protected processCurrent(response: AxiosResponse): Promise<UserDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = UserDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<UserDto>(<any>null)
  }

  /**
   * @return Success
   */
  updateCurrentUser(
    body: UserDto,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/users/current'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateCurrentUser(_response)
      })
  }

  protected processUpdateCurrentUser(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @param area (optional)
   * @param extId (optional)
   * @return Success
   */
  getCurrentUserConfig(
    area: string | null | undefined,
    extId: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/users/current/config?'
    if (area !== undefined && area !== null)
      url_ += 'area=' + encodeURIComponent('' + area) + '&'
    if (extId === null) throw new Error("The parameter 'extId' cannot be null.")
    else if (extId !== undefined)
      url_ += 'extId=' + encodeURIComponent('' + extId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCurrentUserConfig(_response)
      })
  }

  protected processGetCurrentUserConfig(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }

  /**
   * @param area (optional)
   * @param extId (optional)
   * @param config (optional)
   * @return Success
   */
  setCurrentUserConfig(
    area: string | null | undefined,
    extId: string | undefined,
    config: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/users/current/config?'
    if (area !== undefined && area !== null)
      url_ += 'area=' + encodeURIComponent('' + area) + '&'
    if (extId === null) throw new Error("The parameter 'extId' cannot be null.")
    else if (extId !== undefined)
      url_ += 'extId=' + encodeURIComponent('' + extId) + '&'
    if (config !== undefined && config !== null)
      url_ += 'config=' + encodeURIComponent('' + config) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'PUT',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSetCurrentUserConfig(_response)
      })
  }

  protected processSetCurrentUserConfig(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @param picture (optional)
   * @return Success
   */
  setCurrentProfilePicture(
    picture: FileParameter | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/users/current/profile-picture'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = new FormData()
    if (picture !== null && picture !== undefined)
      content_.append(
        'picture',
        picture.data,
        picture.fileName ? picture.fileName : 'picture'
      )

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSetCurrentProfilePicture(_response)
      })
  }

  protected processSetCurrentProfilePicture(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  deleteCurrentProfilePicture(
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/users/current/profile-picture'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteCurrentProfilePicture(_response)
      })
  }

  protected processDeleteCurrentProfilePicture(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }
}

export interface IVersionClient {
  /**
   * @return Success
   */
  getAssemblyVersion(): Promise<string>
}

export class VersionClient implements IVersionClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  getAssemblyVersion(cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/assembly-version'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAssemblyVersion(_response)
      })
  }

  protected processGetAssemblyVersion(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200 !== undefined ? resultData200 : <any>null
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<string>(<any>null)
  }
}

export interface IWorkflowsClient {
  /**
   * @return Success
   */
  createWorkflow(body: WorkflowDto): Promise<WorkflowDto>
  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getGenericWorkflows(
    page: number | undefined,
    pageSize: number | undefined
  ): Promise<PagedOfWorkflowDto>
  /**
   * @return Success
   */
  updateWorkflow(body: WorkflowDto): Promise<WorkflowDto>
  /**
   * @return Success
   */
  getWorkflow(id: string): Promise<WorkflowDto>
  /**
   * @return Success
   */
  deleteWorkflow(id: string): Promise<void>
  /**
   * @return Success
   */
  getCaseTypeWorkflow(caseTypeId: string): Promise<WorkflowDto>
}

export class WorkflowsClient implements IWorkflowsClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  createWorkflow(
    body: WorkflowDto,
    cancelToken?: CancelToken | undefined
  ): Promise<WorkflowDto> {
    let url_ = this.baseUrl + '/Workflows'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateWorkflow(_response)
      })
  }

  protected processCreateWorkflow(
    response: AxiosResponse
  ): Promise<WorkflowDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = WorkflowDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<WorkflowDto>(<any>null)
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @return Success
   */
  getGenericWorkflows(
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PagedOfWorkflowDto> {
    let url_ = this.baseUrl + '/Workflows?'
    if (page === null) throw new Error("The parameter 'page' cannot be null.")
    else if (page !== undefined)
      url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.")
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetGenericWorkflows(_response)
      })
  }

  protected processGetGenericWorkflows(
    response: AxiosResponse
  ): Promise<PagedOfWorkflowDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = PagedOfWorkflowDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<PagedOfWorkflowDto>(<any>null)
  }

  /**
   * @return Success
   */
  updateWorkflow(
    body: WorkflowDto,
    cancelToken?: CancelToken | undefined
  ): Promise<WorkflowDto> {
    let url_ = this.baseUrl + '/Workflows'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateWorkflow(_response)
      })
  }

  protected processUpdateWorkflow(
    response: AxiosResponse
  ): Promise<WorkflowDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = WorkflowDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<WorkflowDto>(<any>null)
  }

  /**
   * @return Success
   */
  getWorkflow(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<WorkflowDto> {
    let url_ = this.baseUrl + '/Workflows/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetWorkflow(_response)
      })
  }

  protected processGetWorkflow(response: AxiosResponse): Promise<WorkflowDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = WorkflowDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<WorkflowDto>(<any>null)
  }

  /**
   * @return Success
   */
  deleteWorkflow(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/Workflows/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteWorkflow(_response)
      })
  }

  protected processDeleteWorkflow(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  getCaseTypeWorkflow(
    caseTypeId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<WorkflowDto> {
    let url_ = this.baseUrl + '/Workflows/casetype/{caseTypeId}'
    if (caseTypeId === undefined || caseTypeId === null)
      throw new Error("The parameter 'caseTypeId' must be defined.")
    url_ = url_.replace('{caseTypeId}', encodeURIComponent('' + caseTypeId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCaseTypeWorkflow(_response)
      })
  }

  protected processGetCaseTypeWorkflow(
    response: AxiosResponse
  ): Promise<WorkflowDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = WorkflowDto.fromJS(resultData200)
      return result200
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<WorkflowDto>(<any>null)
  }
}

export interface IWorkflowTasksClient {
  /**
   * @return Success
   */
  getTasks(): Promise<WorkflowTaskDto[]>
  /**
   * @return Success
   */
  saveTask(body: WorkflowTaskDto): Promise<void>
  /**
   * @return Success
   */
  getTask(id: string): Promise<WorkflowTaskDto>
  /**
   * @param transitionId (optional)
   * @param nextStepId (optional)
   * @return Success
   */
  transition(
    transitionId: string | undefined,
    nextStepId: string | null | undefined
  ): Promise<void>
  /**
   * @param transitionId (optional)
   * @return Success
   */
  takeOverTask(transitionId: string | undefined): Promise<WorkflowTaskDto>
  /**
   * @param delegateUserId (optional)
   * @return Success
   */
  delegate(
    delegateUserId: string | undefined,
    body: WorkflowTaskDto
  ): Promise<void>
}

export class WorkflowTasksClient implements IWorkflowTasksClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create()
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:44322/api'
  }

  /**
   * @return Success
   */
  getTasks(cancelToken?: CancelToken | undefined): Promise<WorkflowTaskDto[]> {
    let url_ = this.baseUrl + '/WorkflowTasks'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTasks(_response)
      })
  }

  protected processGetTasks(
    response: AxiosResponse
  ): Promise<WorkflowTaskDto[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      if (Array.isArray(resultData200)) {
        result200 = [] as any
        for (let item of resultData200)
          result200!.push(WorkflowTaskDto.fromJS(item))
      } else {
        result200 = <any>null
      }
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<WorkflowTaskDto[]>(<any>null)
  }

  /**
   * @return Success
   */
  saveTask(
    body: WorkflowTaskDto,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/WorkflowTasks'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSaveTask(_response)
      })
  }

  protected processSaveTask(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @return Success
   */
  getTask(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<WorkflowTaskDto> {
    let url_ = this.baseUrl + '/WorkflowTasks/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTask(_response)
      })
  }

  protected processGetTask(response: AxiosResponse): Promise<WorkflowTaskDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = WorkflowTaskDto.fromJS(resultData200)
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<WorkflowTaskDto>(<any>null)
  }

  /**
   * @param transitionId (optional)
   * @param nextStepId (optional)
   * @return Success
   */
  transition(
    transitionId: string | undefined,
    nextStepId: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/WorkflowTasks/transition?'
    if (transitionId === null)
      throw new Error("The parameter 'transitionId' cannot be null.")
    else if (transitionId !== undefined)
      url_ += 'transitionId=' + encodeURIComponent('' + transitionId) + '&'
    if (nextStepId !== undefined && nextStepId !== null)
      url_ += 'nextStepId=' + encodeURIComponent('' + nextStepId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processTransition(_response)
      })
  }

  protected processTransition(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }

  /**
   * @param transitionId (optional)
   * @return Success
   */
  takeOverTask(
    transitionId: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<WorkflowTaskDto> {
    let url_ = this.baseUrl + '/WorkflowTasks/take-over?'
    if (transitionId === null)
      throw new Error("The parameter 'transitionId' cannot be null.")
    else if (transitionId !== undefined)
      url_ += 'transitionId=' + encodeURIComponent('' + transitionId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <AxiosRequestConfig>{
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'text/plain'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processTakeOverTask(_response)
      })
  }

  protected processTakeOverTask(
    response: AxiosResponse
  ): Promise<WorkflowTaskDto> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = WorkflowTaskDto.fromJS(resultData200)
      return result200
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<WorkflowTaskDto>(<any>null)
  }

  /**
   * @param delegateUserId (optional)
   * @return Success
   */
  delegate(
    delegateUserId: string | undefined,
    body: WorkflowTaskDto,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/WorkflowTasks/delegate?'
    if (delegateUserId === null)
      throw new Error("The parameter 'delegateUserId' cannot be null.")
    else if (delegateUserId !== undefined)
      url_ += 'delegateUserId=' + encodeURIComponent('' + delegateUserId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    }

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelegate(_response)
      })
  }

  protected processDelegate(response: AxiosResponse): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      return Promise.resolve<void>(<any>null)
    } else if (status === 401) {
      const _responseText = response.data
      return throwException('Unauthorized', status, _responseText, _headers)
    } else if (status === 403) {
      const _responseText = response.data
      return throwException('Forbidden', status, _responseText, _headers)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      )
    }
    return Promise.resolve<void>(<any>null)
  }
}

export class CloudNuggetProfile implements ICloudNuggetProfile {
  /** The Cloud-Nugget specific version number, can be any string and should help the caller to identify the version */
  version?: string
  /** The supported Cloud-Nugget skills */
  skills?: CloudNuggetSkill[]
  /** The basic route to the API versions, can be '1' for '/1/<...>' or 'v1' for '/v1/<...>, the '/s1/cloud-nugget/openapi/' has to provide an OpenAPI document for every listed version */
  apiVersions?: string[]

  constructor(data?: ICloudNuggetProfile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.version = _data['version']
      if (Array.isArray(_data['skills'])) {
        this.skills = [] as any
        for (let item of _data['skills'])
          this.skills!.push(CloudNuggetSkill.fromJS(item))
      }
      if (Array.isArray(_data['apiVersions'])) {
        this.apiVersions = [] as any
        for (let item of _data['apiVersions']) this.apiVersions!.push(item)
      }
    }
  }

  static fromJS(data: any): CloudNuggetProfile {
    data = typeof data === 'object' ? data : {}
    let result = new CloudNuggetProfile()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['version'] = this.version
    if (Array.isArray(this.skills)) {
      data['skills'] = []
      for (let item of this.skills) data['skills'].push(item.toJSON())
    }
    if (Array.isArray(this.apiVersions)) {
      data['apiVersions'] = []
      for (let item of this.apiVersions) data['apiVersions'].push(item)
    }
    return data
  }
}

export interface ICloudNuggetProfile {
  /** The Cloud-Nugget specific version number, can be any string and should help the caller to identify the version */
  version?: string
  /** The supported Cloud-Nugget skills */
  skills?: CloudNuggetSkill[]
  /** The basic route to the API versions, can be '1' for '/1/<...>' or 'v1' for '/v1/<...>, the '/s1/cloud-nugget/openapi/' has to provide an OpenAPI document for every listed version */
  apiVersions?: string[]
}

export class CloudNuggetSkill implements ICloudNuggetSkill {
  /** A Skill is defined by a unique name that is registered in the Cloud-Nuggets skill database */
  name?: string
  /** The version of the Skill */
  version?: string

  constructor(data?: ICloudNuggetSkill) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name']
      this.version = _data['version']
    }
  }

  static fromJS(data: any): CloudNuggetSkill {
    data = typeof data === 'object' ? data : {}
    let result = new CloudNuggetSkill()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['version'] = this.version
    return data
  }
}

export interface ICloudNuggetSkill {
  /** A Skill is defined by a unique name that is registered in the Cloud-Nuggets skill database */
  name?: string
  /** The version of the Skill */
  version?: string
}

export class Login implements ILogin {
  username!: string
  password!: string

  constructor(data?: ILogin) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.username = _data['username']
      this.password = _data['password']
    }
  }

  static fromJS(data: any): Login {
    data = typeof data === 'object' ? data : {}
    let result = new Login()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['username'] = this.username
    data['password'] = this.password
    return data
  }
}

export interface ILogin {
  username: string
  password: string
}

export class Login2FA implements ILogin2FA {
  twoFactorCode!: string

  constructor(data?: ILogin2FA) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.twoFactorCode = _data['twoFactorCode']
    }
  }

  static fromJS(data: any): Login2FA {
    data = typeof data === 'object' ? data : {}
    let result = new Login2FA()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['twoFactorCode'] = this.twoFactorCode
    return data
  }
}

export interface ILogin2FA {
  twoFactorCode: string
}

export class AuthenticatorConnectInfo implements IAuthenticatorConnectInfo {
  readonly sharedKey?: string
  readonly authenticatorUri?: string

  constructor(data?: IAuthenticatorConnectInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).sharedKey = _data['sharedKey']
      ;(<any>this).authenticatorUri = _data['authenticatorUri']
    }
  }

  static fromJS(data: any): AuthenticatorConnectInfo {
    data = typeof data === 'object' ? data : {}
    let result = new AuthenticatorConnectInfo()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['sharedKey'] = this.sharedKey
    data['authenticatorUri'] = this.authenticatorUri
    return data
  }
}

export interface IAuthenticatorConnectInfo {
  sharedKey?: string
  authenticatorUri?: string
}

export class Enable2FA implements IEnable2FA {
  username!: string
  password!: string
  code!: string

  constructor(data?: IEnable2FA) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.username = _data['username']
      this.password = _data['password']
      this.code = _data['code']
    }
  }

  static fromJS(data: any): Enable2FA {
    data = typeof data === 'object' ? data : {}
    let result = new Enable2FA()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['username'] = this.username
    data['password'] = this.password
    data['code'] = this.code
    return data
  }
}

export interface IEnable2FA {
  username: string
  password: string
  code: string
}

export class Enable2FAResponse implements IEnable2FAResponse {
  readonly recoveryCodes?: string[]

  constructor(data?: IEnable2FAResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['recoveryCodes'])) {
        ;(<any>this).recoveryCodes = [] as any
        for (let item of _data['recoveryCodes'])
          (<any>this).recoveryCodes!.push(item)
      }
    }
  }

  static fromJS(data: any): Enable2FAResponse {
    data = typeof data === 'object' ? data : {}
    let result = new Enable2FAResponse()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.recoveryCodes)) {
      data['recoveryCodes'] = []
      for (let item of this.recoveryCodes) data['recoveryCodes'].push(item)
    }
    return data
  }
}

export interface IEnable2FAResponse {
  recoveryCodes?: string[]
}

export class ChangeCurrentPassword implements IChangeCurrentPassword {
  password!: string

  constructor(data?: IChangeCurrentPassword) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.password = _data['password']
    }
  }

  static fromJS(data: any): ChangeCurrentPassword {
    data = typeof data === 'object' ? data : {}
    let result = new ChangeCurrentPassword()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['password'] = this.password
    return data
  }
}

export interface IChangeCurrentPassword {
  password: string
}

export class UserInfo_ClaimValue implements IUserInfo_ClaimValue {
  value?: string | undefined
  type?: string | undefined

  constructor(data?: IUserInfo_ClaimValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data['value']
      this.type = _data['type']
    }
  }

  static fromJS(data: any): UserInfo_ClaimValue {
    data = typeof data === 'object' ? data : {}
    let result = new UserInfo_ClaimValue()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['value'] = this.value
    data['type'] = this.type
    return data
  }
}

export interface IUserInfo_ClaimValue {
  value?: string | undefined
  type?: string | undefined
}

export class UserInfo implements IUserInfo {
  id?: string | undefined
  isAuthenticated?: boolean
  nameClaimType?: string | undefined
  roleClaimType?: string | undefined
  givenNameClaimType?: string | undefined
  surnameClaimType?: string | undefined
  claims?: UserInfo_ClaimValue[] | undefined

  constructor(data?: IUserInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.isAuthenticated = _data['isAuthenticated']
      this.nameClaimType = _data['nameClaimType']
      this.roleClaimType = _data['roleClaimType']
      this.givenNameClaimType = _data['givenNameClaimType']
      this.surnameClaimType = _data['surnameClaimType']
      if (Array.isArray(_data['claims'])) {
        this.claims = [] as any
        for (let item of _data['claims'])
          this.claims!.push(UserInfo_ClaimValue.fromJS(item))
      }
    }
  }

  static fromJS(data: any): UserInfo {
    data = typeof data === 'object' ? data : {}
    let result = new UserInfo()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['isAuthenticated'] = this.isAuthenticated
    data['nameClaimType'] = this.nameClaimType
    data['roleClaimType'] = this.roleClaimType
    data['givenNameClaimType'] = this.givenNameClaimType
    data['surnameClaimType'] = this.surnameClaimType
    if (Array.isArray(this.claims)) {
      data['claims'] = []
      for (let item of this.claims) data['claims'].push(item.toJSON())
    }
    return data
  }
}

export interface IUserInfo {
  id?: string | undefined
  isAuthenticated?: boolean
  nameClaimType?: string | undefined
  roleClaimType?: string | undefined
  givenNameClaimType?: string | undefined
  surnameClaimType?: string | undefined
  claims?: UserInfo_ClaimValue[] | undefined
}

export class AvailableTypeDto implements IAvailableTypeDto {
  id?: string | undefined
  name?: string | undefined
  type?: string | undefined
  system?: boolean
  lookupDomain?: string | undefined

  constructor(data?: IAvailableTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.type = _data['type']
      this.system = _data['system']
      this.lookupDomain = _data['lookupDomain']
    }
  }

  static fromJS(data: any): AvailableTypeDto {
    data = typeof data === 'object' ? data : {}
    let result = new AvailableTypeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['type'] = this.type
    data['system'] = this.system
    data['lookupDomain'] = this.lookupDomain
    return data
  }
}

export interface IAvailableTypeDto {
  id?: string | undefined
  name?: string | undefined
  type?: string | undefined
  system?: boolean
  lookupDomain?: string | undefined
}

export class PagedOfAvailableTypeDto implements IPagedOfAvailableTypeDto {
  readonly data?: AvailableTypeDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfAvailableTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(AvailableTypeDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfAvailableTypeDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfAvailableTypeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfAvailableTypeDto {
  data?: AvailableTypeDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export enum PerformedAction {
  Download = 0,
  Checkout = 1,
  Checkin = 2,
  Preview = 3,
  Delete = 4
}

export class DocumentLogEntryDto implements IDocumentLogEntryDto {
  userId?: string
  username?: string | undefined
  createdAt?: Date
  action?: PerformedAction
  text?: string | undefined
  documentId?: string
  documentName?: string | undefined

  constructor(data?: IDocumentLogEntryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId']
      this.username = _data['username']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.action = _data['action']
      this.text = _data['text']
      this.documentId = _data['documentId']
      this.documentName = _data['documentName']
    }
  }

  static fromJS(data: any): DocumentLogEntryDto {
    data = typeof data === 'object' ? data : {}
    let result = new DocumentLogEntryDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['userId'] = this.userId
    data['username'] = this.username
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['action'] = this.action
    data['text'] = this.text
    data['documentId'] = this.documentId
    data['documentName'] = this.documentName
    return data
  }
}

export interface IDocumentLogEntryDto {
  userId?: string
  username?: string | undefined
  createdAt?: Date
  action?: PerformedAction
  text?: string | undefined
  documentId?: string
  documentName?: string | undefined
}

export class PagedOfDocumentLogEntryDto implements IPagedOfDocumentLogEntryDto {
  readonly data?: DocumentLogEntryDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfDocumentLogEntryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(DocumentLogEntryDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfDocumentLogEntryDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfDocumentLogEntryDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfDocumentLogEntryDto {
  data?: DocumentLogEntryDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class SendDocumentsMail_DocumentRecipient
  implements ISendDocumentsMail_DocumentRecipient {
  email?: string | undefined
  receiverType?: number

  constructor(data?: ISendDocumentsMail_DocumentRecipient) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data['email']
      this.receiverType = _data['receiverType']
    }
  }

  static fromJS(data: any): SendDocumentsMail_DocumentRecipient {
    data = typeof data === 'object' ? data : {}
    let result = new SendDocumentsMail_DocumentRecipient()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['email'] = this.email
    data['receiverType'] = this.receiverType
    return data
  }
}

export interface ISendDocumentsMail_DocumentRecipient {
  email?: string | undefined
  receiverType?: number
}

export class RequirableDocument implements IRequirableDocument {
  documentId?: string
  version?: number

  constructor(data?: IRequirableDocument) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.documentId = _data['documentId']
      this.version = _data['version']
    }
  }

  static fromJS(data: any): RequirableDocument {
    data = typeof data === 'object' ? data : {}
    let result = new RequirableDocument()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['documentId'] = this.documentId
    data['version'] = this.version
    return data
  }
}

export interface IRequirableDocument {
  documentId?: string
  version?: number
}

export class SendDocumentsMail implements ISendDocumentsMail {
  documentRecipients?: SendDocumentsMail_DocumentRecipient[] | undefined
  documentsToSend?: RequirableDocument[] | undefined

  constructor(data?: ISendDocumentsMail) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['documentRecipients'])) {
        this.documentRecipients = [] as any
        for (let item of _data['documentRecipients'])
          this.documentRecipients!.push(
            SendDocumentsMail_DocumentRecipient.fromJS(item)
          )
      }
      if (Array.isArray(_data['documentsToSend'])) {
        this.documentsToSend = [] as any
        for (let item of _data['documentsToSend'])
          this.documentsToSend!.push(RequirableDocument.fromJS(item))
      }
    }
  }

  static fromJS(data: any): SendDocumentsMail {
    data = typeof data === 'object' ? data : {}
    let result = new SendDocumentsMail()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.documentRecipients)) {
      data['documentRecipients'] = []
      for (let item of this.documentRecipients)
        data['documentRecipients'].push(item.toJSON())
    }
    if (Array.isArray(this.documentsToSend)) {
      data['documentsToSend'] = []
      for (let item of this.documentsToSend)
        data['documentsToSend'].push(item.toJSON())
    }
    return data
  }
}

export interface ISendDocumentsMail {
  documentRecipients?: SendDocumentsMail_DocumentRecipient[] | undefined
  documentsToSend?: RequirableDocument[] | undefined
}

export class DocumentsMail implements IDocumentsMail {
  recipientFirstname?: string | undefined
  recipientLastname?: string | undefined
  recipientMailAddress?: string | undefined
  mailSubject?: string | undefined
  mialBody?: string | undefined
  mailFolder?: string | undefined
  sendToLeadingLegalSystem?: boolean

  constructor(data?: IDocumentsMail) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.recipientFirstname = _data['recipientFirstname']
      this.recipientLastname = _data['recipientLastname']
      this.recipientMailAddress = _data['recipientMailAddress']
      this.mailSubject = _data['mailSubject']
      this.mialBody = _data['mialBody']
      this.mailFolder = _data['mailFolder']
      this.sendToLeadingLegalSystem = _data['sendToLeadingLegalSystem']
    }
  }

  static fromJS(data: any): DocumentsMail {
    data = typeof data === 'object' ? data : {}
    let result = new DocumentsMail()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['recipientFirstname'] = this.recipientFirstname
    data['recipientLastname'] = this.recipientLastname
    data['recipientMailAddress'] = this.recipientMailAddress
    data['mailSubject'] = this.mailSubject
    data['mialBody'] = this.mialBody
    data['mailFolder'] = this.mailFolder
    data['sendToLeadingLegalSystem'] = this.sendToLeadingLegalSystem
    return data
  }
}

export interface IDocumentsMail {
  recipientFirstname?: string | undefined
  recipientLastname?: string | undefined
  recipientMailAddress?: string | undefined
  mailSubject?: string | undefined
  mialBody?: string | undefined
  mailFolder?: string | undefined
  sendToLeadingLegalSystem?: boolean
}

export class DocumentMailing implements IDocumentMailing {
  mailsToSend?: DocumentsMail[] | undefined
  documents?: RequirableDocument[] | undefined
  sendDocumentsToLeadingLegalSystem?: boolean

  constructor(data?: IDocumentMailing) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['mailsToSend'])) {
        this.mailsToSend = [] as any
        for (let item of _data['mailsToSend'])
          this.mailsToSend!.push(DocumentsMail.fromJS(item))
      }
      if (Array.isArray(_data['documents'])) {
        this.documents = [] as any
        for (let item of _data['documents'])
          this.documents!.push(RequirableDocument.fromJS(item))
      }
      this.sendDocumentsToLeadingLegalSystem =
        _data['sendDocumentsToLeadingLegalSystem']
    }
  }

  static fromJS(data: any): DocumentMailing {
    data = typeof data === 'object' ? data : {}
    let result = new DocumentMailing()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.mailsToSend)) {
      data['mailsToSend'] = []
      for (let item of this.mailsToSend) data['mailsToSend'].push(item.toJSON())
    }
    if (Array.isArray(this.documents)) {
      data['documents'] = []
      for (let item of this.documents) data['documents'].push(item.toJSON())
    }
    data[
      'sendDocumentsToLeadingLegalSystem'
    ] = this.sendDocumentsToLeadingLegalSystem
    return data
  }
}

export interface IDocumentMailing {
  mailsToSend?: DocumentsMail[] | undefined
  documents?: RequirableDocument[] | undefined
  sendDocumentsToLeadingLegalSystem?: boolean
}

export enum DocumentStatus {
  NoFileUploaded = 0,
  CheckedIn = 1,
  CheckedOut = 2
}

export class DocumentDto implements IDocumentDto {
  id?: string
  filename?: string | undefined
  isFinal?: boolean
  status?: DocumentStatus
  metadata?: string | undefined
  createdAt?: Date
  currentVersion?: number
  currentFilesize?: number
  extension?: string | undefined
  checkedOutAt?: Date | undefined
  checkedOutBy?: string | undefined

  constructor(data?: IDocumentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.filename = _data['filename']
      this.isFinal = _data['isFinal']
      this.status = _data['status']
      this.metadata = _data['metadata']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.currentVersion = _data['currentVersion']
      this.currentFilesize = _data['currentFilesize']
      this.extension = _data['extension']
      this.checkedOutAt = _data['checkedOutAt']
        ? new Date(_data['checkedOutAt'].toString())
        : <any>undefined
      this.checkedOutBy = _data['checkedOutBy']
    }
  }

  static fromJS(data: any): DocumentDto {
    data = typeof data === 'object' ? data : {}
    let result = new DocumentDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['filename'] = this.filename
    data['isFinal'] = this.isFinal
    data['status'] = this.status
    data['metadata'] = this.metadata
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['currentVersion'] = this.currentVersion
    data['currentFilesize'] = this.currentFilesize
    data['extension'] = this.extension
    data['checkedOutAt'] = this.checkedOutAt
      ? this.checkedOutAt.toISOString()
      : <any>undefined
    data['checkedOutBy'] = this.checkedOutBy
    return data
  }
}

export interface IDocumentDto {
  id?: string
  filename?: string | undefined
  isFinal?: boolean
  status?: DocumentStatus
  metadata?: string | undefined
  createdAt?: Date
  currentVersion?: number
  currentFilesize?: number
  extension?: string | undefined
  checkedOutAt?: Date | undefined
  checkedOutBy?: string | undefined
}

export class BasicDocumentDto implements IBasicDocumentDto {
  id?: string
  filename?: string | undefined
  currentFilesize?: number
  extension?: string | undefined

  constructor(data?: IBasicDocumentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.filename = _data['filename']
      this.currentFilesize = _data['currentFilesize']
      this.extension = _data['extension']
    }
  }

  static fromJS(data: any): BasicDocumentDto {
    data = typeof data === 'object' ? data : {}
    let result = new BasicDocumentDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['filename'] = this.filename
    data['currentFilesize'] = this.currentFilesize
    data['extension'] = this.extension
    return data
  }
}

export interface IBasicDocumentDto {
  id?: string
  filename?: string | undefined
  currentFilesize?: number
  extension?: string | undefined
}

export class DocumentNamePartDto implements IDocumentNamePartDto {
  order?: number
  value?: string | undefined

  constructor(data?: IDocumentNamePartDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.order = _data['order']
      this.value = _data['value']
    }
  }

  static fromJS(data: any): DocumentNamePartDto {
    data = typeof data === 'object' ? data : {}
    let result = new DocumentNamePartDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['order'] = this.order
    data['value'] = this.value
    return data
  }
}

export interface IDocumentNamePartDto {
  order?: number
  value?: string | undefined
}

export class DocumentSpecification implements IDocumentSpecification {
  filenameParts?: DocumentNamePartDto[] | undefined
  extension?: string | undefined
  metadata?: string | undefined
  assignedFolders?: string[] | undefined
  marker?: string | undefined

  constructor(data?: IDocumentSpecification) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['filenameParts'])) {
        this.filenameParts = [] as any
        for (let item of _data['filenameParts'])
          this.filenameParts!.push(DocumentNamePartDto.fromJS(item))
      }
      this.extension = _data['extension']
      this.metadata = _data['metadata']
      if (Array.isArray(_data['assignedFolders'])) {
        this.assignedFolders = [] as any
        for (let item of _data['assignedFolders'])
          this.assignedFolders!.push(item)
      }
      this.marker = _data['marker']
    }
  }

  static fromJS(data: any): DocumentSpecification {
    data = typeof data === 'object' ? data : {}
    let result = new DocumentSpecification()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.filenameParts)) {
      data['filenameParts'] = []
      for (let item of this.filenameParts)
        data['filenameParts'].push(item.toJSON())
    }
    data['extension'] = this.extension
    data['metadata'] = this.metadata
    if (Array.isArray(this.assignedFolders)) {
      data['assignedFolders'] = []
      for (let item of this.assignedFolders) data['assignedFolders'].push(item)
    }
    data['marker'] = this.marker
    return data
  }
}

export interface IDocumentSpecification {
  filenameParts?: DocumentNamePartDto[] | undefined
  extension?: string | undefined
  metadata?: string | undefined
  assignedFolders?: string[] | undefined
  marker?: string | undefined
}

export class DocumentsRequestDto implements IDocumentsRequestDto {
  folderIds?: string[] | undefined
  documentIds?: string[] | undefined

  constructor(data?: IDocumentsRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['folderIds'])) {
        this.folderIds = [] as any
        for (let item of _data['folderIds']) this.folderIds!.push(item)
      }
      if (Array.isArray(_data['documentIds'])) {
        this.documentIds = [] as any
        for (let item of _data['documentIds']) this.documentIds!.push(item)
      }
    }
  }

  static fromJS(data: any): DocumentsRequestDto {
    data = typeof data === 'object' ? data : {}
    let result = new DocumentsRequestDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.folderIds)) {
      data['folderIds'] = []
      for (let item of this.folderIds) data['folderIds'].push(item)
    }
    if (Array.isArray(this.documentIds)) {
      data['documentIds'] = []
      for (let item of this.documentIds) data['documentIds'].push(item)
    }
    return data
  }
}

export interface IDocumentsRequestDto {
  folderIds?: string[] | undefined
  documentIds?: string[] | undefined
}

export class DocumentVersionDto implements IDocumentVersionDto {
  readonly id?: string
  version?: number
  filesize?: number
  createdAt?: Date

  constructor(data?: IDocumentVersionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).id = _data['id']
      this.version = _data['version']
      this.filesize = _data['filesize']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): DocumentVersionDto {
    data = typeof data === 'object' ? data : {}
    let result = new DocumentVersionDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['version'] = this.version
    data['filesize'] = this.filesize
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    return data
  }
}

export interface IDocumentVersionDto {
  id?: string
  version?: number
  filesize?: number
  createdAt?: Date
}

export class DocumentsFoldersDto implements IDocumentsFoldersDto {
  prefix?: number
  caseFolderId?: string

  constructor(data?: IDocumentsFoldersDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.prefix = _data['prefix']
      this.caseFolderId = _data['caseFolderId']
    }
  }

  static fromJS(data: any): DocumentsFoldersDto {
    data = typeof data === 'object' ? data : {}
    let result = new DocumentsFoldersDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['prefix'] = this.prefix
    data['caseFolderId'] = this.caseFolderId
    return data
  }
}

export interface IDocumentsFoldersDto {
  prefix?: number
  caseFolderId?: string
}

export class DocumentDetailDto implements IDocumentDetailDto {
  id?: string
  filename?: string | undefined
  isFinal?: boolean
  status?: DocumentStatus
  metadata?: string | undefined
  createdAt?: Date
  currentVersion?: number
  currentFilesize?: number
  extension?: string | undefined
  checkedOutAt?: Date | undefined
  checkedOutBy?: string | undefined
  filenameParts?: DocumentNamePartDto[] | undefined
  versions?: DocumentVersionDto[] | undefined
  assignedFolders?: DocumentsFoldersDto[] | undefined

  constructor(data?: IDocumentDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.filename = _data['filename']
      this.isFinal = _data['isFinal']
      this.status = _data['status']
      this.metadata = _data['metadata']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.currentVersion = _data['currentVersion']
      this.currentFilesize = _data['currentFilesize']
      this.extension = _data['extension']
      this.checkedOutAt = _data['checkedOutAt']
        ? new Date(_data['checkedOutAt'].toString())
        : <any>undefined
      this.checkedOutBy = _data['checkedOutBy']
      if (Array.isArray(_data['filenameParts'])) {
        this.filenameParts = [] as any
        for (let item of _data['filenameParts'])
          this.filenameParts!.push(DocumentNamePartDto.fromJS(item))
      }
      if (Array.isArray(_data['versions'])) {
        this.versions = [] as any
        for (let item of _data['versions'])
          this.versions!.push(DocumentVersionDto.fromJS(item))
      }
      if (Array.isArray(_data['assignedFolders'])) {
        this.assignedFolders = [] as any
        for (let item of _data['assignedFolders'])
          this.assignedFolders!.push(DocumentsFoldersDto.fromJS(item))
      }
    }
  }

  static fromJS(data: any): DocumentDetailDto {
    data = typeof data === 'object' ? data : {}
    let result = new DocumentDetailDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['filename'] = this.filename
    data['isFinal'] = this.isFinal
    data['status'] = this.status
    data['metadata'] = this.metadata
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['currentVersion'] = this.currentVersion
    data['currentFilesize'] = this.currentFilesize
    data['extension'] = this.extension
    data['checkedOutAt'] = this.checkedOutAt
      ? this.checkedOutAt.toISOString()
      : <any>undefined
    data['checkedOutBy'] = this.checkedOutBy
    if (Array.isArray(this.filenameParts)) {
      data['filenameParts'] = []
      for (let item of this.filenameParts)
        data['filenameParts'].push(item.toJSON())
    }
    if (Array.isArray(this.versions)) {
      data['versions'] = []
      for (let item of this.versions) data['versions'].push(item.toJSON())
    }
    if (Array.isArray(this.assignedFolders)) {
      data['assignedFolders'] = []
      for (let item of this.assignedFolders)
        data['assignedFolders'].push(item.toJSON())
    }
    return data
  }
}

export interface IDocumentDetailDto {
  id?: string
  filename?: string | undefined
  isFinal?: boolean
  status?: DocumentStatus
  metadata?: string | undefined
  createdAt?: Date
  currentVersion?: number
  currentFilesize?: number
  extension?: string | undefined
  checkedOutAt?: Date | undefined
  checkedOutBy?: string | undefined
  filenameParts?: DocumentNamePartDto[] | undefined
  versions?: DocumentVersionDto[] | undefined
  assignedFolders?: DocumentsFoldersDto[] | undefined
}

export class TemplateMergeResponse implements ITemplateMergeResponse {
  documentId?: string
  notMergedFields?: string[] | undefined

  constructor(data?: ITemplateMergeResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.documentId = _data['documentId']
      if (Array.isArray(_data['notMergedFields'])) {
        this.notMergedFields = [] as any
        for (let item of _data['notMergedFields'])
          this.notMergedFields!.push(item)
      }
    }
  }

  static fromJS(data: any): TemplateMergeResponse {
    data = typeof data === 'object' ? data : {}
    let result = new TemplateMergeResponse()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['documentId'] = this.documentId
    if (Array.isArray(this.notMergedFields)) {
      data['notMergedFields'] = []
      for (let item of this.notMergedFields) data['notMergedFields'].push(item)
    }
    return data
  }
}

export interface ITemplateMergeResponse {
  documentId?: string
  notMergedFields?: string[] | undefined
}

export class CaseFolderDto implements ICaseFolderDto {
  id?: string
  name?: string | undefined
  parentId?: string | undefined
  order?: number
  subfolder?: CaseFolderDto[] | undefined
  isDefault?: boolean

  constructor(data?: ICaseFolderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.parentId = _data['parentId']
      this.order = _data['order']
      if (Array.isArray(_data['subfolder'])) {
        this.subfolder = [] as any
        for (let item of _data['subfolder'])
          this.subfolder!.push(CaseFolderDto.fromJS(item))
      }
      this.isDefault = _data['isDefault']
    }
  }

  static fromJS(data: any): CaseFolderDto {
    data = typeof data === 'object' ? data : {}
    let result = new CaseFolderDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['parentId'] = this.parentId
    data['order'] = this.order
    if (Array.isArray(this.subfolder)) {
      data['subfolder'] = []
      for (let item of this.subfolder) data['subfolder'].push(item.toJSON())
    }
    data['isDefault'] = this.isDefault
    return data
  }
}

export interface ICaseFolderDto {
  id?: string
  name?: string | undefined
  parentId?: string | undefined
  order?: number
  subfolder?: CaseFolderDto[] | undefined
  isDefault?: boolean
}

export class DocumentOrdering implements IDocumentOrdering {
  documentId?: string
  documentName?: string | undefined
  currentFilesize?: number
  order?: number

  constructor(data?: IDocumentOrdering) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.documentId = _data['documentId']
      this.documentName = _data['documentName']
      this.currentFilesize = _data['currentFilesize']
      this.order = _data['order']
    }
  }

  static fromJS(data: any): DocumentOrdering {
    data = typeof data === 'object' ? data : {}
    let result = new DocumentOrdering()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['documentId'] = this.documentId
    data['documentName'] = this.documentName
    data['currentFilesize'] = this.currentFilesize
    data['order'] = this.order
    return data
  }
}

export interface IDocumentOrdering {
  documentId?: string
  documentName?: string | undefined
  currentFilesize?: number
  order?: number
}

export class DocumentOrderingChange implements IDocumentOrderingChange {
  documentId?: string
  order?: number

  constructor(data?: IDocumentOrderingChange) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.documentId = _data['documentId']
      this.order = _data['order']
    }
  }

  static fromJS(data: any): DocumentOrderingChange {
    data = typeof data === 'object' ? data : {}
    let result = new DocumentOrderingChange()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['documentId'] = this.documentId
    data['order'] = this.order
    return data
  }
}

export interface IDocumentOrderingChange {
  documentId?: string
  order?: number
}

export class CaseInterviewShareDto implements ICaseInterviewShareDto {
  id?: string
  caseId?: string
  accessRestriction?: string | undefined
  workflowTaskId?: string
  shareUrl?: string | undefined

  constructor(data?: ICaseInterviewShareDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.caseId = _data['caseId']
      this.accessRestriction = _data['accessRestriction']
      this.workflowTaskId = _data['workflowTaskId']
      this.shareUrl = _data['shareUrl']
    }
  }

  static fromJS(data: any): CaseInterviewShareDto {
    data = typeof data === 'object' ? data : {}
    let result = new CaseInterviewShareDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['caseId'] = this.caseId
    data['accessRestriction'] = this.accessRestriction
    data['workflowTaskId'] = this.workflowTaskId
    data['shareUrl'] = this.shareUrl
    return data
  }
}

export interface ICaseInterviewShareDto {
  id?: string
  caseId?: string
  accessRestriction?: string | undefined
  workflowTaskId?: string
  shareUrl?: string | undefined
}

export enum CaseStatus {
  Draft = 0,
  Open = 1,
  Closed = 2
}

export class CaseDto implements ICaseDto {
  id?: string
  caseTypeId?: string
  createdAt?: Date
  createdBy?: string
  deletedAt?: Date | undefined
  jsonSchema?: string | undefined
  jsonValues?: string | undefined
  modifiedAt?: Date | undefined
  modifiedBy?: string | undefined
  status?: CaseStatus
  caseTypeName?: string | undefined
  blockUpdatesFromLookups?: boolean

  constructor(data?: ICaseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.caseTypeId = _data['caseTypeId']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.createdBy = _data['createdBy']
      this.deletedAt = _data['deletedAt']
        ? new Date(_data['deletedAt'].toString())
        : <any>undefined
      this.jsonSchema = _data['jsonSchema']
      this.jsonValues = _data['jsonValues']
      this.modifiedAt = _data['modifiedAt']
        ? new Date(_data['modifiedAt'].toString())
        : <any>undefined
      this.modifiedBy = _data['modifiedBy']
      this.status = _data['status']
      this.caseTypeName = _data['caseTypeName']
      this.blockUpdatesFromLookups = _data['blockUpdatesFromLookups']
    }
  }

  static fromJS(data: any): CaseDto {
    data = typeof data === 'object' ? data : {}
    let result = new CaseDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['caseTypeId'] = this.caseTypeId
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['createdBy'] = this.createdBy
    data['deletedAt'] = this.deletedAt
      ? this.deletedAt.toISOString()
      : <any>undefined
    data['jsonSchema'] = this.jsonSchema
    data['jsonValues'] = this.jsonValues
    data['modifiedAt'] = this.modifiedAt
      ? this.modifiedAt.toISOString()
      : <any>undefined
    data['modifiedBy'] = this.modifiedBy
    data['status'] = this.status
    data['caseTypeName'] = this.caseTypeName
    data['blockUpdatesFromLookups'] = this.blockUpdatesFromLookups
    return data
  }
}

export interface ICaseDto {
  id?: string
  caseTypeId?: string
  createdAt?: Date
  createdBy?: string
  deletedAt?: Date | undefined
  jsonSchema?: string | undefined
  jsonValues?: string | undefined
  modifiedAt?: Date | undefined
  modifiedBy?: string | undefined
  status?: CaseStatus
  caseTypeName?: string | undefined
  blockUpdatesFromLookups?: boolean
}

export class PagedOfCaseDto implements IPagedOfCaseDto {
  readonly data?: CaseDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfCaseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(CaseDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfCaseDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfCaseDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfCaseDto {
  data?: CaseDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export enum CombinationOperator {
  And = 0,
  Or = 1
}

export enum SearchOperator {
  Equal = 0,
  NotEqual = 1,
  Like = 2,
  GreaterThan = 3,
  GreaterThanOrEqual = 4,
  LessThan = 5,
  LessThanOrEqual = 6
}

export class SearchCondition implements ISearchCondition {
  group?: boolean
  combination?: CombinationOperator
  field?: string | undefined
  operator?: SearchOperator
  value?: string | undefined

  constructor(data?: ISearchCondition) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.group = _data['group']
      this.combination = _data['combination']
      this.field = _data['field']
      this.operator = _data['operator']
      this.value = _data['value']
    }
  }

  static fromJS(data: any): SearchCondition {
    data = typeof data === 'object' ? data : {}
    let result = new SearchCondition()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['group'] = this.group
    data['combination'] = this.combination
    data['field'] = this.field
    data['operator'] = this.operator
    data['value'] = this.value
    return data
  }
}

export interface ISearchCondition {
  group?: boolean
  combination?: CombinationOperator
  field?: string | undefined
  operator?: SearchOperator
  value?: string | undefined
}

export enum SortOrder {
  Ascending = 0,
  Descending = 1
}

export class SortField implements ISortField {
  field?: string | undefined
  order?: SortOrder

  constructor(data?: ISortField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.field = _data['field']
      this.order = _data['order']
    }
  }

  static fromJS(data: any): SortField {
    data = typeof data === 'object' ? data : {}
    let result = new SortField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['field'] = this.field
    data['order'] = this.order
    return data
  }
}

export interface ISortField {
  field?: string | undefined
  order?: SortOrder
}

export class FilteredAndSortedDataRequest
  implements IFilteredAndSortedDataRequest {
  searchConditions?: SearchCondition[] | undefined
  sortFields?: SortField[] | undefined
  page?: number
  pageSize?: number

  constructor(data?: IFilteredAndSortedDataRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['searchConditions'])) {
        this.searchConditions = [] as any
        for (let item of _data['searchConditions'])
          this.searchConditions!.push(SearchCondition.fromJS(item))
      }
      if (Array.isArray(_data['sortFields'])) {
        this.sortFields = [] as any
        for (let item of _data['sortFields'])
          this.sortFields!.push(SortField.fromJS(item))
      }
      this.page = _data['page']
      this.pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): FilteredAndSortedDataRequest {
    data = typeof data === 'object' ? data : {}
    let result = new FilteredAndSortedDataRequest()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.searchConditions)) {
      data['searchConditions'] = []
      for (let item of this.searchConditions)
        data['searchConditions'].push(item.toJSON())
    }
    if (Array.isArray(this.sortFields)) {
      data['sortFields'] = []
      for (let item of this.sortFields) data['sortFields'].push(item.toJSON())
    }
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IFilteredAndSortedDataRequest {
  searchConditions?: SearchCondition[] | undefined
  sortFields?: SortField[] | undefined
  page?: number
  pageSize?: number
}

export class FilteredAndSortedCase implements IFilteredAndSortedCase {
  id?: string
  caseTypeId?: string
  createdAt?: Date
  createdBy?: string
  modifiedAt?: Date | undefined
  modifiedBy?: string | undefined
  status?: CaseStatus
  blockUpdatesFromLookups?: boolean
  jsonSchema?: string | undefined
  jsonValues?: string | undefined
  caseTypeName?: string | undefined
  createdByName?: string | undefined
  modifiedByName?: string | undefined

  constructor(data?: IFilteredAndSortedCase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.caseTypeId = _data['caseTypeId']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.createdBy = _data['createdBy']
      this.modifiedAt = _data['modifiedAt']
        ? new Date(_data['modifiedAt'].toString())
        : <any>undefined
      this.modifiedBy = _data['modifiedBy']
      this.status = _data['status']
      this.blockUpdatesFromLookups = _data['blockUpdatesFromLookups']
      this.jsonSchema = _data['jsonSchema']
      this.jsonValues = _data['jsonValues']
      this.caseTypeName = _data['caseTypeName']
      this.createdByName = _data['createdByName']
      this.modifiedByName = _data['modifiedByName']
    }
  }

  static fromJS(data: any): FilteredAndSortedCase {
    data = typeof data === 'object' ? data : {}
    let result = new FilteredAndSortedCase()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['caseTypeId'] = this.caseTypeId
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['createdBy'] = this.createdBy
    data['modifiedAt'] = this.modifiedAt
      ? this.modifiedAt.toISOString()
      : <any>undefined
    data['modifiedBy'] = this.modifiedBy
    data['status'] = this.status
    data['blockUpdatesFromLookups'] = this.blockUpdatesFromLookups
    data['jsonSchema'] = this.jsonSchema
    data['jsonValues'] = this.jsonValues
    data['caseTypeName'] = this.caseTypeName
    data['createdByName'] = this.createdByName
    data['modifiedByName'] = this.modifiedByName
    return data
  }
}

export interface IFilteredAndSortedCase {
  id?: string
  caseTypeId?: string
  createdAt?: Date
  createdBy?: string
  modifiedAt?: Date | undefined
  modifiedBy?: string | undefined
  status?: CaseStatus
  blockUpdatesFromLookups?: boolean
  jsonSchema?: string | undefined
  jsonValues?: string | undefined
  caseTypeName?: string | undefined
  createdByName?: string | undefined
  modifiedByName?: string | undefined
}

export class PagedOfFilteredAndSortedCase
  implements IPagedOfFilteredAndSortedCase {
  readonly data?: FilteredAndSortedCase[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfFilteredAndSortedCase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(FilteredAndSortedCase.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfFilteredAndSortedCase {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfFilteredAndSortedCase()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfFilteredAndSortedCase {
  data?: FilteredAndSortedCase[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class SimpleSearchCondition implements ISimpleSearchCondition {
  field?: string | undefined
  operator?: SearchOperator
  value?: string | undefined

  constructor(data?: ISimpleSearchCondition) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.field = _data['field']
      this.operator = _data['operator']
      this.value = _data['value']
    }
  }

  static fromJS(data: any): SimpleSearchCondition {
    data = typeof data === 'object' ? data : {}
    let result = new SimpleSearchCondition()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['field'] = this.field
    data['operator'] = this.operator
    data['value'] = this.value
    return data
  }
}

export interface ISimpleSearchCondition {
  field?: string | undefined
  operator?: SearchOperator
  value?: string | undefined
}

export class UpdateCasesFromLookupEntry implements IUpdateCasesFromLookupEntry {
  caseIds?: string[] | undefined
  lookupEntryId?: string

  constructor(data?: IUpdateCasesFromLookupEntry) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['caseIds'])) {
        this.caseIds = [] as any
        for (let item of _data['caseIds']) this.caseIds!.push(item)
      }
      this.lookupEntryId = _data['lookupEntryId']
    }
  }

  static fromJS(data: any): UpdateCasesFromLookupEntry {
    data = typeof data === 'object' ? data : {}
    let result = new UpdateCasesFromLookupEntry()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.caseIds)) {
      data['caseIds'] = []
      for (let item of this.caseIds) data['caseIds'].push(item)
    }
    data['lookupEntryId'] = this.lookupEntryId
    return data
  }
}

export interface IUpdateCasesFromLookupEntry {
  caseIds?: string[] | undefined
  lookupEntryId?: string
}

export class FillCasePropertiesFromLookupEntry
  implements IFillCasePropertiesFromLookupEntry {
  lookupEntryId?: string
  rootPath?: string | undefined
  jsonValues?: string | undefined

  constructor(data?: IFillCasePropertiesFromLookupEntry) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lookupEntryId = _data['lookupEntryId']
      this.rootPath = _data['rootPath']
      this.jsonValues = _data['jsonValues']
    }
  }

  static fromJS(data: any): FillCasePropertiesFromLookupEntry {
    data = typeof data === 'object' ? data : {}
    let result = new FillCasePropertiesFromLookupEntry()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['lookupEntryId'] = this.lookupEntryId
    data['rootPath'] = this.rootPath
    data['jsonValues'] = this.jsonValues
    return data
  }
}

export interface IFillCasePropertiesFromLookupEntry {
  lookupEntryId?: string
  rootPath?: string | undefined
  jsonValues?: string | undefined
}

export class FolderDto implements IFolderDto {
  id?: string | undefined
  name?: string | undefined
  parentId?: string | undefined
  order?: number
  subfolders?: FolderDto[] | undefined
  isDefault?: boolean
  isSystem?: boolean

  constructor(data?: IFolderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.parentId = _data['parentId']
      this.order = _data['order']
      if (Array.isArray(_data['subfolders'])) {
        this.subfolders = [] as any
        for (let item of _data['subfolders'])
          this.subfolders!.push(FolderDto.fromJS(item))
      }
      this.isDefault = _data['isDefault']
      this.isSystem = _data['isSystem']
    }
  }

  static fromJS(data: any): FolderDto {
    data = typeof data === 'object' ? data : {}
    let result = new FolderDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['parentId'] = this.parentId
    data['order'] = this.order
    if (Array.isArray(this.subfolders)) {
      data['subfolders'] = []
      for (let item of this.subfolders) data['subfolders'].push(item.toJSON())
    }
    data['isDefault'] = this.isDefault
    data['isSystem'] = this.isSystem
    return data
  }
}

export interface IFolderDto {
  id?: string | undefined
  name?: string | undefined
  parentId?: string | undefined
  order?: number
  subfolders?: FolderDto[] | undefined
  isDefault?: boolean
  isSystem?: boolean
}

export class CaseTypeDto implements ICaseTypeDto {
  id?: string
  name!: string
  description?: string | undefined

  constructor(data?: ICaseTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.description = _data['description']
    }
  }

  static fromJS(data: any): CaseTypeDto {
    data = typeof data === 'object' ? data : {}
    let result = new CaseTypeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['description'] = this.description
    return data
  }
}

export interface ICaseTypeDto {
  id?: string
  name: string
  description?: string | undefined
}

export class PagedOfCaseTypeDto implements IPagedOfCaseTypeDto {
  readonly data?: CaseTypeDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfCaseTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(CaseTypeDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfCaseTypeDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfCaseTypeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfCaseTypeDto {
  data?: CaseTypeDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export enum PrimitiveType {
  Text = 0,
  Date = 1,
  Number = 2,
  List = 3,
  Boolean = 4,
  File = 5,
  Currency = 6,
  User = 7,
  Folder = 8,
  Script = 9
}

export class FullyQualifiedCompoundTypeDto
  implements IFullyQualifiedCompoundTypeDto {
  fullyQualifiedName?: string | undefined
  type?: PrimitiveType

  constructor(data?: IFullyQualifiedCompoundTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fullyQualifiedName = _data['fullyQualifiedName']
      this.type = _data['type']
    }
  }

  static fromJS(data: any): FullyQualifiedCompoundTypeDto {
    data = typeof data === 'object' ? data : {}
    let result = new FullyQualifiedCompoundTypeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['fullyQualifiedName'] = this.fullyQualifiedName
    data['type'] = this.type
    return data
  }
}

export interface IFullyQualifiedCompoundTypeDto {
  fullyQualifiedName?: string | undefined
  type?: PrimitiveType
}

export enum CaseWorkflowStatus {
  Created = 0,
  Active = 1,
  Canceled = 2,
  Completed = 3
}

export enum EscalationType {
  Duration = 0,
  PointInTime = 1
}

export enum DecisionType {
  Normal = 0,
  DispatchApproval = 1,
  Draft = 2
}

export enum CaseWorkflowStepPriority {
  Normal = 0,
  Important = 1,
  Urgent = 2
}

export enum WorkflowTaskExecutor {
  Role = 0,
  User = 1,
  Associate = 2,
  Clerk = 3
}

export enum WorkflowTaskEscalationExecutor {
  User = 0,
  Associate = 1,
  Clerk = 2
}

export class CaseWorkflowStepDto implements ICaseWorkflowStepDto {
  id?: string
  createdAt?: Date
  createdBy?: string | undefined
  modifiedAt?: Date
  modifiedBy?: string | undefined
  parentDiagramReference?: string | undefined
  diagramReference?: string | undefined
  userId?: string | undefined
  roleId?: string | undefined
  tariffType?: string | undefined
  activityUnit?: string | undefined
  costs?: number
  jsonDefinition?: string | undefined
  escalationType?: EscalationType
  decisionType?: DecisionType
  escalationUserId?: string | undefined
  escalationDate?: Date | undefined
  escalationDurationDays?: number | undefined
  escalationDurationHours?: number | undefined
  priority?: CaseWorkflowStepPriority
  xml?: string | undefined
  type?: string | undefined
  executionBy?: WorkflowTaskExecutor
  escalationExecutionBy?: WorkflowTaskEscalationExecutor

  constructor(data?: ICaseWorkflowStepDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.createdBy = _data['createdBy']
      this.modifiedAt = _data['modifiedAt']
        ? new Date(_data['modifiedAt'].toString())
        : <any>undefined
      this.modifiedBy = _data['modifiedBy']
      this.parentDiagramReference = _data['parentDiagramReference']
      this.diagramReference = _data['diagramReference']
      this.userId = _data['userId']
      this.roleId = _data['roleId']
      this.tariffType = _data['tariffType']
      this.activityUnit = _data['activityUnit']
      this.costs = _data['costs']
      this.jsonDefinition = _data['jsonDefinition']
      this.escalationType = _data['escalationType']
      this.decisionType = _data['decisionType']
      this.escalationUserId = _data['escalationUserId']
      this.escalationDate = _data['escalationDate']
        ? new Date(_data['escalationDate'].toString())
        : <any>undefined
      this.escalationDurationDays = _data['escalationDurationDays']
      this.escalationDurationHours = _data['escalationDurationHours']
      this.priority = _data['priority']
      this.xml = _data['xml']
      this.type = _data['type']
      this.executionBy = _data['executionBy']
      this.escalationExecutionBy = _data['escalationExecutionBy']
    }
  }

  static fromJS(data: any): CaseWorkflowStepDto {
    data = typeof data === 'object' ? data : {}
    let result = new CaseWorkflowStepDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['createdBy'] = this.createdBy
    data['modifiedAt'] = this.modifiedAt
      ? this.modifiedAt.toISOString()
      : <any>undefined
    data['modifiedBy'] = this.modifiedBy
    data['parentDiagramReference'] = this.parentDiagramReference
    data['diagramReference'] = this.diagramReference
    data['userId'] = this.userId
    data['roleId'] = this.roleId
    data['tariffType'] = this.tariffType
    data['activityUnit'] = this.activityUnit
    data['costs'] = this.costs
    data['jsonDefinition'] = this.jsonDefinition
    data['escalationType'] = this.escalationType
    data['decisionType'] = this.decisionType
    data['escalationUserId'] = this.escalationUserId
    data['escalationDate'] = this.escalationDate
      ? this.escalationDate.toISOString()
      : <any>undefined
    data['escalationDurationDays'] = this.escalationDurationDays
    data['escalationDurationHours'] = this.escalationDurationHours
    data['priority'] = this.priority
    data['xml'] = this.xml
    data['type'] = this.type
    data['executionBy'] = this.executionBy
    data['escalationExecutionBy'] = this.escalationExecutionBy
    return data
  }
}

export interface ICaseWorkflowStepDto {
  id?: string
  createdAt?: Date
  createdBy?: string | undefined
  modifiedAt?: Date
  modifiedBy?: string | undefined
  parentDiagramReference?: string | undefined
  diagramReference?: string | undefined
  userId?: string | undefined
  roleId?: string | undefined
  tariffType?: string | undefined
  activityUnit?: string | undefined
  costs?: number
  jsonDefinition?: string | undefined
  escalationType?: EscalationType
  decisionType?: DecisionType
  escalationUserId?: string | undefined
  escalationDate?: Date | undefined
  escalationDurationDays?: number | undefined
  escalationDurationHours?: number | undefined
  priority?: CaseWorkflowStepPriority
  xml?: string | undefined
  type?: string | undefined
  executionBy?: WorkflowTaskExecutor
  escalationExecutionBy?: WorkflowTaskEscalationExecutor
}

export class CaseWorkflowDto implements ICaseWorkflowDto {
  id?: string
  createdAt?: Date
  createdBy?: string | undefined
  modifiedAt?: Date
  modifiedBy?: string | undefined
  caseId?: string
  name?: string | undefined
  activeStepDiagramReference?: string | undefined
  activeStepParentDiagramReference?: string | undefined
  xml?: string | undefined
  status?: CaseWorkflowStatus
  steps?: CaseWorkflowStepDto[] | undefined

  constructor(data?: ICaseWorkflowDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.createdBy = _data['createdBy']
      this.modifiedAt = _data['modifiedAt']
        ? new Date(_data['modifiedAt'].toString())
        : <any>undefined
      this.modifiedBy = _data['modifiedBy']
      this.caseId = _data['caseId']
      this.name = _data['name']
      this.activeStepDiagramReference = _data['activeStepDiagramReference']
      this.activeStepParentDiagramReference =
        _data['activeStepParentDiagramReference']
      this.xml = _data['xml']
      this.status = _data['status']
      if (Array.isArray(_data['steps'])) {
        this.steps = [] as any
        for (let item of _data['steps'])
          this.steps!.push(CaseWorkflowStepDto.fromJS(item))
      }
    }
  }

  static fromJS(data: any): CaseWorkflowDto {
    data = typeof data === 'object' ? data : {}
    let result = new CaseWorkflowDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['createdBy'] = this.createdBy
    data['modifiedAt'] = this.modifiedAt
      ? this.modifiedAt.toISOString()
      : <any>undefined
    data['modifiedBy'] = this.modifiedBy
    data['caseId'] = this.caseId
    data['name'] = this.name
    data['activeStepDiagramReference'] = this.activeStepDiagramReference
    data[
      'activeStepParentDiagramReference'
    ] = this.activeStepParentDiagramReference
    data['xml'] = this.xml
    data['status'] = this.status
    if (Array.isArray(this.steps)) {
      data['steps'] = []
      for (let item of this.steps) data['steps'].push(item.toJSON())
    }
    return data
  }
}

export interface ICaseWorkflowDto {
  id?: string
  createdAt?: Date
  createdBy?: string | undefined
  modifiedAt?: Date
  modifiedBy?: string | undefined
  caseId?: string
  name?: string | undefined
  activeStepDiagramReference?: string | undefined
  activeStepParentDiagramReference?: string | undefined
  xml?: string | undefined
  status?: CaseWorkflowStatus
  steps?: CaseWorkflowStepDto[] | undefined
}

export enum TransitionReason {
  Escalated = 0,
  Delegated = 1,
  FollowUp = 2
}

export class TimeSpan implements ITimeSpan {
  readonly ticks?: number
  readonly days?: number
  readonly hours?: number
  readonly milliseconds?: number
  readonly minutes?: number
  readonly seconds?: number
  readonly totalDays?: number
  readonly totalHours?: number
  readonly totalMilliseconds?: number
  readonly totalMinutes?: number
  readonly totalSeconds?: number

  constructor(data?: ITimeSpan) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).ticks = _data['ticks']
      ;(<any>this).days = _data['days']
      ;(<any>this).hours = _data['hours']
      ;(<any>this).milliseconds = _data['milliseconds']
      ;(<any>this).minutes = _data['minutes']
      ;(<any>this).seconds = _data['seconds']
      ;(<any>this).totalDays = _data['totalDays']
      ;(<any>this).totalHours = _data['totalHours']
      ;(<any>this).totalMilliseconds = _data['totalMilliseconds']
      ;(<any>this).totalMinutes = _data['totalMinutes']
      ;(<any>this).totalSeconds = _data['totalSeconds']
    }
  }

  static fromJS(data: any): TimeSpan {
    data = typeof data === 'object' ? data : {}
    let result = new TimeSpan()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['ticks'] = this.ticks
    data['days'] = this.days
    data['hours'] = this.hours
    data['milliseconds'] = this.milliseconds
    data['minutes'] = this.minutes
    data['seconds'] = this.seconds
    data['totalDays'] = this.totalDays
    data['totalHours'] = this.totalHours
    data['totalMilliseconds'] = this.totalMilliseconds
    data['totalMinutes'] = this.totalMinutes
    data['totalSeconds'] = this.totalSeconds
    return data
  }
}

export interface ITimeSpan {
  ticks?: number
  days?: number
  hours?: number
  milliseconds?: number
  minutes?: number
  seconds?: number
  totalDays?: number
  totalHours?: number
  totalMilliseconds?: number
  totalMinutes?: number
  totalSeconds?: number
}

export class CaseWorkflowLogDto implements ICaseWorkflowLogDto {
  name?: string | undefined
  description?: string | undefined
  type?: string | undefined
  userId?: string | undefined
  escalatedUserId?: string | undefined
  followUpAt?: Date | undefined
  autoEscalateOnFollowUp?: boolean
  comment?: string | undefined
  jsonValues?: string | undefined
  reason?: TransitionReason
  executionBy?: WorkflowTaskExecutor
  createdAt?: Date
  modifiedAt?: Date
  duration?: TimeSpan

  constructor(data?: ICaseWorkflowLogDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name']
      this.description = _data['description']
      this.type = _data['type']
      this.userId = _data['userId']
      this.escalatedUserId = _data['escalatedUserId']
      this.followUpAt = _data['followUpAt']
        ? new Date(_data['followUpAt'].toString())
        : <any>undefined
      this.autoEscalateOnFollowUp = _data['autoEscalateOnFollowUp']
      this.comment = _data['comment']
      this.jsonValues = _data['jsonValues']
      this.reason = _data['reason']
      this.executionBy = _data['executionBy']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.modifiedAt = _data['modifiedAt']
        ? new Date(_data['modifiedAt'].toString())
        : <any>undefined
      this.duration = _data['duration']
        ? TimeSpan.fromJS(_data['duration'])
        : <any>undefined
    }
  }

  static fromJS(data: any): CaseWorkflowLogDto {
    data = typeof data === 'object' ? data : {}
    let result = new CaseWorkflowLogDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['description'] = this.description
    data['type'] = this.type
    data['userId'] = this.userId
    data['escalatedUserId'] = this.escalatedUserId
    data['followUpAt'] = this.followUpAt
      ? this.followUpAt.toISOString()
      : <any>undefined
    data['autoEscalateOnFollowUp'] = this.autoEscalateOnFollowUp
    data['comment'] = this.comment
    data['jsonValues'] = this.jsonValues
    data['reason'] = this.reason
    data['executionBy'] = this.executionBy
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['modifiedAt'] = this.modifiedAt
      ? this.modifiedAt.toISOString()
      : <any>undefined
    data['duration'] = this.duration ? this.duration.toJSON() : <any>undefined
    return data
  }
}

export interface ICaseWorkflowLogDto {
  name?: string | undefined
  description?: string | undefined
  type?: string | undefined
  userId?: string | undefined
  escalatedUserId?: string | undefined
  followUpAt?: Date | undefined
  autoEscalateOnFollowUp?: boolean
  comment?: string | undefined
  jsonValues?: string | undefined
  reason?: TransitionReason
  executionBy?: WorkflowTaskExecutor
  createdAt?: Date
  modifiedAt?: Date
  duration?: TimeSpan
}

export class CompoundTypeItemDto implements ICompoundTypeItemDto {
  id?: string | undefined
  name?: string | undefined
  compoundTypeId?: string | undefined
  itemTypeId?: string | undefined
  itemType?: string | undefined
  order?: number
  system?: boolean
  forLookupUniqueness?: boolean
  forSummary?: boolean
  key?: string | undefined

  constructor(data?: ICompoundTypeItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.compoundTypeId = _data['compoundTypeId']
      this.itemTypeId = _data['itemTypeId']
      this.itemType = _data['itemType']
      this.order = _data['order']
      this.system = _data['system']
      this.forLookupUniqueness = _data['forLookupUniqueness']
      this.forSummary = _data['forSummary']
      this.key = _data['key']
    }
  }

  static fromJS(data: any): CompoundTypeItemDto {
    data = typeof data === 'object' ? data : {}
    let result = new CompoundTypeItemDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['compoundTypeId'] = this.compoundTypeId
    data['itemTypeId'] = this.itemTypeId
    data['itemType'] = this.itemType
    data['order'] = this.order
    data['system'] = this.system
    data['forLookupUniqueness'] = this.forLookupUniqueness
    data['forSummary'] = this.forSummary
    data['key'] = this.key
    return data
  }
}

export interface ICompoundTypeItemDto {
  id?: string | undefined
  name?: string | undefined
  compoundTypeId?: string | undefined
  itemTypeId?: string | undefined
  itemType?: string | undefined
  order?: number
  system?: boolean
  forLookupUniqueness?: boolean
  forSummary?: boolean
  key?: string | undefined
}

export class CompoundTypeDto implements ICompoundTypeDto {
  id?: string | undefined
  name?: string | undefined
  description?: string | undefined
  caseTypeId?: string | undefined
  caseTypeName?: string | undefined
  isBasicData?: boolean
  system?: boolean
  items?: CompoundTypeItemDto[] | undefined
  area?: string | undefined
  subarea?: number | undefined
  order?: number | undefined
  key?: string | undefined
  lookupId?: string | undefined
  lookupDomain?: string | undefined
  lookupOrder?: number | undefined
  forSummary?: boolean
  summaryColor?: string | undefined

  constructor(data?: ICompoundTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.description = _data['description']
      this.caseTypeId = _data['caseTypeId']
      this.caseTypeName = _data['caseTypeName']
      this.isBasicData = _data['isBasicData']
      this.system = _data['system']
      if (Array.isArray(_data['items'])) {
        this.items = [] as any
        for (let item of _data['items'])
          this.items!.push(CompoundTypeItemDto.fromJS(item))
      }
      this.area = _data['area']
      this.subarea = _data['subarea']
      this.order = _data['order']
      this.key = _data['key']
      this.lookupId = _data['lookupId']
      this.lookupDomain = _data['lookupDomain']
      this.lookupOrder = _data['lookupOrder']
      this.forSummary = _data['forSummary']
      this.summaryColor = _data['summaryColor']
    }
  }

  static fromJS(data: any): CompoundTypeDto {
    data = typeof data === 'object' ? data : {}
    let result = new CompoundTypeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['description'] = this.description
    data['caseTypeId'] = this.caseTypeId
    data['caseTypeName'] = this.caseTypeName
    data['isBasicData'] = this.isBasicData
    data['system'] = this.system
    if (Array.isArray(this.items)) {
      data['items'] = []
      for (let item of this.items) data['items'].push(item.toJSON())
    }
    data['area'] = this.area
    data['subarea'] = this.subarea
    data['order'] = this.order
    data['key'] = this.key
    data['lookupId'] = this.lookupId
    data['lookupDomain'] = this.lookupDomain
    data['lookupOrder'] = this.lookupOrder
    data['forSummary'] = this.forSummary
    data['summaryColor'] = this.summaryColor
    return data
  }
}

export interface ICompoundTypeDto {
  id?: string | undefined
  name?: string | undefined
  description?: string | undefined
  caseTypeId?: string | undefined
  caseTypeName?: string | undefined
  isBasicData?: boolean
  system?: boolean
  items?: CompoundTypeItemDto[] | undefined
  area?: string | undefined
  subarea?: number | undefined
  order?: number | undefined
  key?: string | undefined
  lookupId?: string | undefined
  lookupDomain?: string | undefined
  lookupOrder?: number | undefined
  forSummary?: boolean
  summaryColor?: string | undefined
}

export class PagedOfCompoundTypeDto implements IPagedOfCompoundTypeDto {
  readonly data?: CompoundTypeDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfCompoundTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(CompoundTypeDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfCompoundTypeDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfCompoundTypeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfCompoundTypeDto {
  data?: CompoundTypeDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class CreateCompoundType_CompoundTypeItem
  implements ICreateCompoundType_CompoundTypeItem {
  name?: string | undefined
  itemTypeId?: string | undefined
  itemType?: string | undefined
  order?: number
  forLookupUniqueness?: boolean
  forSummary?: boolean

  constructor(data?: ICreateCompoundType_CompoundTypeItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name']
      this.itemTypeId = _data['itemTypeId']
      this.itemType = _data['itemType']
      this.order = _data['order']
      this.forLookupUniqueness = _data['forLookupUniqueness']
      this.forSummary = _data['forSummary']
    }
  }

  static fromJS(data: any): CreateCompoundType_CompoundTypeItem {
    data = typeof data === 'object' ? data : {}
    let result = new CreateCompoundType_CompoundTypeItem()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['itemTypeId'] = this.itemTypeId
    data['itemType'] = this.itemType
    data['order'] = this.order
    data['forLookupUniqueness'] = this.forLookupUniqueness
    data['forSummary'] = this.forSummary
    return data
  }
}

export interface ICreateCompoundType_CompoundTypeItem {
  name?: string | undefined
  itemTypeId?: string | undefined
  itemType?: string | undefined
  order?: number
  forLookupUniqueness?: boolean
  forSummary?: boolean
}

export class CreateCompoundType implements ICreateCompoundType {
  id?: string | undefined
  name?: string | undefined
  description?: string | undefined
  items?: CreateCompoundType_CompoundTypeItem[] | undefined
  basicData?: boolean
  caseTypeId?: string | undefined
  area?: string | undefined
  subarea?: number | undefined
  order?: number | undefined
  lookupDomain?: string | undefined
  lookupOrder?: number | undefined
  forSummary?: boolean
  summaryColor?: string | undefined

  constructor(data?: ICreateCompoundType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.description = _data['description']
      if (Array.isArray(_data['items'])) {
        this.items = [] as any
        for (let item of _data['items'])
          this.items!.push(CreateCompoundType_CompoundTypeItem.fromJS(item))
      }
      this.basicData = _data['basicData']
      this.caseTypeId = _data['caseTypeId']
      this.area = _data['area']
      this.subarea = _data['subarea']
      this.order = _data['order']
      this.lookupDomain = _data['lookupDomain']
      this.lookupOrder = _data['lookupOrder']
      this.forSummary = _data['forSummary']
      this.summaryColor = _data['summaryColor']
    }
  }

  static fromJS(data: any): CreateCompoundType {
    data = typeof data === 'object' ? data : {}
    let result = new CreateCompoundType()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['description'] = this.description
    if (Array.isArray(this.items)) {
      data['items'] = []
      for (let item of this.items) data['items'].push(item.toJSON())
    }
    data['basicData'] = this.basicData
    data['caseTypeId'] = this.caseTypeId
    data['area'] = this.area
    data['subarea'] = this.subarea
    data['order'] = this.order
    data['lookupDomain'] = this.lookupDomain
    data['lookupOrder'] = this.lookupOrder
    data['forSummary'] = this.forSummary
    data['summaryColor'] = this.summaryColor
    return data
  }
}

export interface ICreateCompoundType {
  id?: string | undefined
  name?: string | undefined
  description?: string | undefined
  items?: CreateCompoundType_CompoundTypeItem[] | undefined
  basicData?: boolean
  caseTypeId?: string | undefined
  area?: string | undefined
  subarea?: number | undefined
  order?: number | undefined
  lookupDomain?: string | undefined
  lookupOrder?: number | undefined
  forSummary?: boolean
  summaryColor?: string | undefined
}

export class UpdateCompoundType_CompoundTypeItem
  implements IUpdateCompoundType_CompoundTypeItem {
  id?: string | undefined
  name?: string | undefined
  itemTypeId?: string | undefined
  itemType?: string | undefined
  order?: number
  system?: boolean
  forLookupUniqueness?: boolean
  forSummary?: boolean
  key?: string | undefined

  constructor(data?: IUpdateCompoundType_CompoundTypeItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.itemTypeId = _data['itemTypeId']
      this.itemType = _data['itemType']
      this.order = _data['order']
      this.system = _data['system']
      this.forLookupUniqueness = _data['forLookupUniqueness']
      this.forSummary = _data['forSummary']
      this.key = _data['key']
    }
  }

  static fromJS(data: any): UpdateCompoundType_CompoundTypeItem {
    data = typeof data === 'object' ? data : {}
    let result = new UpdateCompoundType_CompoundTypeItem()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['itemTypeId'] = this.itemTypeId
    data['itemType'] = this.itemType
    data['order'] = this.order
    data['system'] = this.system
    data['forLookupUniqueness'] = this.forLookupUniqueness
    data['forSummary'] = this.forSummary
    data['key'] = this.key
    return data
  }
}

export interface IUpdateCompoundType_CompoundTypeItem {
  id?: string | undefined
  name?: string | undefined
  itemTypeId?: string | undefined
  itemType?: string | undefined
  order?: number
  system?: boolean
  forLookupUniqueness?: boolean
  forSummary?: boolean
  key?: string | undefined
}

export class UpdateCompoundType implements IUpdateCompoundType {
  name?: string | undefined
  description?: string | undefined
  items?: UpdateCompoundType_CompoundTypeItem[] | undefined
  area?: string | undefined
  subarea?: number | undefined
  order?: number | undefined
  lookupDomain?: string | undefined
  lookupOrder?: number | undefined
  forSummary?: boolean
  summaryColor?: string | undefined

  constructor(data?: IUpdateCompoundType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name']
      this.description = _data['description']
      if (Array.isArray(_data['items'])) {
        this.items = [] as any
        for (let item of _data['items'])
          this.items!.push(UpdateCompoundType_CompoundTypeItem.fromJS(item))
      }
      this.area = _data['area']
      this.subarea = _data['subarea']
      this.order = _data['order']
      this.lookupDomain = _data['lookupDomain']
      this.lookupOrder = _data['lookupOrder']
      this.forSummary = _data['forSummary']
      this.summaryColor = _data['summaryColor']
    }
  }

  static fromJS(data: any): UpdateCompoundType {
    data = typeof data === 'object' ? data : {}
    let result = new UpdateCompoundType()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['description'] = this.description
    if (Array.isArray(this.items)) {
      data['items'] = []
      for (let item of this.items) data['items'].push(item.toJSON())
    }
    data['area'] = this.area
    data['subarea'] = this.subarea
    data['order'] = this.order
    data['lookupDomain'] = this.lookupDomain
    data['lookupOrder'] = this.lookupOrder
    data['forSummary'] = this.forSummary
    data['summaryColor'] = this.summaryColor
    return data
  }
}

export interface IUpdateCompoundType {
  name?: string | undefined
  description?: string | undefined
  items?: UpdateCompoundType_CompoundTypeItem[] | undefined
  area?: string | undefined
  subarea?: number | undefined
  order?: number | undefined
  lookupDomain?: string | undefined
  lookupOrder?: number | undefined
  forSummary?: boolean
  summaryColor?: string | undefined
}

export enum DocumentNameSchemePartType {
  TEXT = 0,
  DATE = 1,
  LIST = 2
}

export class DocumentNameSchemePartDto implements IDocumentNameSchemePartDto {
  type?: DocumentNameSchemePartType
  name?: string | undefined
  suggestions?: string[] | undefined
  order?: number

  constructor(data?: IDocumentNameSchemePartDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type']
      this.name = _data['name']
      if (Array.isArray(_data['suggestions'])) {
        this.suggestions = [] as any
        for (let item of _data['suggestions']) this.suggestions!.push(item)
      }
      this.order = _data['order']
    }
  }

  static fromJS(data: any): DocumentNameSchemePartDto {
    data = typeof data === 'object' ? data : {}
    let result = new DocumentNameSchemePartDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['name'] = this.name
    if (Array.isArray(this.suggestions)) {
      data['suggestions'] = []
      for (let item of this.suggestions) data['suggestions'].push(item)
    }
    data['order'] = this.order
    return data
  }
}

export interface IDocumentNameSchemePartDto {
  type?: DocumentNameSchemePartType
  name?: string | undefined
  suggestions?: string[] | undefined
  order?: number
}

export class LockedCaseDocumentDto implements ILockedCaseDocumentDto {
  id?: string
  caseId?: string
  caseNo?: string | undefined
  caseName?: string | undefined
  checkedOutAt?: Date
  checkedOutBy?: string | undefined
  currentCombinedFilename?: string | undefined

  constructor(data?: ILockedCaseDocumentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.caseId = _data['caseId']
      this.caseNo = _data['caseNo']
      this.caseName = _data['caseName']
      this.checkedOutAt = _data['checkedOutAt']
        ? new Date(_data['checkedOutAt'].toString())
        : <any>undefined
      this.checkedOutBy = _data['checkedOutBy']
      this.currentCombinedFilename = _data['currentCombinedFilename']
    }
  }

  static fromJS(data: any): LockedCaseDocumentDto {
    data = typeof data === 'object' ? data : {}
    let result = new LockedCaseDocumentDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['caseId'] = this.caseId
    data['caseNo'] = this.caseNo
    data['caseName'] = this.caseName
    data['checkedOutAt'] = this.checkedOutAt
      ? this.checkedOutAt.toISOString()
      : <any>undefined
    data['checkedOutBy'] = this.checkedOutBy
    data['currentCombinedFilename'] = this.currentCombinedFilename
    return data
  }
}

export interface ILockedCaseDocumentDto {
  id?: string
  caseId?: string
  caseNo?: string | undefined
  caseName?: string | undefined
  checkedOutAt?: Date
  checkedOutBy?: string | undefined
  currentCombinedFilename?: string | undefined
}

export class PagedOfLockedCaseDocumentDto
  implements IPagedOfLockedCaseDocumentDto {
  readonly data?: LockedCaseDocumentDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfLockedCaseDocumentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(LockedCaseDocumentDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfLockedCaseDocumentDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfLockedCaseDocumentDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfLockedCaseDocumentDto {
  data?: LockedCaseDocumentDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class FileTemplateSpecification implements IFileTemplateSpecification {
  label?: string | undefined
  proposalNameParts?: DocumentNamePartDto[] | undefined

  constructor(data?: IFileTemplateSpecification) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.label = _data['label']
      if (Array.isArray(_data['proposalNameParts'])) {
        this.proposalNameParts = [] as any
        for (let item of _data['proposalNameParts'])
          this.proposalNameParts!.push(DocumentNamePartDto.fromJS(item))
      }
    }
  }

  static fromJS(data: any): FileTemplateSpecification {
    data = typeof data === 'object' ? data : {}
    let result = new FileTemplateSpecification()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['label'] = this.label
    if (Array.isArray(this.proposalNameParts)) {
      data['proposalNameParts'] = []
      for (let item of this.proposalNameParts)
        data['proposalNameParts'].push(item.toJSON())
    }
    return data
  }
}

export interface IFileTemplateSpecification {
  label?: string | undefined
  proposalNameParts?: DocumentNamePartDto[] | undefined
}

export class FileTemplateDto implements IFileTemplateDto {
  id?: string
  isBasicData?: boolean
  caseTypeId?: string | undefined
  filename?: string | undefined
  createdAt?: Date
  changedAt?: Date
  proposalNameParts?: DocumentNamePartDto[] | undefined

  constructor(data?: IFileTemplateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.isBasicData = _data['isBasicData']
      this.caseTypeId = _data['caseTypeId']
      this.filename = _data['filename']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.changedAt = _data['changedAt']
        ? new Date(_data['changedAt'].toString())
        : <any>undefined
      if (Array.isArray(_data['proposalNameParts'])) {
        this.proposalNameParts = [] as any
        for (let item of _data['proposalNameParts'])
          this.proposalNameParts!.push(DocumentNamePartDto.fromJS(item))
      }
    }
  }

  static fromJS(data: any): FileTemplateDto {
    data = typeof data === 'object' ? data : {}
    let result = new FileTemplateDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['isBasicData'] = this.isBasicData
    data['caseTypeId'] = this.caseTypeId
    data['filename'] = this.filename
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['changedAt'] = this.changedAt
      ? this.changedAt.toISOString()
      : <any>undefined
    if (Array.isArray(this.proposalNameParts)) {
      data['proposalNameParts'] = []
      for (let item of this.proposalNameParts)
        data['proposalNameParts'].push(item.toJSON())
    }
    return data
  }
}

export interface IFileTemplateDto {
  id?: string
  isBasicData?: boolean
  caseTypeId?: string | undefined
  filename?: string | undefined
  createdAt?: Date
  changedAt?: Date
  proposalNameParts?: DocumentNamePartDto[] | undefined
}

export class PagedOfFileTemplateDto implements IPagedOfFileTemplateDto {
  readonly data?: FileTemplateDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfFileTemplateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(FileTemplateDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfFileTemplateDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfFileTemplateDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfFileTemplateDto {
  data?: FileTemplateDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export enum InterviewUsage {
  General = 0,
  B2B = 1,
  B2C = 2
}

export class InterviewDto implements IInterviewDto {
  id?: string
  name?: string | undefined
  description?: string | undefined
  humanReadableId?: string | undefined
  url?: string | undefined
  usage?: InterviewUsage
  createdAt?: Date
  isPublished?: boolean
  isOnboarding?: boolean

  constructor(data?: IInterviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.description = _data['description']
      this.humanReadableId = _data['humanReadableId']
      this.url = _data['url']
      this.usage = _data['usage']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.isPublished = _data['isPublished']
      this.isOnboarding = _data['isOnboarding']
    }
  }

  static fromJS(data: any): InterviewDto {
    data = typeof data === 'object' ? data : {}
    let result = new InterviewDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['description'] = this.description
    data['humanReadableId'] = this.humanReadableId
    data['url'] = this.url
    data['usage'] = this.usage
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['isPublished'] = this.isPublished
    data['isOnboarding'] = this.isOnboarding
    return data
  }
}

export interface IInterviewDto {
  id?: string
  name?: string | undefined
  description?: string | undefined
  humanReadableId?: string | undefined
  url?: string | undefined
  usage?: InterviewUsage
  createdAt?: Date
  isPublished?: boolean
  isOnboarding?: boolean
}

export class PagedOfInterviewDto implements IPagedOfInterviewDto {
  readonly data?: InterviewDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfInterviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(InterviewDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfInterviewDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfInterviewDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfInterviewDto {
  data?: InterviewDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class InterviewDetailDto implements IInterviewDetailDto {
  id?: string
  name?: string | undefined
  description?: string | undefined
  humanReadableId?: string | undefined
  url?: string | undefined
  usage?: InterviewUsage
  createdAt?: Date
  data?: string | undefined
  isPublished?: boolean
  isOnboarding?: boolean

  constructor(data?: IInterviewDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.description = _data['description']
      this.humanReadableId = _data['humanReadableId']
      this.url = _data['url']
      this.usage = _data['usage']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.data = _data['data']
      this.isPublished = _data['isPublished']
      this.isOnboarding = _data['isOnboarding']
    }
  }

  static fromJS(data: any): InterviewDetailDto {
    data = typeof data === 'object' ? data : {}
    let result = new InterviewDetailDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['description'] = this.description
    data['humanReadableId'] = this.humanReadableId
    data['url'] = this.url
    data['usage'] = this.usage
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['data'] = this.data
    data['isPublished'] = this.isPublished
    data['isOnboarding'] = this.isOnboarding
    return data
  }
}

export interface IInterviewDetailDto {
  id?: string
  name?: string | undefined
  description?: string | undefined
  humanReadableId?: string | undefined
  url?: string | undefined
  usage?: InterviewUsage
  createdAt?: Date
  data?: string | undefined
  isPublished?: boolean
  isOnboarding?: boolean
}

export class MinimalInterviewDto implements IMinimalInterviewDto {
  slugName?: string | undefined
  name?: string | undefined
  usage?: InterviewUsage

  constructor(data?: IMinimalInterviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.slugName = _data['slugName']
      this.name = _data['name']
      this.usage = _data['usage']
    }
  }

  static fromJS(data: any): MinimalInterviewDto {
    data = typeof data === 'object' ? data : {}
    let result = new MinimalInterviewDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['slugName'] = this.slugName
    data['name'] = this.name
    data['usage'] = this.usage
    return data
  }
}

export interface IMinimalInterviewDto {
  slugName?: string | undefined
  name?: string | undefined
  usage?: InterviewUsage
}

export class PagedOfMinimalInterviewDto implements IPagedOfMinimalInterviewDto {
  readonly data?: MinimalInterviewDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfMinimalInterviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(MinimalInterviewDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfMinimalInterviewDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfMinimalInterviewDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfMinimalInterviewDto {
  data?: MinimalInterviewDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class LoginLogEntryDto implements ILoginLogEntryDto {
  id?: string
  tenantId?: string
  userId?: string
  userName?: string | undefined
  ipAddress?: string | undefined
  createdAt?: Date

  constructor(data?: ILoginLogEntryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.tenantId = _data['tenantId']
      this.userId = _data['userId']
      this.userName = _data['userName']
      this.ipAddress = _data['ipAddress']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): LoginLogEntryDto {
    data = typeof data === 'object' ? data : {}
    let result = new LoginLogEntryDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['tenantId'] = this.tenantId
    data['userId'] = this.userId
    data['userName'] = this.userName
    data['ipAddress'] = this.ipAddress
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    return data
  }
}

export interface ILoginLogEntryDto {
  id?: string
  tenantId?: string
  userId?: string
  userName?: string | undefined
  ipAddress?: string | undefined
  createdAt?: Date
}

export class PagedOfLoginLogEntryDto implements IPagedOfLoginLogEntryDto {
  readonly data?: LoginLogEntryDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfLoginLogEntryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(LoginLogEntryDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfLoginLogEntryDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfLoginLogEntryDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfLoginLogEntryDto {
  data?: LoginLogEntryDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class LookupEntryDto implements ILookupEntryDto {
  id?: string
  lookupId?: string
  lookupDomain?: string | undefined
  jsonValues?: string | undefined
  jsonSchema?: string | undefined
  lookupSchemaVersion?: number
  createdAt?: Date
  createdBy?: string
  modifiedAt?: Date | undefined
  modifiedBy?: string | undefined

  constructor(data?: ILookupEntryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.lookupId = _data['lookupId']
      this.lookupDomain = _data['lookupDomain']
      this.jsonValues = _data['jsonValues']
      this.jsonSchema = _data['jsonSchema']
      this.lookupSchemaVersion = _data['lookupSchemaVersion']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.createdBy = _data['createdBy']
      this.modifiedAt = _data['modifiedAt']
        ? new Date(_data['modifiedAt'].toString())
        : <any>undefined
      this.modifiedBy = _data['modifiedBy']
    }
  }

  static fromJS(data: any): LookupEntryDto {
    data = typeof data === 'object' ? data : {}
    let result = new LookupEntryDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['lookupId'] = this.lookupId
    data['lookupDomain'] = this.lookupDomain
    data['jsonValues'] = this.jsonValues
    data['jsonSchema'] = this.jsonSchema
    data['lookupSchemaVersion'] = this.lookupSchemaVersion
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['createdBy'] = this.createdBy
    data['modifiedAt'] = this.modifiedAt
      ? this.modifiedAt.toISOString()
      : <any>undefined
    data['modifiedBy'] = this.modifiedBy
    return data
  }
}

export interface ILookupEntryDto {
  id?: string
  lookupId?: string
  lookupDomain?: string | undefined
  jsonValues?: string | undefined
  jsonSchema?: string | undefined
  lookupSchemaVersion?: number
  createdAt?: Date
  createdBy?: string
  modifiedAt?: Date | undefined
  modifiedBy?: string | undefined
}

export class PagedOfLookupEntryDto implements IPagedOfLookupEntryDto {
  readonly data?: LookupEntryDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfLookupEntryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(LookupEntryDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfLookupEntryDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfLookupEntryDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfLookupEntryDto {
  data?: LookupEntryDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class FilteredAndSortedLookupEntryRequest
  implements IFilteredAndSortedLookupEntryRequest {
  searchConditions?: SearchCondition[] | undefined
  sortFields?: SortField[] | undefined
  page?: number
  pageSize?: number
  lookupId?: string | undefined

  constructor(data?: IFilteredAndSortedLookupEntryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['searchConditions'])) {
        this.searchConditions = [] as any
        for (let item of _data['searchConditions'])
          this.searchConditions!.push(SearchCondition.fromJS(item))
      }
      if (Array.isArray(_data['sortFields'])) {
        this.sortFields = [] as any
        for (let item of _data['sortFields'])
          this.sortFields!.push(SortField.fromJS(item))
      }
      this.page = _data['page']
      this.pageSize = _data['pageSize']
      this.lookupId = _data['lookupId']
    }
  }

  static fromJS(data: any): FilteredAndSortedLookupEntryRequest {
    data = typeof data === 'object' ? data : {}
    let result = new FilteredAndSortedLookupEntryRequest()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.searchConditions)) {
      data['searchConditions'] = []
      for (let item of this.searchConditions)
        data['searchConditions'].push(item.toJSON())
    }
    if (Array.isArray(this.sortFields)) {
      data['sortFields'] = []
      for (let item of this.sortFields) data['sortFields'].push(item.toJSON())
    }
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    data['lookupId'] = this.lookupId
    return data
  }
}

export interface IFilteredAndSortedLookupEntryRequest {
  searchConditions?: SearchCondition[] | undefined
  sortFields?: SortField[] | undefined
  page?: number
  pageSize?: number
  lookupId?: string | undefined
}

export class FilteredAndSortedLookupEntry
  implements IFilteredAndSortedLookupEntry {
  id?: string
  lookupId?: string
  lookupDomain?: string | undefined
  jsonValues?: string | undefined
  createdAt?: Date
  createdBy?: string
  modifiedAt?: Date | undefined
  modifiedBy?: string | undefined
  createdByName?: string | undefined
  modifiedByName?: string | undefined

  constructor(data?: IFilteredAndSortedLookupEntry) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.lookupId = _data['lookupId']
      this.lookupDomain = _data['lookupDomain']
      this.jsonValues = _data['jsonValues']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.createdBy = _data['createdBy']
      this.modifiedAt = _data['modifiedAt']
        ? new Date(_data['modifiedAt'].toString())
        : <any>undefined
      this.modifiedBy = _data['modifiedBy']
      this.createdByName = _data['createdByName']
      this.modifiedByName = _data['modifiedByName']
    }
  }

  static fromJS(data: any): FilteredAndSortedLookupEntry {
    data = typeof data === 'object' ? data : {}
    let result = new FilteredAndSortedLookupEntry()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['lookupId'] = this.lookupId
    data['lookupDomain'] = this.lookupDomain
    data['jsonValues'] = this.jsonValues
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['createdBy'] = this.createdBy
    data['modifiedAt'] = this.modifiedAt
      ? this.modifiedAt.toISOString()
      : <any>undefined
    data['modifiedBy'] = this.modifiedBy
    data['createdByName'] = this.createdByName
    data['modifiedByName'] = this.modifiedByName
    return data
  }
}

export interface IFilteredAndSortedLookupEntry {
  id?: string
  lookupId?: string
  lookupDomain?: string | undefined
  jsonValues?: string | undefined
  createdAt?: Date
  createdBy?: string
  modifiedAt?: Date | undefined
  modifiedBy?: string | undefined
  createdByName?: string | undefined
  modifiedByName?: string | undefined
}

export class PagedOfFilteredAndSortedLookupEntry
  implements IPagedOfFilteredAndSortedLookupEntry {
  readonly data?: FilteredAndSortedLookupEntry[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfFilteredAndSortedLookupEntry) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(FilteredAndSortedLookupEntry.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfFilteredAndSortedLookupEntry {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfFilteredAndSortedLookupEntry()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfFilteredAndSortedLookupEntry {
  data?: FilteredAndSortedLookupEntry[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class LookupDto implements ILookupDto {
  id?: string
  lookupDomain?: string | undefined
  jsonSchema?: string | undefined
  jsonSchemaVersion?: number
  createdAt?: Date
  modifiedAt?: Date | undefined

  constructor(data?: ILookupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.lookupDomain = _data['lookupDomain']
      this.jsonSchema = _data['jsonSchema']
      this.jsonSchemaVersion = _data['jsonSchemaVersion']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.modifiedAt = _data['modifiedAt']
        ? new Date(_data['modifiedAt'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): LookupDto {
    data = typeof data === 'object' ? data : {}
    let result = new LookupDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['lookupDomain'] = this.lookupDomain
    data['jsonSchema'] = this.jsonSchema
    data['jsonSchemaVersion'] = this.jsonSchemaVersion
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['modifiedAt'] = this.modifiedAt
      ? this.modifiedAt.toISOString()
      : <any>undefined
    return data
  }
}

export interface ILookupDto {
  id?: string
  lookupDomain?: string | undefined
  jsonSchema?: string | undefined
  jsonSchemaVersion?: number
  createdAt?: Date
  modifiedAt?: Date | undefined
}

export class PagedOfLookupDto implements IPagedOfLookupDto {
  readonly data?: LookupDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfLookupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(LookupDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfLookupDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfLookupDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfLookupDto {
  data?: LookupDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class LookupDomainInfoDto implements ILookupDomainInfoDto {
  lookupId?: string
  lookupDomain?: string | undefined

  constructor(data?: ILookupDomainInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lookupId = _data['lookupId']
      this.lookupDomain = _data['lookupDomain']
    }
  }

  static fromJS(data: any): LookupDomainInfoDto {
    data = typeof data === 'object' ? data : {}
    let result = new LookupDomainInfoDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['lookupId'] = this.lookupId
    data['lookupDomain'] = this.lookupDomain
    return data
  }
}

export interface ILookupDomainInfoDto {
  lookupId?: string
  lookupDomain?: string | undefined
}

export class PermissionDto implements IPermissionDto {
  readonly internalName?: string
  readonly name?: string
  readonly description?: string

  constructor(data?: IPermissionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).internalName = _data['internalName']
      ;(<any>this).name = _data['name']
      ;(<any>this).description = _data['description']
    }
  }

  static fromJS(data: any): PermissionDto {
    data = typeof data === 'object' ? data : {}
    let result = new PermissionDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['internalName'] = this.internalName
    data['name'] = this.name
    data['description'] = this.description
    return data
  }
}

export interface IPermissionDto {
  internalName?: string
  name?: string
  description?: string
}

export class RoleDto implements IRoleDto {
  id?: string
  name?: string | undefined
  permissions?: string[] | undefined

  constructor(data?: IRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any
        for (let item of _data['permissions']) this.permissions!.push(item)
      }
    }
  }

  static fromJS(data: any): RoleDto {
    data = typeof data === 'object' ? data : {}
    let result = new RoleDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    if (Array.isArray(this.permissions)) {
      data['permissions'] = []
      for (let item of this.permissions) data['permissions'].push(item)
    }
    return data
  }
}

export interface IRoleDto {
  id?: string
  name?: string | undefined
  permissions?: string[] | undefined
}

export class PagedOfRoleDto implements IPagedOfRoleDto {
  readonly data?: RoleDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(RoleDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfRoleDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfRoleDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfRoleDto {
  data?: RoleDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class CreateOrUpdateRole_PermissionSetting
  implements ICreateOrUpdateRole_PermissionSetting {
  permissionValue!: string
  active?: boolean

  constructor(data?: ICreateOrUpdateRole_PermissionSetting) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.permissionValue = _data['permissionValue']
      this.active = _data['active']
    }
  }

  static fromJS(data: any): CreateOrUpdateRole_PermissionSetting {
    data = typeof data === 'object' ? data : {}
    let result = new CreateOrUpdateRole_PermissionSetting()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['permissionValue'] = this.permissionValue
    data['active'] = this.active
    return data
  }
}

export interface ICreateOrUpdateRole_PermissionSetting {
  permissionValue: string
  active?: boolean
}

export class CreateOrUpdateRole implements ICreateOrUpdateRole {
  name!: string
  permissions!: CreateOrUpdateRole_PermissionSetting[]

  constructor(data?: ICreateOrUpdateRole) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
    if (!data) {
      this.permissions = []
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name']
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any
        for (let item of _data['permissions'])
          this.permissions!.push(
            CreateOrUpdateRole_PermissionSetting.fromJS(item)
          )
      }
    }
  }

  static fromJS(data: any): CreateOrUpdateRole {
    data = typeof data === 'object' ? data : {}
    let result = new CreateOrUpdateRole()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    if (Array.isArray(this.permissions)) {
      data['permissions'] = []
      for (let item of this.permissions) data['permissions'].push(item.toJSON())
    }
    return data
  }
}

export interface ICreateOrUpdateRole {
  name: string
  permissions: CreateOrUpdateRole_PermissionSetting[]
}

export class PropertyOptionsDto implements IPropertyOptionsDto {
  format?: string | undefined
  unit?: string | undefined
  multiple?: boolean
  entries?: string[] | undefined
  script?: string | undefined

  constructor(data?: IPropertyOptionsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.format = _data['format']
      this.unit = _data['unit']
      this.multiple = _data['multiple']
      if (Array.isArray(_data['entries'])) {
        this.entries = [] as any
        for (let item of _data['entries']) this.entries!.push(item)
      }
      this.script = _data['script']
    }
  }

  static fromJS(data: any): PropertyOptionsDto {
    data = typeof data === 'object' ? data : {}
    let result = new PropertyOptionsDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['format'] = this.format
    data['unit'] = this.unit
    data['multiple'] = this.multiple
    if (Array.isArray(this.entries)) {
      data['entries'] = []
      for (let item of this.entries) data['entries'].push(item)
    }
    data['script'] = this.script
    return data
  }
}

export interface IPropertyOptionsDto {
  format?: string | undefined
  unit?: string | undefined
  multiple?: boolean
  entries?: string[] | undefined
  script?: string | undefined
}

export class ValidationOptionsDto implements IValidationOptionsDto {
  min?: number | undefined
  max?: number | undefined
  pattern?: string | undefined
  url?: string | undefined

  constructor(data?: IValidationOptionsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.min = _data['min']
      this.max = _data['max']
      this.pattern = _data['pattern']
      this.url = _data['url']
    }
  }

  static fromJS(data: any): ValidationOptionsDto {
    data = typeof data === 'object' ? data : {}
    let result = new ValidationOptionsDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['min'] = this.min
    data['max'] = this.max
    data['pattern'] = this.pattern
    data['url'] = this.url
    return data
  }
}

export interface IValidationOptionsDto {
  min?: number | undefined
  max?: number | undefined
  pattern?: string | undefined
  url?: string | undefined
}

export class SimpleTypeDto implements ISimpleTypeDto {
  id?: string | undefined
  name?: string | undefined
  type?: PrimitiveType
  description?: string | undefined
  propertyOptions?: PropertyOptionsDto
  validationOptions?: ValidationOptionsDto
  system?: boolean
  key?: string | undefined

  constructor(data?: ISimpleTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.type = _data['type']
      this.description = _data['description']
      this.propertyOptions = _data['propertyOptions']
        ? PropertyOptionsDto.fromJS(_data['propertyOptions'])
        : <any>undefined
      this.validationOptions = _data['validationOptions']
        ? ValidationOptionsDto.fromJS(_data['validationOptions'])
        : <any>undefined
      this.system = _data['system']
      this.key = _data['key']
    }
  }

  static fromJS(data: any): SimpleTypeDto {
    data = typeof data === 'object' ? data : {}
    let result = new SimpleTypeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['type'] = this.type
    data['description'] = this.description
    data['propertyOptions'] = this.propertyOptions
      ? this.propertyOptions.toJSON()
      : <any>undefined
    data['validationOptions'] = this.validationOptions
      ? this.validationOptions.toJSON()
      : <any>undefined
    data['system'] = this.system
    data['key'] = this.key
    return data
  }
}

export interface ISimpleTypeDto {
  id?: string | undefined
  name?: string | undefined
  type?: PrimitiveType
  description?: string | undefined
  propertyOptions?: PropertyOptionsDto
  validationOptions?: ValidationOptionsDto
  system?: boolean
  key?: string | undefined
}

export class PagedOfSimpleTypeDto implements IPagedOfSimpleTypeDto {
  readonly data?: SimpleTypeDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfSimpleTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(SimpleTypeDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfSimpleTypeDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfSimpleTypeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfSimpleTypeDto {
  data?: SimpleTypeDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class CommandPropertyOptions implements ICommandPropertyOptions {
  format?: string | undefined
  unit?: string | undefined
  multiple?: boolean
  entries?: string[] | undefined
  script?: string | undefined

  constructor(data?: ICommandPropertyOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.format = _data['format']
      this.unit = _data['unit']
      this.multiple = _data['multiple']
      if (Array.isArray(_data['entries'])) {
        this.entries = [] as any
        for (let item of _data['entries']) this.entries!.push(item)
      }
      this.script = _data['script']
    }
  }

  static fromJS(data: any): CommandPropertyOptions {
    data = typeof data === 'object' ? data : {}
    let result = new CommandPropertyOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['format'] = this.format
    data['unit'] = this.unit
    data['multiple'] = this.multiple
    if (Array.isArray(this.entries)) {
      data['entries'] = []
      for (let item of this.entries) data['entries'].push(item)
    }
    data['script'] = this.script
    return data
  }
}

export interface ICommandPropertyOptions {
  format?: string | undefined
  unit?: string | undefined
  multiple?: boolean
  entries?: string[] | undefined
  script?: string | undefined
}

export class CommandValidationOptions implements ICommandValidationOptions {
  min?: number | undefined
  max?: number | undefined
  pattern?: string | undefined
  url?: string | undefined

  constructor(data?: ICommandValidationOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.min = _data['min']
      this.max = _data['max']
      this.pattern = _data['pattern']
      this.url = _data['url']
    }
  }

  static fromJS(data: any): CommandValidationOptions {
    data = typeof data === 'object' ? data : {}
    let result = new CommandValidationOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['min'] = this.min
    data['max'] = this.max
    data['pattern'] = this.pattern
    data['url'] = this.url
    return data
  }
}

export interface ICommandValidationOptions {
  min?: number | undefined
  max?: number | undefined
  pattern?: string | undefined
  url?: string | undefined
}

export class CreateSimpleType implements ICreateSimpleType {
  id?: string | undefined
  name?: string | undefined
  description?: string | undefined
  propertyOptions?: CommandPropertyOptions
  validationOptions?: CommandValidationOptions
  type?: PrimitiveType

  constructor(data?: ICreateSimpleType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.description = _data['description']
      this.propertyOptions = _data['propertyOptions']
        ? CommandPropertyOptions.fromJS(_data['propertyOptions'])
        : <any>undefined
      this.validationOptions = _data['validationOptions']
        ? CommandValidationOptions.fromJS(_data['validationOptions'])
        : <any>undefined
      this.type = _data['type']
    }
  }

  static fromJS(data: any): CreateSimpleType {
    data = typeof data === 'object' ? data : {}
    let result = new CreateSimpleType()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['description'] = this.description
    data['propertyOptions'] = this.propertyOptions
      ? this.propertyOptions.toJSON()
      : <any>undefined
    data['validationOptions'] = this.validationOptions
      ? this.validationOptions.toJSON()
      : <any>undefined
    data['type'] = this.type
    return data
  }
}

export interface ICreateSimpleType {
  id?: string | undefined
  name?: string | undefined
  description?: string | undefined
  propertyOptions?: CommandPropertyOptions
  validationOptions?: CommandValidationOptions
  type?: PrimitiveType
}

export class UpdateSimpleType implements IUpdateSimpleType {
  name?: string | undefined
  description?: string | undefined
  propertyOptions?: CommandPropertyOptions
  validationOptions?: CommandValidationOptions
  type?: PrimitiveType

  constructor(data?: IUpdateSimpleType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name']
      this.description = _data['description']
      this.propertyOptions = _data['propertyOptions']
        ? CommandPropertyOptions.fromJS(_data['propertyOptions'])
        : <any>undefined
      this.validationOptions = _data['validationOptions']
        ? CommandValidationOptions.fromJS(_data['validationOptions'])
        : <any>undefined
      this.type = _data['type']
    }
  }

  static fromJS(data: any): UpdateSimpleType {
    data = typeof data === 'object' ? data : {}
    let result = new UpdateSimpleType()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['description'] = this.description
    data['propertyOptions'] = this.propertyOptions
      ? this.propertyOptions.toJSON()
      : <any>undefined
    data['validationOptions'] = this.validationOptions
      ? this.validationOptions.toJSON()
      : <any>undefined
    data['type'] = this.type
    return data
  }
}

export interface IUpdateSimpleType {
  name?: string | undefined
  description?: string | undefined
  propertyOptions?: CommandPropertyOptions
  validationOptions?: CommandValidationOptions
  type?: PrimitiveType
}

export class TestScriptCommand implements ITestScriptCommand {
  script?: string | undefined
  testParameter?: { [key: string]: string } | undefined

  constructor(data?: ITestScriptCommand) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.script = _data['script']
      if (_data['testParameter']) {
        this.testParameter = {} as any
        for (let key in _data['testParameter']) {
          if (_data['testParameter'].hasOwnProperty(key))
            (<any>this.testParameter)![key] = _data['testParameter'][key]
        }
      }
    }
  }

  static fromJS(data: any): TestScriptCommand {
    data = typeof data === 'object' ? data : {}
    let result = new TestScriptCommand()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['script'] = this.script
    if (this.testParameter) {
      data['testParameter'] = {}
      for (let key in this.testParameter) {
        if (this.testParameter.hasOwnProperty(key))
          (<any>data['testParameter'])[key] = this.testParameter[key]
      }
    }
    return data
  }
}

export interface ITestScriptCommand {
  script?: string | undefined
  testParameter?: { [key: string]: string } | undefined
}

export class TenantDto implements ITenantDto {
  id?: string
  name?: string | undefined
  shortName?: string | undefined
  sessionTimeout?: number

  constructor(data?: ITenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.shortName = _data['shortName']
      this.sessionTimeout = _data['sessionTimeout']
    }
  }

  static fromJS(data: any): TenantDto {
    data = typeof data === 'object' ? data : {}
    let result = new TenantDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['shortName'] = this.shortName
    data['sessionTimeout'] = this.sessionTimeout
    return data
  }
}

export interface ITenantDto {
  id?: string
  name?: string | undefined
  shortName?: string | undefined
  sessionTimeout?: number
}

export class PagedOfTenantDto implements IPagedOfTenantDto {
  readonly data?: TenantDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfTenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(TenantDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfTenantDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfTenantDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfTenantDto {
  data?: TenantDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class UserDto implements IUserDto {
  id?: string
  tenantId?: string
  userName?: string | undefined
  twoFactorEnabled?: boolean
  email?: string | undefined
  roleId?: string | undefined
  roleName?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  deletedAt?: Date | undefined
  userSettings?: string | undefined
  userData?: string | undefined
  profilePicture?: string | undefined

  constructor(data?: IUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.tenantId = _data['tenantId']
      this.userName = _data['userName']
      this.twoFactorEnabled = _data['twoFactorEnabled']
      this.email = _data['email']
      this.roleId = _data['roleId']
      this.roleName = _data['roleName']
      this.firstName = _data['firstName']
      this.lastName = _data['lastName']
      this.deletedAt = _data['deletedAt']
        ? new Date(_data['deletedAt'].toString())
        : <any>undefined
      this.userSettings = _data['userSettings']
      this.userData = _data['userData']
      this.profilePicture = _data['profilePicture']
    }
  }

  static fromJS(data: any): UserDto {
    data = typeof data === 'object' ? data : {}
    let result = new UserDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['tenantId'] = this.tenantId
    data['userName'] = this.userName
    data['twoFactorEnabled'] = this.twoFactorEnabled
    data['email'] = this.email
    data['roleId'] = this.roleId
    data['roleName'] = this.roleName
    data['firstName'] = this.firstName
    data['lastName'] = this.lastName
    data['deletedAt'] = this.deletedAt
      ? this.deletedAt.toISOString()
      : <any>undefined
    data['userSettings'] = this.userSettings
    data['userData'] = this.userData
    data['profilePicture'] = this.profilePicture
    return data
  }
}

export interface IUserDto {
  id?: string
  tenantId?: string
  userName?: string | undefined
  twoFactorEnabled?: boolean
  email?: string | undefined
  roleId?: string | undefined
  roleName?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  deletedAt?: Date | undefined
  userSettings?: string | undefined
  userData?: string | undefined
  profilePicture?: string | undefined
}

export class PagedOfUserDto implements IPagedOfUserDto {
  readonly data?: UserDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(UserDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfUserDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfUserDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfUserDto {
  data?: UserDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class CreateUser implements ICreateUser {
  username?: string | undefined
  email?: string | undefined
  password?: string | undefined
  roleId?: string
  firstName?: string | undefined
  lastName?: string | undefined
  userSettings?: string | undefined
  userData?: string | undefined

  constructor(data?: ICreateUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.username = _data['username']
      this.email = _data['email']
      this.password = _data['password']
      this.roleId = _data['roleId']
      this.firstName = _data['firstName']
      this.lastName = _data['lastName']
      this.userSettings = _data['userSettings']
      this.userData = _data['userData']
    }
  }

  static fromJS(data: any): CreateUser {
    data = typeof data === 'object' ? data : {}
    let result = new CreateUser()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['username'] = this.username
    data['email'] = this.email
    data['password'] = this.password
    data['roleId'] = this.roleId
    data['firstName'] = this.firstName
    data['lastName'] = this.lastName
    data['userSettings'] = this.userSettings
    data['userData'] = this.userData
    return data
  }
}

export interface ICreateUser {
  username?: string | undefined
  email?: string | undefined
  password?: string | undefined
  roleId?: string
  firstName?: string | undefined
  lastName?: string | undefined
  userSettings?: string | undefined
  userData?: string | undefined
}

export class BasicUserDto implements IBasicUserDto {
  id?: string
  tenantId?: string
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
  userData?: string | undefined

  constructor(data?: IBasicUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.tenantId = _data['tenantId']
      this.firstName = _data['firstName']
      this.lastName = _data['lastName']
      this.email = _data['email']
      this.userData = _data['userData']
    }
  }

  static fromJS(data: any): BasicUserDto {
    data = typeof data === 'object' ? data : {}
    let result = new BasicUserDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['tenantId'] = this.tenantId
    data['firstName'] = this.firstName
    data['lastName'] = this.lastName
    data['email'] = this.email
    data['userData'] = this.userData
    return data
  }
}

export interface IBasicUserDto {
  id?: string
  tenantId?: string
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
  userData?: string | undefined
}

export class UpdateUser implements IUpdateUser {
  userName?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  roleId?: string | undefined
  userSettings?: string | undefined
  userData?: string | undefined

  constructor(data?: IUpdateUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data['userName']
      this.firstName = _data['firstName']
      this.lastName = _data['lastName']
      this.roleId = _data['roleId']
      this.userSettings = _data['userSettings']
      this.userData = _data['userData']
    }
  }

  static fromJS(data: any): UpdateUser {
    data = typeof data === 'object' ? data : {}
    let result = new UpdateUser()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['userName'] = this.userName
    data['firstName'] = this.firstName
    data['lastName'] = this.lastName
    data['roleId'] = this.roleId
    data['userSettings'] = this.userSettings
    data['userData'] = this.userData
    return data
  }
}

export interface IUpdateUser {
  userName?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  roleId?: string | undefined
  userSettings?: string | undefined
  userData?: string | undefined
}

export class AssignRoleToUser implements IAssignRoleToUser {
  roleId?: string

  constructor(data?: IAssignRoleToUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.roleId = _data['roleId']
    }
  }

  static fromJS(data: any): AssignRoleToUser {
    data = typeof data === 'object' ? data : {}
    let result = new AssignRoleToUser()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['roleId'] = this.roleId
    return data
  }
}

export interface IAssignRoleToUser {
  roleId?: string
}

export class ChangePassword implements IChangePassword {
  password?: string | undefined

  constructor(data?: IChangePassword) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.password = _data['password']
    }
  }

  static fromJS(data: any): ChangePassword {
    data = typeof data === 'object' ? data : {}
    let result = new ChangePassword()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['password'] = this.password
    return data
  }
}

export interface IChangePassword {
  password?: string | undefined
}

export class WorkflowDto implements IWorkflowDto {
  id?: string
  caseTypeId?: string | undefined
  name?: string | undefined
  executable?: boolean
  xml?: string | undefined
  createdAt?: Date
  modifiedAt?: Date | undefined
  deletedAt?: Date | undefined

  constructor(data?: IWorkflowDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.caseTypeId = _data['caseTypeId']
      this.name = _data['name']
      this.executable = _data['executable']
      this.xml = _data['xml']
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.modifiedAt = _data['modifiedAt']
        ? new Date(_data['modifiedAt'].toString())
        : <any>undefined
      this.deletedAt = _data['deletedAt']
        ? new Date(_data['deletedAt'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): WorkflowDto {
    data = typeof data === 'object' ? data : {}
    let result = new WorkflowDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['caseTypeId'] = this.caseTypeId
    data['name'] = this.name
    data['executable'] = this.executable
    data['xml'] = this.xml
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['modifiedAt'] = this.modifiedAt
      ? this.modifiedAt.toISOString()
      : <any>undefined
    data['deletedAt'] = this.deletedAt
      ? this.deletedAt.toISOString()
      : <any>undefined
    return data
  }
}

export interface IWorkflowDto {
  id?: string
  caseTypeId?: string | undefined
  name?: string | undefined
  executable?: boolean
  xml?: string | undefined
  createdAt?: Date
  modifiedAt?: Date | undefined
  deletedAt?: Date | undefined
}

export class PagedOfWorkflowDto implements IPagedOfWorkflowDto {
  readonly data?: WorkflowDto[]
  readonly totalCount?: number
  readonly page?: number
  readonly pageSize?: number

  constructor(data?: IPagedOfWorkflowDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        ;(<any>this).data = [] as any
        for (let item of _data['data'])
          (<any>this).data!.push(WorkflowDto.fromJS(item))
      }
      ;(<any>this).totalCount = _data['totalCount']
      ;(<any>this).page = _data['page']
      ;(<any>this).pageSize = _data['pageSize']
    }
  }

  static fromJS(data: any): PagedOfWorkflowDto {
    data = typeof data === 'object' ? data : {}
    let result = new PagedOfWorkflowDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    data['totalCount'] = this.totalCount
    data['page'] = this.page
    data['pageSize'] = this.pageSize
    return data
  }
}

export interface IPagedOfWorkflowDto {
  data?: WorkflowDto[]
  totalCount?: number
  page?: number
  pageSize?: number
}

export class WorkflowTaskDto implements IWorkflowTaskDto {
  transitionId?: string
  type?: string | undefined
  name?: string | undefined
  description?: string | undefined
  priority?: CaseWorkflowStepPriority
  costs?: number
  tariffType?: string | undefined
  activityUnit?: string | undefined
  workflowXml?: string | undefined
  parentDiagramReference?: string | undefined
  diagramReference?: string | undefined
  userId?: string | undefined
  roleId?: string | undefined
  caseJsonValues?: string | undefined
  stepJsonDefinition?: string | undefined
  stepJsonOutcomes?: string | undefined
  transitionJsonValues?: string | undefined
  escalationAt?: Date | undefined
  createdAt?: Date
  caseId?: string
  escalatedUserId?: string | undefined
  escalationType?: EscalationType
  decisionType?: DecisionType
  escalationUserId?: string | undefined
  escalationDate?: Date | undefined
  escalationDurationDays?: number | undefined
  escalationDurationHours?: number | undefined
  transitionUserId?: string | undefined
  comment?: string | undefined
  followUpAt?: Date | undefined
  autoEscalateOnFollowUp?: boolean

  constructor(data?: IWorkflowTaskDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transitionId = _data['transitionId']
      this.type = _data['type']
      this.name = _data['name']
      this.description = _data['description']
      this.priority = _data['priority']
      this.costs = _data['costs']
      this.tariffType = _data['tariffType']
      this.activityUnit = _data['activityUnit']
      this.workflowXml = _data['workflowXml']
      this.parentDiagramReference = _data['parentDiagramReference']
      this.diagramReference = _data['diagramReference']
      this.userId = _data['userId']
      this.roleId = _data['roleId']
      this.caseJsonValues = _data['caseJsonValues']
      this.stepJsonDefinition = _data['stepJsonDefinition']
      this.stepJsonOutcomes = _data['stepJsonOutcomes']
      this.transitionJsonValues = _data['transitionJsonValues']
      this.escalationAt = _data['escalationAt']
        ? new Date(_data['escalationAt'].toString())
        : <any>undefined
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined
      this.caseId = _data['caseId']
      this.escalatedUserId = _data['escalatedUserId']
      this.escalationType = _data['escalationType']
      this.decisionType = _data['decisionType']
      this.escalationUserId = _data['escalationUserId']
      this.escalationDate = _data['escalationDate']
        ? new Date(_data['escalationDate'].toString())
        : <any>undefined
      this.escalationDurationDays = _data['escalationDurationDays']
      this.escalationDurationHours = _data['escalationDurationHours']
      this.transitionUserId = _data['transitionUserId']
      this.comment = _data['comment']
      this.followUpAt = _data['followUpAt']
        ? new Date(_data['followUpAt'].toString())
        : <any>undefined
      this.autoEscalateOnFollowUp = _data['autoEscalateOnFollowUp']
    }
  }

  static fromJS(data: any): WorkflowTaskDto {
    data = typeof data === 'object' ? data : {}
    let result = new WorkflowTaskDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['transitionId'] = this.transitionId
    data['type'] = this.type
    data['name'] = this.name
    data['description'] = this.description
    data['priority'] = this.priority
    data['costs'] = this.costs
    data['tariffType'] = this.tariffType
    data['activityUnit'] = this.activityUnit
    data['workflowXml'] = this.workflowXml
    data['parentDiagramReference'] = this.parentDiagramReference
    data['diagramReference'] = this.diagramReference
    data['userId'] = this.userId
    data['roleId'] = this.roleId
    data['caseJsonValues'] = this.caseJsonValues
    data['stepJsonDefinition'] = this.stepJsonDefinition
    data['stepJsonOutcomes'] = this.stepJsonOutcomes
    data['transitionJsonValues'] = this.transitionJsonValues
    data['escalationAt'] = this.escalationAt
      ? this.escalationAt.toISOString()
      : <any>undefined
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined
    data['caseId'] = this.caseId
    data['escalatedUserId'] = this.escalatedUserId
    data['escalationType'] = this.escalationType
    data['decisionType'] = this.decisionType
    data['escalationUserId'] = this.escalationUserId
    data['escalationDate'] = this.escalationDate
      ? this.escalationDate.toISOString()
      : <any>undefined
    data['escalationDurationDays'] = this.escalationDurationDays
    data['escalationDurationHours'] = this.escalationDurationHours
    data['transitionUserId'] = this.transitionUserId
    data['comment'] = this.comment
    data['followUpAt'] = this.followUpAt
      ? this.followUpAt.toISOString()
      : <any>undefined
    data['autoEscalateOnFollowUp'] = this.autoEscalateOnFollowUp
    return data
  }
}

export interface IWorkflowTaskDto {
  transitionId?: string
  type?: string | undefined
  name?: string | undefined
  description?: string | undefined
  priority?: CaseWorkflowStepPriority
  costs?: number
  tariffType?: string | undefined
  activityUnit?: string | undefined
  workflowXml?: string | undefined
  parentDiagramReference?: string | undefined
  diagramReference?: string | undefined
  userId?: string | undefined
  roleId?: string | undefined
  caseJsonValues?: string | undefined
  stepJsonDefinition?: string | undefined
  stepJsonOutcomes?: string | undefined
  transitionJsonValues?: string | undefined
  escalationAt?: Date | undefined
  createdAt?: Date
  caseId?: string
  escalatedUserId?: string | undefined
  escalationType?: EscalationType
  decisionType?: DecisionType
  escalationUserId?: string | undefined
  escalationDate?: Date | undefined
  escalationDurationDays?: number | undefined
  escalationDurationHours?: number | undefined
  transitionUserId?: string | undefined
  comment?: string | undefined
  followUpAt?: Date | undefined
  autoEscalateOnFollowUp?: boolean
}

export interface FileParameter {
  data: any
  fileName: string
}

export interface FileResponse {
  data: Blob
  status: number
  fileName?: string
  headers?: { [name: string]: any }
}

export class ApiException extends Error {
  message: string
  status: number
  response: string
  headers: { [key: string]: any }
  result: any

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super()

    this.message = message
    this.status = status
    this.response = response
    this.headers = headers
    this.result = result
  }

  protected isApiException = true

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result
  else throw new ApiException(message, status, response, headers, null)
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true
}
